export const en = {
    app: {
      home: 'Home',
      playerScout: "Player Scout",
      playerComparison: "Player Comparison",
      playerRecruitment: 'Radar',
      collections: "Collections",
      favoritePlayers: 'Favorite Players',
      teamAnalytics: 'Team Analytics',
      gameAnalysis: 'Game Analysis',
      seasonStats: 'Season Stats',
      leagueTable: 'League Table',
      scoresAndFixtures: 'Scores & Fixtures',
      notifications: 'Notifications',
      administration: 'Administration',
      inbox: "Inbox",
      teamStats: "Team Stats",
      blog:"Blog",
      leagues:"Leagues",
      squadBuilder: "Squad Builder",
      playerAlerts:"Player Alerts",
      searchAlerts:"Search Alerts",
      videoUploadTool:"Video Upload Tool",
      videoPlaylists: "Playlists",
      uploadedGames:"Uploaded games",
      favoriteTeams:"Favorite Teams"
    },
    playerRecruitment: {
      title: "Player Sheet",
      subtitle: "Go deeper into the player's characteristics and statistics",
      league: 'League',
      selectedSeason: "Selected Season",
      year: 'Year',
      radar: 'Radar',
      positions: 'Positions',
      numberOfPlayers: 'Number of players',
      template: "Template",
      compareWith: "Compare with",
      previousPerformance: "Previous Performance",
      xGames: "{0} games",
      average: "Average",
      leagueAverage: "League Average",
      positionsPlayed: "Positions Played",
      minMax: "Min & Max",
      top5Leagues: "Top 5 Leagues",
      infoMessage: "Check just one season to enable Season Min & Max",
      infoMessage2: "Select the same season for both players",
      dataPer90MinText: "Data per 90 minutes",
      adjustToPossessionText: "* Adjusted to possession",
      text: "Text",
      lollipop: "Lollipop",
      polar: 'Polar',
      radarTemplates: {
        Goalkeeper: "Goalkeeper",
        GoalkeeperCustom: "Goalkeeper Custom",
        GoalkeeperCustom1: "Goalkeeper Custom 1",
        GoalkeeperCustom2: "Goalkeeper Custom 2",
        GoalkeeperCustom3: "Goalkeeper Custom 3",
        GoalkeeperCustom4: "Goalkeeper Custom 4",
        GoalkeeperCustom5: "Goalkeeper Custom 5",
        GoalkeeperCustom6: "Goalkeeper Custom 6",
        Defender: "Defender",
        DefenderCustom: "Defender Custom",
        DefenderCustom1: "Defender Custom 1",
        DefenderCustom2: "Defender Custom 2",
        DefenderCustom3: "Defender Custom 3",
        DefenderCustom4: "Defender Custom 4",
        DefenderCustom5: "Defender Custom 5",
        DefenderCustom6: "Defender Custom 6",
        FullBack: "FullBack",
        FullBackCustom: "FullBack Custom",
        FullBackCustom1: "FullBack Custom 1",
        FullBackCustom2: "FullBack Custom 2",
        FullBackCustom3: "FullBack Custom 3",
        FullBackCustom4: "FullBack Custom 4",
        FullBackCustom5: "FullBack Custom 5",
        FullBackCustom6: "FullBack Custom 6",
        FullBackPredictive: "FullBack",
        Midfielder: "Midfielder",
        MidfielderCustom: "Midfielder Custom",
        MidfielderCustom1: "Midfielder Custom 1",
        MidfielderCustom2: "Midfielder Custom 2",
        MidfielderCustom3: "Midfielder Custom 3",
        MidfielderCustom4: "Midfielder Custom 4",
        MidfielderCustom5: "Midfielder Custom 5",
        MidfielderCustom6: "Midfielder Custom 6",
        MidfielderPredictive: "Midfielder",
        MidfielderDefensive: "Midfielder Defensive",
        MidfielderOffensive: "Midfielder Offensive",
        'AttackingMidfielder': "Attacking Midfielder",
        MidfielderWing: "Midfielder Wing",
        Winger: "Winger",
        WingerCustom: "Winger Custom",
        WingerCustom1: "Winger Custom 1",
        WingerCustom2: "Winger Custom 2",
        WingerCustom3: "Winger Custom 3",
        WingerCustom4: "Winger Custom 4",
        WingerCustom5: "Winger Custom 5",
        WingerCustom6: "Winger Custom 6",
        WingerOffensive: "Winger Offensive",
        Forward: "Forward",
        ForwardCustom: "Forward Custom",
        ForwardCustom1: "Forward Custom 1",
        ForwardCustom2: "Forward Custom 2",
        ForwardCustom3: "Forward Custom 3",
        ForwardCustom4: "Forward Custom 4",
        ForwardCustom5: "Forward Custom 5",
        ForwardCustom6: "Forward Custom 6",
        ForwardPredictive: "Forward",
        WingBack: "WingBack",
        WingBackCustom: "WingBack Custom",
        WingBackCustom1: "WingBack Custom 1",
        WingBackCustom2: "WingBack Custom 2",
        WingBackCustom3: "WingBack Custom 3",
        WingBackCustom4: "WingBack Custom 4",
        WingBackCustom5: "WingBack Custom 5",
        WingBackCustom6: "WingBack Custom 6",
        WingBackMedia: "WingBack (SocialMedia)",
        FullBackMedia: "FullBack (SocialMedia)",
        MidfielderMedia: "Midfielder (SocialMedia)",
        WingerMedia: "Winger (SocialMedia)",
        ForwardMedia: "Forward (SocialMedia)",
        PhysicalWingBack: "Physical WingBack",
        PhysicalForward: "Physical Forward",
        PhysicalWinger: "Physical Winger",
        PhysicalMidfielder: "Physical Midfielder",
        PhysicalFullBack: "Physical FullBack",
        PhysicalDefender: "Physical Defender",
        PhysicalWingBackLMO: "Physical WingBack",
        PhysicalForwardLMO: "Physical Forward",
        PhysicalWingerLMO: "Physical Winger",
        PhysicalMidfielderLMO: "Physical Midfielder",
        PhysicalFullBackLMO: "Physical FullBack",
        PhysicalDefenderLMO: "Physical Defender",
      },
      radarTemplatesWomen: {
        Goalkeeper: "Goalkeeper",
        Defender: "Defender",
        FullBack: "FullBack",
        FullBackPredictive: "FullBack",
        Midfielder: "Midfielder",
        MidfielderPredictive: "Midfielder",
        MidfielderDefensive: "Midfielder Defensive",
        MidfielderOffensive: "Midfielder Offensive",
        'AttackingMidfielder': "Attacking Midfielder",
        MidfielderWing: "Midfielder Wing",
        Winger: "Winger",
        WingerOffensive: "Winger Offensive",
        Forward: "Forward",
        ForwardPredictive: "Forward",
        WingBack: "WingBack",
        WingBackMedia: "WingBack (SocialMedia)",
        FullBackMedia: "FullBack (SocialMedia)",
        MidfielderMedia: "Midfielder (SocialMedia)",
        WingerMedia: "Winger (SocialMedia)",
        ForwardMedia: "Forward (SocialMedia)",
        PhysicalWingBack: "Physical WingBack",
        PhysicalForward: "Physical Forward",
        PhysicalWinger: "Physical Winger",
        PhysicalMidfielder: "Physical Midfielder",
        PhysicalFullBack: "Physical FullBack",
        PhysicalDefender: "Physical Defender",
        PhysicalWingBackLMO: "Physical WingBack",
        PhysicalForwardLMO: "Physical Forward",
        PhysicalWingerLMO: "Physical Winger",
        PhysicalMidfielderLMO: "Physical Midfielder",
        PhysicalFullBackLMO: "Physical FullBack",
        PhysicalDefenderLMO: "Physical Defender",
      },
      radarDescription: {
        basicStatistics: {
          title: "BASIC STATISTICS",
          minutes: "minutes",
          goals: "goals",
          assists: "assists",
          redCards: "red cards",
          yellowCards: "yellow cards",
          games: "games",
          goalsReceived: "non penalty goals received",
          xGFaced: "xG faced"
        },
        //Inside, Ids of Profiles
        profiles: {
          //GoalKeeperBallPlaying
          3: {
            1: "Skilled goalkeeper with the ball at his feet, both in short and long passes.",
            // 2
            // 3
            // 4
            // 5
            // 6
            // 7
          },
          //DefenderBallWinning
          5: {
            1: "Defender characterized by going well in one-on-one and performing a large number of tackles and interceptions.",
            // 2
            // 3
            // 4
            // 5
            // 6
            // 7
          },
          //DefenderBallPlaying
          6: {
            1: "Defense with great contribution to the generation of chances and a good vision of the game.",
          },
          //FullBackMix
          7: {
            1: "Player with a balanced performance between the offensive game (great contribution in \"xG Buildup\") and the defensive (high volume of recoveries).",
          },
          //FullBackDefensive
          8: {
            1: "Solid in defensive one-on-ones and a high volume of recoveries, both for tackles and interceptions.",
          },
          //FullBackOffensive
          9: {
            1: "Player with great offensive contribution generating dangerous actions and creating chances.",
          },
          //MidfielderBoxToBox
          10: {
            1: "Complete player capable of covering a lot of space, being able to contribute in recoveries as well as having a relevant percentage of \"xG Buildup\" with respect to the total of what the team creates.",
          },
          //MidfielderBallWinning
          11: {
            1: "Midfielder with high defensive performance and great effectiveness in the pass despite his little influence on the attack.",
          },
          //MidfielderHolding
          12: {
            1: "Complete midfielder with high contribution creating chances and a good aerial efficiency, as well as a lot of interceptions and tackles.",
          },
          //WingerClassic
          15: {
            1: "Winger with skill in one-on-one and good level of completed crosses, generating more expected assists than shots.",
          },
          //WingerWide
          16: {
            1: "Player with large volume of through balls and ball progressions, also generating chances and with more influence with possession in the middle than one winger.",
          },
          //WingerInside
          17: {
            1: "Player with good dribbling skills, their movements seek to cut inside to generate more shots (xG) than key passes (xA).",
          },
          //ForwardPressing
          18: {
            1: "Forward who does a great job without the ball at his feet, knowing how to choose well when to end the game with a shot or when to pass.",
          },
          //ForwardMobile
          22: {
            1: "Forward with great mobility to receive through balls, drop to the wing and high level of chances created. High percentage of touches outside the box in relation to the total number of touches per game.",
          },
        },
        description: "DESCRIPTION",
        //Words
        conjuction: " and ",
        //¡¡¡¡ Please, don't remove conjuction2 !!!!
        conjuction2: " and ",
        over: "over",
        under: "under",
        respectively: ", respectively",
        //Categories and quintiles description
        Defending1: {
          1: "His defensive performance is among the worst in the top 5 leagues",
        },
        Defending2: {
          1: "He does not play well defensively since his performance is below average",
        },
        Defending3: {
          1: "He plays with a medium performance, its level is a little over_under_average the average",
        },
        Defending4: {
          1: "Outstanding work on defensive tasks with above average performance",
        },
        Defending5: {
          1: "Outstanding in defensive tasks, with a performance similar to that of the best player_positions of the top 5 leagues",
        },
        Saving1: {
          1: "Goalkeeper with a very low performance, with many difficulties to block the ball",
        },
        Saving2: {
          1: "Does not play a good performance as a goalkeeper since his level is below average",
        },
        Saving3: {
          1: "Goalkeeper with acceptable performance, is in the average of the 5 best leagues, having to improve metric_name",
        },
        Saving4: {
          1: "Goalkeeper with a good level above the average of the 5 best leagues, standing out especially in metric_name",
        },
        Saving5: {
          1: "Saving is a very complete player, all his metrics place him within the Top 20% comparing him with the goalkeepers of the top 5 leagues in Europe.",
        },
        Passing1: {
          1: "With the ball his level is among the worst players",
        },
        Passing2: {
          1: "As far as passes are concerned, their performance is below average",
        },
        Passing3: {
          1: "Passing level is acceptable, slightly over_under_average the average",
        },
        Passing4: {
          1: "Very good level passing the ball, well above average",
        },
        Passing5: {
          1: "Great effectiveness passing the ball with a performance higher than most of players",
        },
        Aerial1: {
          1: "Very weak player in the aerial game, among the worst in his position in this aspect",
        },
        Aerial2: {
          1: "As for winning aerial balls, the player does not perform well, below average",
        },
        Aerial3: {
          1: "Acceptable level in the aerial game, a little over_under_average the average",
        },
        Aerial4: {
          1: "Great performance in the game from above, with high effectiveness in this regard",
        },
        Aerial5: {
          1: "His metrics in the aerial game place him within the best",
        },
        Shooting1: {
          1: "Very poor statistics in front of goal, of the worst players in this regard",
        },
        Shooting2: {
          1: "Very upgradeable shooting level, below average",
        },
        Shooting3: {
          1: "Acceptable performance in offensive work, slightly over_under_average the average",
        },
        Shooting4: {
          1: "It performs very well in the box, with a performance above 60% of players",
        },
        Shooting5: {
          1: "Great skills in offensive tasks, with a spectacular performance, placing him among the best in this regard",
        },
        Association1: {
          1: "His performance associating with the ball is very low, among the worst of the top 5 leagues",
        },
        Association2: {
          1: "It has a lot to improve with the ball at the feet since it is below the average performance in this aspect",
        },
        Association3: {
          1: "Associates well with the ball, slightly over_under_average the average",
        },
        Association4: {
          1: "It associates very well with the ball presenting a very remarkable level",
        },
        Association5: {
          1: "Extraordinary associative ability with the ball at the feet, among the best players",
        },
        BallHandling1: {
          1: "Terrible ball handling performance, among the worst compared to the 5 top leagues",
        },
        BallHandling2: {
          1: "As for ball handling, his levels are below average",
        },
        BallHandling3: {
          1: "Acceptable level handling the ball, slightly over_under_average the average",
        },
        BallHandling4: {
          1: "High level in terms of ball handling, with figures close to the best in this aspect",
        },
        BallHandling5: {
          1: "Exceptional ball handling ability, among the best in the 5 top leagues",
        },
        Crosses1: {
          1: "Low performance crossing the ball into the box. Among the worst players in crossing metrics",
        },
        Crosses2: {
          1: "Below average performance creating danger with his crosses",
        },
        Crosses3: {
          1: "Acceptable level sending crosses into the box, a bit over_under_average",
        },
        Crosses4: {
          1: "Good stats crossing the ball, quite above average",
        },
        Crosses5: {
          1: "Very high performance crossing the ball into the box, specifically, among the top 20% of the most effective profiles in this category",
        },
        Carries1: {
          1: "Among the 20% of players with the worst numbers in terms of carries",
        },
        Carries2: {
          1: "His ball driving performance is far from the average for players in his position",
        },
        Carries3: {
          1: "Close to average performance, slightly over_under_average, in terms of carrying the ball",
        },
        Carries4: {
          1: "Outstanding player with very good depth and carries numbers",
        },
        Carries5: {
          1: "Very talented carrying the ball, with a high performance in the metrics of the Carries category",
        },
        Turnovers1: {
          1: "His performance is very negative with a high volume of turnovers that make it easier for opponents to produce danger. Among the worst in this metric",
        },
        Turnovers2: {
          1: "He benefits opponents with his numerous dangerous turnovers, he needs to improve a lot and reduce his turnovers",
        },
        Turnovers3: {
          1: "This player is slightly over_under_average in terms of turnovers, so there is still room for improvement in his performance",
        },
        Turnovers4: {
          1: "Remarkable performance in turnovers, above the 60% of players who lose the fewest balls",
        },
        Turnovers5: {
          1: "It is worth noting his few turnovers, which place him within the best players in possession for his team",
        },
        SequenceInvolvement1: {
          1: "In terms of ball possession, the numbers speak badly of this player, he very rarely finishes actions with a shot",
        },
        SequenceInvolvement2: {
          1: "His finishing of possessions is quite improvable, he hardly finishes them with a shot, and that places him well below the average",
        },
        SequenceInvolvement3: {
          1: "Acceptable level when it comes to finishing possessions in front of goal, with a percentile a little over_under_average of the average, having a great possibility of improvement",
        },
        SequenceInvolvement4: {
          1: "Good ability to finish his team's possessions with shots, some of them ending in goals, thus having a remarkable performance in this category",
        },
        SequenceInvolvement5: {
          1: "He is among the best players when it comes to finishing his team's possessions, finishing them with shots that generate danger",
        },
        Physical1:{
          1: "His physical performance is among the worst compared to players in the top 5 leagues",
        },
        Physical2:{
          1: "In terms of his physical performance, he is below average",
        },
        Physical3:{
          1: "Acceptable level of physical performance, slightly over/under average",
        },
        Physical4:{
          1: "His physical performance is of high standard, with figures close to the best",
        },
        Physical5:{
          1: "Excepcional physical performance, among the best in the 5 top leagues",
        },
        //Highlight metrics description
        OverMaxValue: {
          1: "He has an extreme ability in over_max_metric_name, with a performance above the maximum value, " +
            "which makes this player in that aspect is in the top 10% of the 5 top leagues",
        },
        OverAverageSeason: {
          1: "Regarding his performance in over_average_metric_name he is above the league average league_name (over_average_metric_value vs average_metric_value)",
          2: "If you compare his numbers with those of the league_name league, in over_average_metric_name you can say that his performance is above average (over_average_metric_value vs average_metric_value)",
        },
        UnderMinValue: {
          1: "As for under_min_metric_name, it should greatly improve its performance since it places it in the lowest percent_metric_name of the top 5 leagues",
        },
        Over70Percent: {
          1: ", especially standing out in over_70_metric_name with over_70_metric_value per 90 minutes, respectively",
          2: ", above 70% in over_70_metric_name with over_70_metric_value per 90 minutes, respectively",
          3: ", performing a more than remarkable job in over_70_metric_name with over_70_metric_value per 90 minutes, respectively",
        },
        Under30Percent: {
          1: ", having to work harder in under_30_metric_name because with under_30_metric_value per 90 minutes, respectively, his performance is low",
          2: ", having to improve remarkably in under_30_metric_name since with under_30_metric_value per 90 minutes, respectively, its performance is below expected",
          3: ", as for under_30_metric_name with under_30_metric_value per 90 minutes respectively, he has to try harder to get better numbers",
        },
        OverAverageSeasonMoreThanOne: {
          1: "It is good to highlight their performance exceeding the league average league_name in ",
        },
        OverAverageStats: {
          1: "over_average_metric_name (over_average_metric_value vs average_metric_value on average)",
        },
        Over70PercentIndividualPressure: {
          1: ", making a very good individual pressure for retrieving the ball",
          2: ", high pressure on the opponent to fetch the ball back",
        },
        Under30PercentIndividualPressure: {
          1: ", having to intensify his pressure more to recover the ball",
          2: ", having to put more effort in terms of pressuring the rival is concerned",
        },
      },
      himSelf:"himself",
      ownSeason: "Own Season",
      minMaxTooltip: "Fit minimun and maximun values of radar"
    },
    login: {
      login: 'Login',
      latestBlogPosts: 'Latest Blog Posts',
      signIn: 'Sign In',
      username: 'Username',
      password: 'Password',
      passwordForgotten: 'Password Forgotten',
      signUp: 'Sign Up',
      enter: "Enter",
      forceTitle: "Account in use",
      forceMessage: "The account is already connected in other device. Do you want kick it out and connect it in this device?",
      forgotMyPassword: "Forgot my password",
      firstLogin: "First Login",
      firstLoginMessage: "For security reasons you have to set a new password in your first login. In addition to a preferred language to view the app",
      firstLoginOverview: "Here is an overview of your account, the leagues and products you have access to.",
      passwordConfirmation: "Password Confirmation",
      forgotPasswordMessage: "Type your email, if there an valid account associated to the email you will recieve in your inbox the next steps to reset your password",
      resetPassword: "Reset Password",
      skipSettings: "Skip settings",
      contact: "Contact",
      cookiesText: "This site uses Google cookies to provide its services and to analyze your traffic to ensure quality of service, generate usage statistics and detect and address abuses.",
      contactUs: "Contact Us",
      newsTitle: "New: Templates Update!",
      newsText: "We've updated our Radar, Stats, and Season templates to offer you more customization and control. Now you can create, edit, and organize your own templates, choosing whether they are public, private, or supervised. Additionally, the stats and season templates will help you optimize your workflow with more precise and tailored selections. Explore the new options in the Templates section of the sidebar!"      
    },
    settings: {
      pageSubtitle: 'Set up your application experience',
      language: 'Language',
      availableLeagues: 'Leagues Available',
      availableProducts: 'Products Available',
      organization: "Company",
      changePassword:"Change Password",
      seasonTemplates:"Season Templates",
      seasonTemplatesSubtitle:"Create your own season templates that will be later available to select in Player Ranking and Player Scout",
      templateName:"Template Name",
      selectTemplate:"Select existing template to edit",
      radarDefault:"Default Radar",
      default: 'Default',
      tabs: {
        options: "Options",
        templates: "Templates",
        availableLeagues: "Available Leagues",
        contactData: "GBE Contact Data"
      },
      contactData: {
        userDetails: "User Details",
        firstName: "First Name",
        lastName: "Last Name",
        contactDetails: "Contact Details for GBE",
        name: "Name",
        phone: "Phone",
        mobile: "Mobile",
        email: "Email",
        representativeDetails: "Representative Details for GBE",
      },
      currency: "Currency",
      fieldPreferences: "Field Preferences",
      visualizationsPreferences: "Visualizations Preferences",
      fieldColor:"Field Color",
      fieldColors:{
        green:"Green",
        blue:"Blue",
        white:"White",
        black:"Black",
        grey:"Grey"
      },
      defaultPlayerVisualization:"Default Player Visualization",
      appPreferences:"Application Preferences",
      darkMode:"Dark Mode",
      showTour:"Show Guided Tour",
      customStats:"Custom Stats",
      radarTemplates: "Radar Templates",
      radarTemplatesSubtitle: "Create your own metric templates that will be later available to select in Radars and Ranking",
      radarCategories:{
        Custom1: "Custom 1",
        Custom2: "Custom 2",
        Custom3: "Custom 3",
        Custom4: "Custom 4",
        Custom5: "Custom 5",
        Custom6: "Custom 6",
        Physical: "Physical",
        CustomPhysical1: "Custom Physical 1",
        CustomPhysical2: "Custom Physical 2",
        CustomPhysical3: "Custom Physical 3",
        CustomPhysical4: "Custom Physical 4",
        CustomPhysical5: "Custom Physical 5",
        CustomPhysical6: "Custom Physical 6",
      },
      templateRemoveTitle:"Remove Template",
      templateRemoveMsg: "Do you want to remove this template?",
      templateEditTitle:"Save Template",
      templateEditMsg: "There is an unsaved template, do you want to save it before loading another template?",
      category:"Category",
      playerRadar:"Player Radar",
      teamRadar:"Team Radar",
      statsAlert:"Insert at least one stat to save",
      recommended: "Recommended",
      warning: "There are positions that have reached the maximum number of radars allowed. Please delete or edit any template",
      fieldPositions: {
        default: 'Driblab',
        fifa: 'FIFA',
        spanish: 'Spanish',
        numeric: 'Numeric'
      },
      showCustomeTemplates: "Show Custom Templates",
      showMediaMode: 'Show Media Mode',
      statTemplates: "Stat Templates",
      statTemplatesSubtitle: "Create your own stats template by choosing from several metrics",
    },
    playerDetail: {
      passport: 'Passport',
      secondPassport: 'Second Passport',
      age: 'Age',
      dateOfBirth: 'Date of Birth',
      height: 'Height',
      weight: 'Weight',
      wage: 'Wage',
      history: 'History',
      positions: 'Positions',
      injuries: 'Injuries',
      transfers: 'Transfers',
      nationalTeam: 'National Team',
      addFavorite: "Add to favorites",
      removeFavorite: "Remove from favorites",
      contractEnd: "Contract End",
      yearsOld: " years old",
      playerAvailability: "Availability",
      playerUsage: "Minutes Played",
      usage: "Usage",
      addToCollection: "Add to collection",
      performance: "Performance",
      info: "Info",
      career: "Career",
      playerStyle: "Player Style",
      radar: "Radar",
      finishingMap: "Finishing Map",
      threatMap: "Threat Map",
      keyPassMap: "Key Pass Map",
      beeswarm: "Ranking",
      allGames: "All Games",
      eventsMap: "Events Map",
      fullName: "Full Name",
      academy: "Academy",
      name: "Name",
      lastName: "Last Name",
      playerAvailabilityLong: "% of the season without injuries or suspensions",
      playerUsageLong: "Minutes Played",
      playerAvailability1: "games without injuries or suspensions",
      playerAvailability2: "games this season",
      playerUsage1: "minutes played",
      playerUsage2: "total team minutes",
      notMinutesThisSeason: "Has not played minutes this season",
      seasonPlaceholder: "There is no active season",
      inactivePlayer: "Inactive Player",
      inactivePlayerMessage: "If you need more information, you can ask for a report",
      goRequest:"Go To Request",
      warningMinutes: "Caution: Less than 450 minutes played, analysis may not be representative",
      warningSeasonGames: "Season has less than 5 games played, so Min & Max are 'Top 5 Leagues'",
      warningStatsRemoved: 'Some stats are not shown because they are not available for the selected season',
      warningBeeswarm: "Player not shown because there is no data for this stat in the selected season", 
      onlyPlayersThatFit: "Only Players that fit in Radar Template",
      gamesPlayedNotEnough: "Options disabled due to not enough games played",
      gbe: "GBE",
      analysis:"Analysis",
      documents:"Documents",
      rankDefensive:"Defensive",
      rankBallHandling:"Ball Handling",
      rankGoal:"Goal Contribution",
      rankXt:"Threat",
      rankIndex:"Index",
      visitHistory: "Visit History",
      placer:"Pitch",
      touchesMap:"Touches map",
      heatMap:"Heat Map",
      ageProfile:"Age Profile",
      strongFoot:"Strong foot",
      player: 'Player',
      outOf: 'out of',
      in: 'in',
      careerTable: {
        nationalTeamCareer: "National Team Career",
        nationalTeamCompetitions: "National Team Competitions"
      },
      physicalProgression:"Physical Progression"
    },
    finishingMap: {
      typesOfShot: "Types of Shot",
      shotStrategy: "Shot Strategy",
      areas: "Areas",
      bodyPart: "Body Part",
      more: "more",
      selectAll: "Select All",
      minutes: "Minutes",
      circles: "Circles",
      boxes: "Boxes",
      lines: "Lines",
      games: "Games",
      perShot: "per Shot",
      goal: "Goal",
      missedShot: "Missed Shot",
      savedShot: "Saved Shot",
      shotOnPost: "Shot on Post",
      missedChance: "Missed Chance",
      openPlay: "Open Play",
      regularPlay: "Regular Play",
      fastBreak: "Fast Break",
      individualPlay: "Individual Play",
      setPiece: "Set Piece",
      fromCorner: "From Corner",
      freeKick: "Free Kick",
      indirectFreeKick: "Indirect Free Kick",
      throwInSetPiece: "Throw In Set Piece",
      inBox: 'In Box',
      goalArea: 'Six-Yard Box',
      boxLeft: 'Box Left',
      boxCenter: 'Box Center',
      boxRight: 'Box Right',
      outOfBox: 'Out of Box',
      outBoxDeepLeft: 'Out of Box Deep Left',
      outBoxDeepRight: 'Out of Box Deep Right',
      outBoxLeft: 'Out of Box Left',
      outBoxCentreLeft: 'Out of Box Centre Left',
      outBoxCentre: 'Out of Box Centre',
      outBoxCentreRight: 'Out of Box Centre Right',
      outBoxRight: 'Out of Box Right',
      left35: '+35 Left',
      centreLeft35: '+35 Centre Left',
      centre35: '+35 Centre',
      centreRight35: '+35 Centre Right',
      right35: '+35 Right',
      head: "Head",
      rightFooted: "Right Footed",
      leftFooted: "Left Footed",
      otherBodyPart: "Other Body Part",
      chart: {
        shots: "Shots",
        xGPerShot: "xG per Shot",
        exceptionTextPenaltyGoals: "* Penalty Shots = 0.765 xG",
        exceptionTextGKPenaltyGoals: "* Penalty Shots = 0.765 xGOT",
        exceptionTextOwnGoals: "* Own Goals not taken into account",
        og: "OG",
        penaltiesExcluded: "Penalty Goals Excluded",
        ownGoalsExcluded: "Own Goals Excluded",
        sumOfxG: "Sum of xG",
        exceptionShotsOutOfRange: "* Not showing shots out of range"
      },
      inGoal: "In Goal",
      outOfGoal: "Out of Goal",
      highLeft: "High Left",
      highCenter: "High Center",
      highRight: "High Right",
      lowLeft: "Low Left",
      lowCenter: "Low Center",
      lowRight: "Low Right",
      outHighLeft: "Out High Left",
      high: "Out High Center",
      outHighRight: "Out High Right",
      closeHighLeft: "Close High Left",
      closeHigh: "Close High Center",
      closeHighRight: "Close High Right",
      closeLeft: "Close Low Left",
      closeRight: "Close Low Right",
      finishingTable: "Finishing Table",
      onGoal: "On Goal",
      distributionFilters: "Distribution Filters",
      penalty: "Penalty",
      penaltyShootout: "Penalty Shootout",
    },
    keyPassMap: {
      chart: {
        keyPasses: "Key Passes",
        xAPerPass: "xA per Pass",
        xAOpenPlay: "xA Open Play",
        xASetPiece: "xA Set Piece"
      }
    },
    beeswarm: {
      template: 'Template',
      templates: {
        'Goalkeeper': 'Goalkeeper',
        'Defender': 'Defender',
        'Full-Back': 'Full-Back',
        'FullBack': 'Full-Back',
        'Wing-Back': 'Wing-Back',
        'WingBack': 'Wing-Back',
        'Midfielder': 'Midfielder',
        'AttackingMidfielder': 'Attacking-Midfielder',
        'Winger': 'Winger',
        'Forward': 'Forward',
        'Physical': 'Physical'
      },
      compareWith: "Compare to",
      highlightPlayersOf: "Highlight Players of",
      highlightPlayers: "Highlight Players",
      per90:"Data per 90 minutes",
      highlightTeams: "Highlight Teams",
      filterTeams: "Filter Teams"
    },
    collections: {
      newCollection: "New collection",
      editCollection: "Edit collection",
      name: "Name",
      visibility: "Visibility",
      privacity: {
        publicTitle: "Public",
        publicDescription: "Visible for you and your club",
        privateTitle: "Private",
        privateDescription: "Only visible for you",
        supervisedTitle: "Supervised",
        supervisedDescription: "Only visible for you and your supervisor",
      },
      addSuccess: "Added successfully",
      createAddSuccess: "Created and added successfully",
      editSuccess: "Updated successfully",
      deleteSuccess: "Deleted successfully",
      title: "Collections of players",
      publics: "Publics",
      privates: "Privates",
      supervised: "Supervised",
      totalMarketValue: "Total market value",
      avgMarketValue: "Average market value",
      avgAge: "Average age",
      searchBarPlaceholder: "To add to the colecction, search and choose players",
      deleteCollection: "Delete collection",
      deleteCollectionMessage: "Collection will be removed, are you sure?",
      removePlayer: "Remove player",
      removePlayerMessage: "Player will be removed from collection, are you sure?",
      subtitle: "Organize your scouting",
      notExitingTemplate: 'There are still no templates',
    },
    searchbar: {
      placeholder: "Type to search (e.g. `david arsenal´)",
      players: "Players",
      teams: "Teams",
      games: "Games",
      leagues: "Leagues",
      explore: "Explore more results",
      placeholderNoResults: "No results for template",
      teamPlaceholder: "To compare a team, search and select it",
    },
    favorites: {
      showOnly: "Show only",
      selfFavorites: "My favorites",
      clubFavorites: "Club favorites",
      contractExpiration: "Contract expiration",
      groupBy: "Group by",
      noGrouped: "None",
      maxSelection: "Only can select",
      selectAtleastOne: "At least select one",
      comparePlayers: "Compare players",
      selectedPlayers: "players selected",
      subtitle: "Keep tracking the future stars",
      generateXlsx: "Generate XLSX",
      generating: "Generating...",
      subscribed: "Subscribed",
      subscribedTooltip:"Subscribe to recieve a mail when a game have been played"
    },
    expiration: {
      summer: "Summer",
      winter: "Winter"
    },
    positions: {
      noposition: "No Position",
      goalkeeper: "Goalkeeper",
      goalkeepers: "Goalkeepers",
      defender: "Defender",
      defenders: "Defenders",
      defenses: "Defenders",
      fullback: "FullBack",
      fullbacks: "FullBacks",
      midfielder: "Midfielder",
      midfielders: "Midfielders",
      winger: "Winger",
      wingers: "Wingers",
      forward: "Forward",
      forwards: "Forwards",
      wingback: "WingBack",
      wingbacks: "WingBacks",
    },
    dPos: { //Dallas Positions
      1: { name: "Goalkeeper", alias: ""},
      2: { name: "Right Full Back", alias: "RFB"},
      3: { name: "Right Center Back", alias: "RCB"},
      4: { name: "Left Center Back", alias: "LCB"},
      5: { name: "Left Full Back", alias: "LFB"},
      6: { name: "Defensive Midfielder", alias: "DM"},
      7: { name: "Right Winger", alias: "RW"},
      8: { name: "Center Midfielder", alias: "CM"},
      9: { name: "Striker", alias: "ST"},
      10: { name: "Attacking Midfielder", alias: "AM"},
      11: { name: "Left Winger", alias: "LW"},
    },
    charts: {
      seasonsCompareSelectLabel: "Compare with",
      lastSeasonSelectText: "Last Season",
      lastAndCurrentSeasonSelectText: "Last + Current Season",
      currentSeasonSelectText: "Current Season",
      last20gamesSelectText: "Last 20 games",
      last10gamesSelectText: "Last 10 games",
      npgVsXGTitle: "Non-Penalty Goals VS xG",
      totalXGLabel: "Total xG",
      xGLabel: "xG",
      totalNPGLabel: "Total Non-Penalty Goals",
      xGAgainstvsNPGAgainstTitle: "xG Against VS Non-Penalty Goals Against",
      totalXGAgainstLabel: "Total xG Against",
      xGAgainstLabel: "xG Against",
      totalNPGAgainstLabel: "Total Non-Penalty Goals Against",
      xGvsxGAgainstTitle: "xG VS xG Against",
      pointsVsXPointsTitle: "Points VS Expected Points",
      xTTitle: "Game Flow",
      totalXPoints: "Total xPoints",
      totalPoints: "Total Points",
      requestedReports: "Reports Requested",
      playersScouted: "Players Scouted",
      performanceVSAverageChart: "Performance VS Average",
      perPositions: "Per Positions",
      perLeagues: "Per Leagues",
      perMonths: "Per Months",
      perClients: "Per Clients",
      ofPreposition: "of",
      idJChartTitle: "Game Initiative",
      idJChartLabel: "Index GI",
      vJOChartTitle: "Offensive Game Volume",
      vJOChartLabel: "Index OGV",
      preJOChartTitle: "Offensive Game Precision",
      preJOChartLabel: "Index OGPre",
      proJOChartTitle: "Offensive Game Progression",
      proJOChartLabel: "Index OGPro",
      chart: "Chart",
      table: "Table"
    },
    table: {
      history: {
        season: 'Season',
        team: 'Team',
        position: 'Position',
        side: 'Side',
        games: 'Games',
        minutes: 'Mins',
        goals: 'NPG (G)',
        assists: 'A',
        yellowCards: 'YC',
        redCards: 'RC',
        gameLost: 'GM',
        gamesMissed: 'Games Missed'
      },
      injury: {
        season: 'Season',
        team: 'Team',
        injury: 'Injury',
        dateFrom: 'Start Date',
        dateTo: 'End Date',
        daysLost: 'Days Lost',
        gamesLost: 'Games Lost',
        allInjuries: 'All Injuries'
      },
      transfers: {
        season: 'Season',
        date: 'Date',
        teamFrom: 'Team From',
        teamTo: 'Team To',
        marketValue: 'Market Value',
        fee: 'Fee',
      },
      caps: {
        team: 'Team',
        debut: 'Debut',
        games: 'Games',
        goals: 'Goals',
        coachDuringDebut: 'Coach During Debut',
        debutAge: 'Debut Age',
      },
      roster: {
        country: 'Country',
        player: 'Player',
        positions: 'Positions',
        minutes: 'Minutes',
        games: 'Games',
        goals: 'Goals',
        assists: 'Assists',
        cards: 'Cards',
        gamesExplicit: 'Games Played',
      },
      league: {
        title: "League Sheet",
        subtitle: "Go deeper into the league's ranking and statistics",
        team: 'Team',
        games: 'GP',
        gamesExplicit: 'Games Played',
        gamesRanking: 'GP',
        gamesRankingExplicit: 'Games Played',
        points: 'Pts',
        pointsExplicit: 'Points',
        expectedPoints: 'xP',
        expectedPointsExplicit: 'Expected Points',
        goalsScored: 'NPG',
        goalsScoredExplicit: 'Non-Penalty Goals',
        xG: 'xG',
        xGExplicit: 'Expected Goals',
        goalsAgainst: 'NPGA',
        goalsAgainstExplicit: 'Non-Penalty Goals Against',
        xGAgainst: 'xGA',
        xGAgainstExplicit: 'Expected Goals Against',
        xGAgainstDiff: 'xGA Diff',
        xGAgainstDiffExplicit: 'Expected Goals Against Difference',
        form: 'Form',
        sos:"SoS",
        sosExplicit:"Strength of Schedule",
        sosHfa: "SoS HFA",
        sosHfaExplicit:"Home Field Advantage",
        difficultyAboveAvg:"Difficulty above average",
        differentGames: "* Different Number of Games Played",
        berth: "Berth"
      },
      usersOfClient: {
        userName: 'Name',
        userRole: 'User',
        devRole: 'Dev',
        adminRole: 'Admin',
        servicesRole: 'Services',
        xgRole: 'XG',
        radarRole: 'Radar',
        beeswarmRole: 'Ranking',
        elevenRole: 'Elevens',
        similarityRole: 'Similarity',
        gameAnalysisRole: 'Game Analysis',
        clientStatsRole: 'Client Stats',
        created: 'Created',
        type: "Type",
        logins: "Logins",
        lastLogin: "Last Login",
        trialDate: "Trial Date"
      },
      clientLeagues: {
        league: 'League',
        area: 'Area',
        tier: 'Tier',
        seasons: 'Seasons',
        currentMatchDay: 'Match day',
        regular: 'Regular',
        youthLeague: 'Youth',
        clientActive: 'Active',
        visibleLeagues: "Visible Leagues"
      },
      connections: {
        title: 'Common Combinations',
        playerFrom: 'From Player',
        playerTo: 'To Player',
        passes: 'Passes',
        passesTooltip: 'Total Number of Successful Passes',
        passesFinalThird: "PF ⅓",
        passesFinalThirdTooltip: "Passes Final Third"
      },
      playerPassMapData: {
        title: 'Passing Stats',
        player: 'Player',
        passes: 'Passes',
        passesPct: '% Passes',
        xA: 'xA',
        xG: 'xG',
        xT: 'xThreat',
        playerTooltip: 'Name of Player',
        passesTooltip: 'Total Number of Passes',
        passesPctTooltip: '% Successful Passes',
        xATooltip: 'Expected Assists',
        xGTooltip: 'Expected Goals',
        xTTooltip: 'Expected Threat'
      },
      playerAllGames: {
        gameDate: 'Date',
        game: 'Game',
        team: 'Team',
        positionsPlayed: 'Positions',
        minsPlayed: 'Minutes',
        gameActions: 'Actions',
        gameDateTooltip: 'Date Game',
        gameTooltip: 'Game',
        positionsPlayedTooltip: 'Positions Played',
        minsPlayedTooltip: 'Minutes Played',
        gameActionsTooltip: 'Goals, Assists, Cards',
        from: "From",
        to: "to",
        goalText: "Goal at",
        assistText: "Assist at",
        penaltyText: "Penalty at",
        ownGoalText: "Own Goal at",
        yellowCardText: "Yellow Card at",
        secondYellowCardText: "Second Yellow Card at",
        redCardText: "Red card at",
        substitutionIN: "In at",
        substitutionOUT: "Out at",
        suspendedText: "Suspension"
      },
      gameFlow: {
        phase: "Phase ",
        mins: "Minutes",
        team: "Team",
        period: "Period",
        possession: "%Poss.",
        possessionTooltip: "% Possession",
        xT: "xThreat",
        xTTooltip: "Expected Threat",
        pft: "PF ⅓",
        pftTooltip: "Passes Final Third",
        xG: "xG",
        xGTooltip: "Expected Goals"
      },
    },
    game: {
      title: "Game Sheet",
      subtitle: "Go deeper into the game's characteristics and statistics",
      header: {
        gameDetails: 'Details',
        gameStats: 'Stats',
        gameFinishingMap: 'Finishing Map',
        gameKeyPassMap: 'Key Pass Map',
        gamePassMap: 'Pass Map',
        gameThreat: 'Game Threat',
        gameFlow: 'Game Flow',
        gameAnalysis: "Game Analysis",
        gamePhysicalStats: "Physical Stats",
        possessions: "Possessions",
        bench: "Bench",
        video:"Video highlights"
      },
      passMap: {
        team: 'Team',
        minutes: 'Minutes:',
        select: 'Select',
        all: 'All',
        attacking: 'Attacking',
        defending: 'Defending',
        forwards: 'Forward',
        backwards: 'Backwards',
        sideways: 'Sideways',
        longBall: 'Long Ball',
        successfullPasses: 'Successfull Passes',
        homeTeam: 'Home',
        awayTeam: 'Away',
        passingMatrix: 'Passing Matrix'
      },
      stats: {
        summary: "Summary",
        attacking: 'Attacking',
        defending: 'Defending',
        contribution: "Contribution",
        possession: "Possession",
        expectedPoints: "Expected Points",
        directness: "Directness",
        ppda: "PPDA",
        xg: "xG",
        xG: "xG",
        xGSetPiece: "xG Set Piece",
        xA: "xA",
        xASetPiece: "xA Set Piece",
        xT: "xT",
        xTSetPiece: "xT Set Piece",
        touchesInOppBox: "Touches in Opponent Box",
        passesFinalThird: "Passes Final Third",
        interceptions: "Interceptions",
        recoveries: "Recoveries",
        recoveriesOppHalf: "Recoveries Opponent Half",
        tackles: "Tackles",
        tacklesWasDribbled: "Tackles / was Dribbled",
        fouls: "Fouls",
        yellowCards: "Yellow Cards",
        redCards: "Red Cards",
        passes: "Passes",
        passing: "Passing %",
        crosses: "Crosses",
        crossing: "Crossing %",
        shots: "Shots",
        shotsOnTarget: "Shots on Target",
        ppdaExplicit: "Conceded Passes per Defensive Action",
        xgExplicit: "Expected Goals",
        xp: "xP",
        ExpectedPassing: "xP %",
        seasonAvg: "Competition Avg.",
        winChance: "Win Probability",
        postGameWinChance: "Post-Game Win Probability",
        winChanceTooltip: "Based on xG generated and conceded",
        drawChance: "Draw",
        xgAgainst: "xG Against",
        averagePossession: "Average Possession",
        averageShots : "Average Shots",
        averagexG: "Average Expected Goals",
        fieldTilt: "Field Tilt",
        fieldTiltExplicit: "Field Tilt"
      },
      detail: {
        halfTime: "Half Time",
        overTime: "Over Time",
        showStats: "Show Stats",
        hideStats: "Hide Stats",
        bench: "Bench",
        showShotOptions: "Show Shot Options",
        hideShotOptions: "Hide Shot Options",
        showPassOptions: "Show Pass Options",
        hidePassOptions: "Hide Pass Options",
        endGame: "Full Time",
        penalties: "Penalties"
      },
      timeline: {
        events: {
          goal: "Goal",
          goal_ownGoal: "Own Goal",
          goal_penalty: "Penalty Kick Goal",
          card: "Card",
          card_yellowCard: "Yellow Card",
          card_secondYellowCard: "Second Yellow Card",
          card_redCard: "Red Card",
          formationChange: "Formation Change",
          substitution: "Substitution",
          saveShot: "Saved Shot",
          saveShot_penalty: "Saved Penalty Kick",
          missedShot: "Missed Shot",
          missedShot_penalty: "Missed Penalty Kick",
          shotOnPost: "Shot on Post",
          shotOnPost_penalty: "Shot on Post Penalty Kick"
        }
      },
      gameFlow: {
        goalOf: "Goal of ",
        redCardTo: "Red Card to ",
        missedPenalty: "Missed penalty"
      },
      gameThreat: {
        typeOfPlay: 'Type of Action',
        regularPlay: 'Regular Play',
        setPiece: 'Set Piece',
        setPiecePlay: 'Set Piece',
        throwInSetPiecePlay: 'Throw In Play',
        throwInPlay: 'Throw In Play',
        gkThrow: 'Goalkeeper Throw',
        gkKick: 'Goalkeeper Kick',
        kickOff: 'Kick Off',
        actionEnding: 'Action Ending',
        pass: 'Pass',
        shot: 'Shot',
        foul: 'Foul',
        other: 'Other',
        threat: 'Threat',
        legendSumOfXT: 'Sum of xT',
        legendPass: 'Pass',
        legendShot: 'Shot',
        legendCarryAndAction: 'Carry and Action',
        legendCarryAndPass: 'Carry and Pass',
        legendOnlyShowing: 'Only showing individual actions with xT > ',
        legendOnlyShowingPart1: 'Only showing individual',
        legendOnlyShowingPart2: 'actions with xT > ',
        legendOnlyShowingSetPiece: 'Only showing Set Piece actions with xT > ',
        legendOnlyShowingOpenPlay: 'Only showing Open Play actions with xT > ',
        legendPlays: 'Actions',
        legendPerPlay: 'per Action',
        legendCarry: 'Carry',
        penaltyPlay: 'Penalty',
        freeKickTakenPlay: "Free Kick Play",
        cornerTakenPlay: "Corner Play",
        fromCornerPlay: "Corner Play",
        keeperThrowPlay: "Keeper Throw Play",
        fastBreakPlay: "Fast Break Play",
        indirectPlay: "Indirect Play",
        minutes: "Minutes",
        games: "Games",
        xT: "xT",
        xTPer90: "xT per 90'"
      },
      gameAnalysis: {
        next: "Next",
        previous: "Previous",
        phaseLabel: "Phase",
        phasesLabel: "Phases",
        dot: ". ",
        comma: ", ",
        from: "From",
        to: "To",
        and: " and ",
        steps: {
          finishingMapFullGame: "Finishing Map",
          keyPassMapFullGame: "Key Pass Map",
          gameFlow: "Game Flow",
          finishingMapPerPhases: "Finishing Map per Phases",
          keyPassMapPerPhases: "Key Pass Map per Phases",
          passMapPerPhases: "Pass Map per Phases",
        },
        step1: {
          table: {
            draw: "Draw",
            win: "Win",
            lose: "Lose",
            possession:	"Possession",
            xP:	"Expected Points",
            directness:	"Directness",
            ppda:	"PPDA",
            xG:	"xG",
            xGOpenPlay:	"xG Open Play",
            xGSetPiece:	"xG Set Piece",
            xA:	"xA",
            xAOpenPlay:	"xA Open Play",
          },
          text: {
            firstParagraph: {
              1: "The map on the right displays the expected goals generated by home_team_name and away_team_name. The refilled circles are the shots that ended in goal. The size of the circles depends on the xG value of each shot. ",
            },
            lastParagraph: {
              1: "The probability percentage of a result and the number of expected points are calculated through shot simulation (100,000 simulations of the shots are carried out and the possibility of results and of getting points is evaluated in a predictive way). ",
            },
            targetHighTeamXG: {
              1: "target_team_name, as well as rival_team_name, managed to create a high volume of expected goals",
            },
            targetHighTeamOpenPlayXG: {
              1: ", with most of the target_team_name chances coming from open plays",
            },
            targetHighTeamOpenPlayXGvsGameRival: {
              1: ", but performed better at generating open play chances",
            },
            targetHighTeamSetPieceXG: {
              1: ", with most of the target_team_name chances coming from set pieces",
            },
            targetHighTeamSetPieceXGvsGameRival: {
              1: ", but performed better at generating chances from set pieces",
            },
            targetHighTeamCornerXG: {
              1: ", with most of the chances coming from corner kicks",
            },
            targetLowTeamGoalConversion: {
              1: ", although the chances conversion was below expected",
            },
            dot: {
              1: ". ",
            },
            targetHighTeamXGOPandSP: {
              1: "target_team_name created a high volume of expected goals in both open plays and set pieces",
            },
            targetHighTeamGoalConversion: {
              1: " also having a high goal conversion ratio. ",
            },
            targetLowTeamGoalConversionZeroGoals: {
              1: ", not being able to score any of the chances created",
            },
            targetLowTeamGoalConversionScoringGoals: {
              1: " but created danger to score more goals",
            },
            targetHighTeamXGvsGameRival: {
              1: "In this game, target_team_name generated more danger than rival_team_name",
            },
            targetLowTeamGoalConversionScoringGoals2: {
              1: " and could have scored more goals. ",
            },
            targetHighTeamXGZeroGoals: {
              1: " but was not able to score any goals out of the chances created. ",
            },
            targetHighTeamXGGoalDiff: {
              1: " matching a winning chance of team_winning_chance according to our post-game simulation. ",
            },
            startTargetHighTeamOpenPlayXG: {
              1: " Most of the target_team_name chances came from open plays. ",
            },
            startTargetHighTeamSetPieceXG: {
              1: " Most of the target_team_name chances were originiated by set piece plays. ",
            },
            startTargetHighTeamCornerXG: {
              1: " Most of the chances came from corner kicks. ",
            },
            targetSimilarTeamXG: {
              1: "In this game, both teams generated a similar amount of danger to the opponent in terms of xG, ",
            },
            targetSimilarTeamXGGoalDiff: {
              1: "but target_team_name performed better at finalizing chances. ",
            },
            targetLowTeamXGGoalDiff: {
              1: "Regardless the result, target_team_name did not generate much danger to the opponent in terms of Expected Goals. ",
            },
            targetLowTeamXGZeroGoalDiff: {
              1: "target_team_name did not generate enough danger to the opponent in terms of Expected Goals to win the game",
            },
            rivalHighTeamXG: {
              1: "and allowed rival_team_name to generate too much danger. ",
            },
            rivalHighTeamXGGoalDiff: {
              1: " With this creation, this is a game that target_team_name would only win team_winning_chance of the times according to our post-game simulation. ",
            },
            targetHighTeamOpenPlayXG: {
              1: "In this game, most of target_team_name chances came from open plays",
            },
            targetHighTeamOpenPlayXGvsGameRival: {
              1: "In this game, most of target_team_name chances were originiated by open plays (unlike rival_team_name)",
            },
            targetHighTeamSetPieceXG: {
              1: "In this game, most of target_team_name chances came from set piece plays",
            },
            targetHighTeamSetPieceXGvsGameRival: {
              1: "In this game, most of target_team_name chances were originiated by set piece plays (unlike rival_team_name)",
            },
            targetHighTeamCornerXG: {
              1: "In this game, most of target_team_name chances came from corner kicks",
            },
            targetHighTeamGoalConversion2: {
              1: " having a high goal conversion ratio",
            },
            targetLowTeamGoalConversionZeroGoals: {
              1: ", not being able to score any of the chances created",
            },
            targetLowTeamGoalConversion: {
              1: " but the goal conversion was low",
            },
            winningChance: {
              1: "Given the number of shots and xG of both teams, target_team_name should have won this game team_winning_chance of the times. ",
            },
            highPlayerXGManyShots: {
              1: "It is interesting to note that player_name generated xg_value xG in shots_value shots",
            },
            highPlayerXGMoreThanOneGoal: {
              1: " needing xg_value xG to score a goal. ",
            },
            highPlayerXGOneGoal: {
              1: " to score the goal. ",
            },
            highPlayerXGAnyGoal: {
              1: ", although he was not able to score any goal. ",
            },
            highPlayerXGNotManyShots: {
              1: "It is worth mentioning that player_name generated xg_value xG in a few shots",
            },
            highManyPlayerXG: {
              1: "It is interesting to note that player_name and player_name2 generated xg_value and xg_value2 <b>xG</b> respectively. ",
            },
            highTeamXGPerShot: {
              1: "Regarding the selection of shots taken by target_team_name, they were very good in terms of probability of becoming a goal, with an average xG per shot of xg_per_shot_value. ",
            },
            highTeamXGPerShotVSGameRival: {
              1: "The selection of shots of target_team_name was much better than rival_team_name, having an average of xg_per_shot_value xG per shot. ",
            },
            xGTimesNotAfter70xG: {
              1: "Despite the high xG generated, target_team_name had problems to create danger at the end of the game. ",
            },
            xGTimesBefore25xG: {
              1: "target_team_name created a lot of danger especially at the beginning of both halves. ",
            },
            xGTimesAfter25xG: {
              1: "target_team_name created a lot of danger especially at the end of both halves. ",
            },
            xGTimesBefore25xGvsItself: {
              1: "target_team_name created most of the danger at the beginning of the first half. ",
            },
            xGTimesAfter25xGvsItself: {
              1: "target_team_name created most of the danger at the end of the first half. ",
            },
            xGTimesBefore70xGvsItself: {
              1: "target_team_name created most of the danger at the beginning of the second half. ",
            },
            xGTimesAfter70xGvsItself: {
              1: "target_team_name created most of the danger at the end of the second half. ",
            },
            xGTimesBefore25xG2: {
              1: "target_team_name started the game very solid with chances that generated xg_value expected goals. ",
            },
            xGTimesAfter25xG2: {
              1: "target_team_name finished the first half of the game with chances that generated xg_value expected goals. ",
            },
            xGTimesBefore70xG: {
              1: "target_team_name came off the half-time break with chances that generated xg_value expected goals. ",
            },
            xGTimesAfter70xG: {
              1: "target_team_name finished the second half with chances that generated xg_value expected goals. ",
            },
            xGTimesAfter70xGOverOneDotTwo: {
              1: "target_team_name created a lot of danger at the end of the second half. ",
            },
            xGTimesBefore70xGOverOneDotTwo: {
              1: "target_team_name created a lot of danger at the beginning of the second half. ",
            },
            xGTimesAfter25xGOverOneDotTwo: {
              1: "target_team_name created a lot of danger at the end of the first half. ",
            },
            xGTimesBefore25xGOverOneDotTwo: {
              1: "target_team_name created a lot of danger at the beginning of the first half. ",
            },
            xGTimesFirstHalfXGSecondHalfXGRival: {
              1: "target_team_name generated most of its danger in the first half while rival_team_name did the same in the second half. ",
            },
            xGTimesSecondHalfXGFirstHalfXGRival: {
              1: "target_team_name generated most of its danger in the second half while rival_team_name did the same in the first half. ",
            },
            xGTimesFirstHalfXGFirstHalfXGRival: {
              1: "It is a game where most of the danger in terms of Expected Goals was generated during the first half. ",
            },
            xGTimesSecondHalfXGSecondHalfXGRival: {
              1: "It is a game where most of the danger in terms of Expected Goals was generated during the second half. ",
            },
            xGTimesFirstHalfXG: {
              1: "target_team_name managed to create most of the danger in the first half. ",
            },
            xGTimesSecondHalfXG: {
              1: "target_team_name managed to create most of the danger during the second half. ",
            },
            xGTimesFirstHalfXGRival: {
              1: "target_team_name allowed most of the danger in terms of Expected Goals in the first half. ",
            },
            xGTimesSecondHalfXGRival: {
              1: "target_team_name allowed most of the danger in terms of Expected Goals during the second half. ",
            },
            highInBoxXG: {
              1: "The shot map displays how most of the danger came from shots inside the box. ",
            },
            highOutOfBoxXG: {
              1: "It can be observed in the shot map that, in this game, target_team_name generated a lot of danger from outside the box. ",
            },
            highInBoxXGRival: {
              1: "We want to point out that, most of the danger conceded by target_team_name came from shots inside the box. ",
            },
            highInBoxXGRival2: {
              1: " It is also interesting to highlight that most of the danger conceded by target_team_name came from shots inside the box. ",
            },
            highOutOfBoxXGRival: {
              1: "target_team_name performed well avoiding danger inside the box. ",
            },
            highTeamChancesHighPPDARival: {
              1: "The lack of pressure of target_team_name, allowing ppda_value Passes per Defensive Action, was one of the keys for rival_team_name to create a high number of chances. ",
            },
            lowPPDAWithGoalDiff: {
              1: "target_team_name only allowed ppda_value Passes per Defensive Action being this one of the keys to victory. ",
            },
            lowPPDA: {
              1: "target_team_name did a great job at interrupting the plays of rival_team_name allowing only an average of ppda_value Passes per Defensive Action. ",
            },
            highPossession: {
              1: "target_team_name had the control of the ball with a possession_value of possession",
            },
            highPPDARival: {
              1: " as well as a fluid distribution of the ball",
            },
            chancesCreated: {
              1: ", which allowed them to have a high number of open play chances (chances_value). ",
            },
            chancesCreatedRival: {
              1: ", although rival_team_name was able to create a high number of open play chances (chances_value). ",
            },
            xGPerShotRival: {
              1: ", although rival_team_name was able to create more dangerous chances with a xg_per_shot_value xG per Shot. ",
            },
            winGame: {
              1: " being one of the keys to win the game. ",
            },
            notEnoughWinGame: {
              1: " not being enough to win the game. ",
            },
            goalsFromErrorsFirstGoal: {
              1: "The first goal came from a mistake of player_error_name seized by player_name",
            },
            goalsFromErrorsFirstGoalFinalResult: {
              1: "The first and only goal came from a mistake of player_error_name seized by player_name",
            },
            lastPhaseOfGame: {
              1: " at the last phase of the game. ",
            },
            goalsFromErrorsFinalResultGoalToLead: {
              1: "The final goal to win the game came from a mistake of player_error_name that led to the goal of player_name. ",
            },
            goalsFromErrorsFinalResultGoalToTie: {
              1: "The final goal to tie the game came from a mistake of player_error_name that led to the goal of player_name. ",
            },
            goalsFromErrorsGoalToTie: {
              1: "An error from player_error_name led to a chance to tie the game for target_team_name. ",
            },
            goalsFromErrorsGoalToLead: {
              1: "target_team_name took the lead taking advantage of an error from player_error_name",
            },
            xGChance: {
              1: " with a chance of xg_value xG. ",
            },
            rivalGoalsFromErrorsFinalResultGoalToLead: {
              1: "The final goal of rival_team_name to win the game came from a mistake of player_error_name that led to the goal of player_name. ",
            },
            rivalGoalsFromErrorsGoalToTie: {
              1: "An error from player_error_name led to a chance to tie the game for rival_team_name. ",
            },
            rivalGoalsFromErrorsGoalToLead: {
              1: "rival_team_name took the lead taking advantage of an error from player_error_name",
            },
            hugeChancesMissedOneScored: {
              1: "target_team_name happened to score the only big chance that created during the game, that is the goal of player_name that we see in the xG map with an xG of xg_value. ",
            },
            hugeChancesMissedMoreThanOneScored: {
              1: "target_team_name happened to score all the big chances that created during the game",
            },
            hugeChancesMissedZeroGoalsOneChance: {
              1: "player_name had the only great chance of target_team_name to score with an xG of xg_value. ",
            },
            hugeChancesMissedZeroGoalsMoreChances: {
              1: "target_team_name  was not able to score any of the chances_value chances above 40% of likelihood to become a goal. ",
            },
            oneHugeChancesBeforeFirstGameGoal: {
              1: "player_name had a great chance of xg_value xG to get ahead in the score. ",
            },
            moreThanOneHugeChancesBeforeFirstGameGoal: {
              1: "target_team_name had chances_value chances with xG above 40% to get ahead in the score. ",
            },
            moreThanOneBigChancesBeforeFirstGameGoal: {
              1: "target_team_name had chances_value chances with high xG to get ahead in the score. ",
            },
            shotOnPostBeforeFirstGameGoal: {
              1: "player_name had a chance to get ahead in the score of xg_value xG that hit the post. ",
            },
            beforeEndOfGame: {
              1: "Before the end of the game, ",
            },
            oneHugeChancesAfterFirstGameGoal: {
              1: "player_name had a chance of xg_value xG to win the match. ",
            },
            moreThanOneHugeChancesAfterFirstGameGoal: {
              1: "target_team_name had chances_value chances with an xG above 40% to win the match. ",
            },
            moreThanOneBigChancesAfterFirstGameGoal: {
              1: "target_team_name had chances_value chances with high xG to win the match. ",
            },
            oneHugeChancesBeforeFirstGameGoalRival: {
              1: "player_name had a great chance of xg_value xG to get ahead in the score. ",
            },
            moreThanOneHugeChancesBeforeFirstGameGoalRival: {
              1: "target_team_name had chances_value chances with xG above 40% to get ahead in the score. ",
            },
            moreThanOneBigChancesBeforeFirstGameGoalRival: {
              1: "target_team_name had chances_value chances with high xG to get ahead in the score. ",
            },
            shotOnPostBeforeFirstGameGoalRival: {
              1: "player_name had a chance to get ahead in the score of xg_value xG that hit the post. ",
            },
            bigChancesMissedWhenLosingByOne: {
              1: "player_name had a chance of xg_value xG to tie the game with no luck. ",
            },
            moreThanOneBigChancesMissedWhenLosingByOne: {
              1: "target_team_name had chances_value chances to tie the game with a probability to score higher than 30%. ",
            },
            shotOnPostWhenLosingByOne: {
              1: "player_name had a chance of xg_value xG to tie the game that ended hitting the post. ",
            },
          }
        },
        step2: {
          table: {
            draw: "Draw",
            win: "Win",
            possession:	"Possession",
            xP:	"Expected Points",
            directness:	"Directness",
            ppda:	"PPDA",
            xA:	"xA",
            xAOpenPlay:	"xA Open Play",
            xASetPiece:	"xA Set Piece",
            chancesCreated: "Chances Created",
            shotsOnTarget: "Shots on Target"
          },
          text: {
            firstParagraph: {
              1: "This image shows the expected assists of <b style='color:home_color'>home_team_name</b> and <b>away_team_name</b>.",
            },
            xAPerKeyPass: {
              1: " xA per Key Pass. ",
            },
            keyPassesGeneratedFrom: {
              1: ", especially key passes generated from ",
            },
            highTeamXAvsXG: {
              1: "As the xA map shows, most of the danger created by target_team_name comes from combination plays rather than individual actions",
            },
            openPlay: {
              1: "open plays",
            },
            setPiece: {
              1: "set piece plays",
            },
            cornerKicks: {
              1: "corner kicks",
            },
            combinationPlays: {
              1: "combination plays",
            },
            dot: {
              1: ". ",
            },
            comma: {
              1: ", ",
            },
            averageTeamXAvsXG: {
              1: "In this game, target_team_name generated danger from both combination plays",
            },
            individualActions: {
              1: " and individual actions. ",
            },
            dangerFromIndividualActions: {
              1: "In this game, most of the danger generated by target_team_name came from individual actions.",
            },
            highTeamXAvsXGRival: {
              1: " The chances that target_team_name allowed during the game were coming from combination plays as the xA map displays.",
            },
            rivalStrongKeyPassesFrom: {
              1: " rival_team_name was strong at key passes coming from ",
            },
            manyPlayerKeyPasses: {
              1: "It is interesting to note that player_name created xa_value xA in key_passes key passes",
            },
            playerAssists: {
              1: " needing xa_per_assist xA per assist.",
            },
            giveAssist: {
              1: " to give the assist.",
            },
            noAssists: {
              1: ", although none of his passes ended up in an assist.",
            },
            highXANotManyShots: {
              1: "It is interesting to note that player_name created xa_value xA in a few passes",
            },
            manyPlayersHighXA: {
              1: "It is interesting to note that player_name and player_name2 generated xa_value and xa_value2 xA respectively.",
            },
            xATimes: {
              1: "target_team_name generated most of its danger in the first half while rival_team_name did the same in the ",
            },
            firstHalf: {
              1: " first half. ",
            },
            secondHalf: {
              1: " second half. ",
            },
            left: {
              1: "left side ",
            },
            center: {
              1: "center ",
            },
            right: {
              1: "right side ",
            },
            xAFirstHalfFirstHalfRival: {
              1: "It is a game where most of the danger in terms of Expected Goals was generated during the ",
            },
            xAFirstHalf: {
              1: "target_team_name managed to create most of the danger in the ",
            },
            xATimesXARival: {
              1: "target_team_name allowed too much danger in terms of Expected Goals in the ",
            },
            xASides: {
              1: " Most of the danger of target_team_name was produced from the side_name (xa_value <b>xA</b>)",
            },
            xASidesRival: {
              1: "while rival_team_name generated the majority of it from the side_name (xa_value <b>xA</b>)",
            },
            dangerCreationRival: {
              1: "The creation of danger of rival_team_name came, especially, from the side_name (xa_value <b>xA</b>). ",
            },
            speciallyEffective: {
              1: "target_team_name was especially effective at ",
            },
            xAPerChanceCreated: {
              1: " with an average of xa_value",
            },
            speciallyEffectiveRival: {
              1: "rival_team_name was especially effective at ",
            },
          }
        },
        step3: {
          text: {
            chance: " chance",
            chances: " chances",
            goal: " goal",
            goals: " goals",
            home: "home",
            away: "away",
            last: "last",
            first: "first",
            goalScorer: "goalscorer",
            goalScorers: "goalscorers",
            lastPhase: "Last phase of the match, ",
            phase: {
              1: "In this phase_position phase of the game, ",
              //2: "",
            },
            moreXT: {
              1: "<b style='color:more_color'>more_xt_team_name</b> generated more Expected Threat (<b style='color:more_color'>more_xt_team_value xT</b>) than <b style='color:less_color'>less_xt_team_name</b> (<b style='color:less_color'>less_xt_team_value xT</b>)",
              //2: "",
            },
            sameTeamMoreMinutes: {
              1: "and did it for more minutes in this period (<b style='color:more_color'>more_time_xt_minutes mins.</b> vs <b style='color:less_color'>less_time_xt_minutes mins.</b> of the opponent)",
              //2: "",
            },
            rivalTeamMoreMinutes: {
              1: "however, it was his opponent who generated danger for longer (<b style='color:more_color'>more_time_xt_minutes mins.</b> vs <b style='color:less_color'>less_time_xt_minutes mins.</b> of the opponent) in this period of the game",
              //2: "",
            },
            maxXTValue: {
              1: "<b style='color:max_color'>max_xt_team_name</b> was the team that created the most danger (<b style='color:max_color'>max_xt_team_value xT</b>) at <b style='color:max_color'>max_xt_team_minute'</b>",
              //2: "",
            },
            maxXTValueRival:{
              1: ", while the <b style='color:max_rival_color'>max_xt_rival_team_name</b> generated their most danger (<b style='color:max_rival_color'>max_xt_rival_team_value xT</b>) at <b style='color:max_rival_color'>max_xt_rival_team_minute'</b>",
            },
            bothTeamsScoreButDraw: {
              1: "Both teams have managed to beat the opposing goalkeeper in <b>number_of_goals_each_team</b> each one. The home team through <b style='color:#3366FF'>home_player_name_goals</b> and the away team through <b>away_player_name_goals</b>",
              //2: "",
            },
            oneTeamTakesTheLead: {
              1: "In terms of goals, <b style='color:replace_color'>goal_scored_team_name</b> outperformed the opponent by <b style='color:replace_color'>difference_number_of_goals</b> of difference as they beat their goalkeeper with <b style='color:replace_color'>home_player_name_goals</b> as goal_scorer_word",
              //2: "",
            },
          }
        },
        step4: {
          table: {
            team: "Team",
            period: "Period",
            possession:	"Poss.",
            ppda:	"PPDA",
            xGOpenPlay:	"xG OP",
            tooltip: {
              team: "Team",
              period: "Period",
              possession:	"Possession",
              ppda:	"Conceded Passes per Defensive Action",
              xGOpenPlay:	"xG Open Play",
            }
          },
          text: {
            clearly: "clearly",
            very: "very ",
            haveGotText1: "only got",
            haveGotText2: "should have gotten more than",
            gaveUpPoss: "gave up the possession",
            lostPoss: "lost the possession of the ball",
            too: "too ",
            possession: {
              1: "During this phase of the game <b style='color:team_color'>team_name</b> clearly_text controlled the possession of the ball",
            },
            equalPossession: {
              1: "In this phase of the match, no one dominated the other as the ball handling was quite balanced, although looking at the numbers, <b style='color:team_color'>team_name</b> slightly outplayed their opponents with a <b style='color:team_color'>possession_value%</b> of possession",
            },
            lowPossessionHighPPDA: {
              1: ". <b style='color:target_team_color'>target_team_name</b> with a bad ball pressure allowed <b style='color:rival_team_color'>rival_team_name</b> to give <b style='color:target_team_color'>ppda_value Passes per Defensive Action</b>",
            },
            lowPossessionLowPPDA: {
              1: ", but <b style='color:target_team_color'>target_team_name</b> did good at pressing the ball when rival_team_name had the possession, with a <b>PPDA</b> of <b>ppda_value</b>",
            },
            highPossessionLowPPDA: {
              1: " and was able to play due to a very_textlow pressing intensity from rival_team_name",
            },
            highPossessionHighPPDA: {
              1: " although the pressing intensity of rival_team_name was very_texthigh",
            },
            highPossessionHighPFT: {
              1: "<b style='color:target_team_color'>target_team_name</b> seized a high possession giving <b>pft_value</b> <b>Passes in the Final Third</b> of the pitch. ",
            },
            highPossessionMidLowPFT: {
              1: "Regardless of the high possession, <b style='color:target_team_color'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passes in the Final Third</b>. ",
            },
            lowPossessionHighPFT: {
              1: "Although <b style='color:target_team_color'>target_team_name</b> possession_text during this phase, it was able to give <b>pft_value</b> <b>Passes in the Final Third</b>. ",
            },
            midPossessionHighPFT: {
              1: "A quite even possession during this phase didn't stop <b style='color:target_team_color'>target_team_name</b> from giving <b>pft_value</b> <b>Passes in the Final Third</b>. ",
            },
            highPFTHighTouchesIOB: {
              1: " Apart from controlling the game in the final third, <b style='color:target_team_color'>target_team_name</b> also had a lot of presence in the opponent box. ",
            },
            highPFTLowTouchesIOB: {
              1: "<b style='color:target_team_color'>target_team_name</b> did control the ball in the final third, but could not get many balls into the opponent box",
            },
            highPFTMidTouchesIOB: {
              1: "Given the number of <b>Passes in the Final Third</b>, <b style='color:target_team_color'>target_team_name</b> should have created more danger in the opponent box",
            },
            lowPFTHighTouchesIOB: {
              1: "Although <b style='color:target_team_color'>target_team_name</b> did not complete many passes in the final third, it was able to reach the opponent box many times. ",
            },
            midPFTHighTouchesIOB: {
              1: "Given the number of passes completed in the final third, <b style='color:target_team_color'>target_team_name</b> achieved to reach the opponent box many times. ",
            },
            maxDirectness: {
              1: "It is worth to point out that this is the phase of the game when <b style='color:max_dir_color'>target_team_name</b> played more offensively with a <b>Directness</b> of <b>directness_value</b>. ",
            },
            maxXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> was able to generate more xG than in other phases of the game ",
            },
            highXGFifthQuintile: {
              1: " <b style='color:target_team_color'>target_team_name</b> managed to generate a high volume of Expected Goals",
            },
            highXG: {
              1: "generated a good volume of Expected Goals",
            },
            highXGLowPossession: {
              1: " in spite of not having the control of the ball",
            },
            highXGLowShots: {
              1: " only in a few shots, having a <b>xG per Shot</b> of <b>xg_per_shot_value</b>",
            },
            highXGLowXGPerShot: {
              1: " though the xG per Shot was too_textlow. ",
            },
            lowXGZeroXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> was not able to generate any danger to the opponent",
            },
            lowXGMinXG: {
              1: "In terms of generation of Expected Goals, this was a poor stage for <b style='color:target_team_color'>target_team_name</b>",
            },
            lowXGFirstQuintileXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> generated a very low volume of Expected Goals",
            },
            lowXGSecondQuintileXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> was not able to generate a good volume of Expected Goals",
            },
            lowXGHighPossession: {
              1: " even though they had the control of the ball. ",
            },
            lowXGHighShots: {
              1: " in spite of shooting many times",
            },
            lowXGHighPFT: {
              1: " in spite of completing <b>pft_value</b> <b>Passes in the Final Third</b> of the pitch. ",
            },
            midXGQuintileMinXG: {
              1: "Although the generation of xG wasn't bad, this was the weakest phase of the game for <b style='color:target_team_color'>target_team_name</b> in that regard",
            },
            midXGQuintileMaxXG: {
              1: "This was the phase during which <b style='color:target_team_color'>target_team_name</b> was able to generate the highest <b>xG (xg_value)</b>",
            },
          }
        },
        step5: {
          table: {
            team: "Team",
            period: "Period",
            possession:	"Poss.",
            directness:	"Dir.",
            passesFinalThird:	"PF ⅓",
            tooltip: {
              team: "Team",
              period: "Period",
              possession:	"Possession",
              directness:	"Directness",
              passesFinalThird:	"Passes Final Third",
            }
          },
          text: {
            last: "last",
            goal: "goal",
            goals: "goals",
            chance: "chance",
            chances: "chances",
            first: "first",
            homeTeam: "home team",
            awayTeam: "away team",
            home: "home",
            away: "away",
            clearly: "clearly",
            slightly: "slightly",
            firstOrLastPhase: {
              1: "In this phase_position phase of the game, ",
              2: "On the phase_position period of the match, ",
            },
            phase: {
              1: "During this period of the match, ",
              //2: "",
            },
            bothZeroGoalsScored: {
              1: "without either team being able to change the scoreboard.",
            },
            equalGoalsScored: {
              1: "getting to score <b>number_goals</b>",
            },
            differentGoalsScored: {
              1: "getting to score <b>number_goals</b>",
            },
            equalPossesion: {
              1: "both teams had the ball exactly <b>poss_value%</b> of the time",
            },
            morePossesion: {
              1: "<b style='color:more_color'>more_poss_team_name</b> had the ball for more minutes (<b style='color:more_color'>more_poss_team_value%</b> of the time) than his opponent <b style='color:less_color'>less_poss_team_name</b> (<b style='color:less_color'>less_poss_team_value%</b> of the time)",
            },
            equalDirectness: {
              1: "both teams played the game with the same directness (<b>directness_value</b> each one)",
            },
            //Same team with more possession and more directness than his rival
            moreDirectnessSameTeam: {
              1: "they also were more vertical than their opponents, playing the game with a directness of <b style='color:more_color'>more_dir_team_value</b> vs <b style='color:less_color'>less_dir_team_value</b>",
            },
            //One team with more possession and one with more directness
            moreDirectnessDifferentTeam: {
              1: "however, it was the home_away team who played with more directness (<b style='color:more_color'>more_dir_team_value</b>) than his opponent (<b style='color:less_color'>less_dir_team_value</b>)",
            },
            equalChancesCreated: {
              1: "Both teams created the same number of chances, exactly <b>chances_created_value</b> chance_text.",
            },
            moreChancesCreated: {
              1: "<b style='color:less_color'>less_cc_team_name</b> created only <b style='color:less_color'>less_cc_team_value less_chance_text</b> and was adverb_text outperformed by the opponent (<b style='color:more_color'>more_cc_team_value more_chance_text created</b>). ",
            },
            equalXA: {
              1: "Both teams had equal opportunities, as reflected in the <b>xa_value of Expected Assists</b>, ",
            },
            moreXA: {
              1: "The home_away team generated <b>diff_xa_team_value Expected Assists</b> (<b style='color:more_color'>more_xa_team_value</b> versus <b style='color:less_color'>less_xa_team_value</b>) more than the opponent, ",
            },
            xAOpenPlay: {
              1: "creating, respectively, <b style='color:more_color'>more_xa_op_value</b> and <b style='color:less_color'>less_xa_op_value xA Open Play</b>.",
            },
          }
        },
        step6: {
          text: {
            eachOne: " each one ",
            respectively: ", respectively",
            with: " (with <b style='color:replace_color'>other_player_name</b>)",
            playerWas: "player was",
            playerWere: "players were",
            firstPhase: {
              1: "In this first part of the match, the most important player_text ",
              2: "As for the first part of the game, who stood out was ",
            },
            otherPhase: {
              1: "Between <b style='color:replace_color'>min_from'</b> and <b style='color:replace_color'>min_to'</b> should be mentioned ",
            },
            lastPhase: {
              1: "In the last part of the game, mention to ",
              2: "As for the last phase of the match, ",
            },
            playerMaxSuccessfullPasses: {
              1: "<b style='color:replace_color'>player_name</b> as he performed the highest number of successful passes of his team, exactly <b style='color:replace_color'>successfull_passes_value passes</b> ",
            },
            playerMaxTotalPasses: {
              1: "which becomes even more valuable when the figures show that he also was",
            },
            playerMaxTotalPasses2: {
              1: "with_text the player with the most attempted passes (<b style='color:replace_color'>total_passes_value passes</b>). ",
            },
            //Just one player with max successfull passes
            playerNotMaxTotalPasses: {
              1: "although he did not attempt the most passes (<b style='color:replace_color'>player_name</b> with <b style='color:replace_color'>total_passes_value passes</b>). ",
            },
            //More than one player with max successfull passes
            playersMaxSuccessfullPassesTotalPasses: {
              1: "trying during this period <b style='color:replace_color'>total_passes_value passes</b> each one. ",
            },
            playerMaxPctPasses: {
              1: "In terms of <b style='color:replace_color'>% Passes Completed</b>, <b style='color:replace_color'>player_name</b> has a high <b style='color:replace_color'>max_pct_passes_value%</b>. ",
              2: "In reference to pass success rate, it is worth mentioning <b style='color:replace_color'>player_name</b> with a <b style='color:replace_color'>max_pct_passes_value%</b> pass success rate</b>. ",
            },
            playerSumTotalXG: {
              1: "In this time window, the team generated a total of <b style='color:replace_color'>sum_xg_value xG</b>, ",
              2: "During this period, <b style='color:replace_color'>team_name</b> created a <b style='color:replace_color'>xG</b> of <b style='color:replace_color'>sum_xg_value</b>, ",
            },
            ZeroSumXG: {
              1: "Despite making a total of <b style='color:replace_color'>all_team_total_passes</b> between the whole team, it was in vain as they failed to create a single chance. ",
              2: "The <b style='color:replace_color'>all_team_total_passes</b> made in this period did not generate a single scoring chance. ",
            },
            playerMaxXGMaxXADiffPlayer: {
              1: "with <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> and <b style='color:replace_color'>player_xa_name</b> with <b style='color:replace_color'>xa_value xA</b> being the most dangerous players in terms of creating chances. ",
            },
            playerMaxXGMaxXASamePlayer: {
              1: "being <b style='color:replace_color'>player_name</b> with <b style='color:replace_color'>xg_value xG</b> and <b style='color:replace_color'>xa_value xA</b> the originator of most of his team's chances. ",
            },
            playersMaxXGMaxXA: {
              1: "thanks among others to <b style='color:replace_color'>players_name</b> who triggered <b style='color:replace_color'>xa_value xA</b> each with their key passes. ",
            },
            //Just one player with max xG
            playerMaxXGZeroXA: {
              1: "being <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> who had the full weight of the chances, having to create them on his own as he did not receive any key passes. ",
            },
            //More than one player with max xG
            playersMaxXGZeroXA: {
              1: "being <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> who had the chances, having to create them on their own as they did not receive any key passes. ",
            },
            oneMaxConnections: {
              1: "The pair that made the most passes between them during this stretch of the match was <b style='color:replace_color'>couple_name</b>, with a total of <b style='color:replace_color'>connections_value passes</b>. ",
              2: "The duo formed by <b style='color:replace_color'>couple_name</b> exchanged <b style='color:replace_color'>connections_value</b> times the ball. ",
              3: "The <b style='color:replace_color'>couple_name</b> duo were the ones who passed the ball the most in this stretch of the match, doing so even on <b style='color:replace_color'>connections_value</b> chances. ",
            },
            twoMaxConnections: {
              1: "The two pairs formed by <b style='color:replace_color'>couple_name</b> and <b style='color:replace_color'>couple_name2</b> were the most repeated connections for this period, passing the ball to each other <b style='color:replace_color'>connections_value</b> times. ",
            },
            moreThanTwoMaxConnections: {
              1: "The pairs of players, such as <b style='color:replace_color'>couple_name</b>, made <b style='color:replace_color'>connections_value passes</b> to each other. ",
            },
            oneMinConnections: {
              1: "On the other hand, it was <b style='color:replace_color'>couple_name</b> who passed the ball to each other the least, only <b style='color:replace_color'>connections_value passes</b>. ",
              2: "At the other extreme, the tandem composed by <b style='color:replace_color'>couple_name</b> only connected <b style='color:replace_color'>connections_value</b> times. ",
            },
            twoMinConnections: {
              1: "On the other hand, <b style='color:replace_color'>couple_name</b> and <b style='color:replace_color'>couple_name2</b> barely exchanged passes between them (<b style='color:replace_color'>connections_value passes</b>). ",
            },
            moreThanTwoMinConnections: {
              1: "Several combinations did not connect enough, such as the <b style='color:replace_color'>couple_name</b> duo, which with <b style='color:replace_color'>connections_value passes</b> are among the least common combinations. ",
            },
          },
        },
      },
      gamePossessionMap: {
        of: "of",
        to: "to",
        and: "and",
        endsWith: "Ends with",
        time: "Time",
        touches: "Touches",
        passes: "Passes",
        threat: "Threat",
        xG: "xG",
        xT: "xT",
        minutes: "Minutes",
        duration: "Duration",
        endsGoal: "Ends Goal",
        endsInBox: "Ends in Box",
        withShot: "With Shot",
        withCross: "With Cross",
        possession: "Possession",
        events: "Events",
        filters: "Filters",
        filtersWarning: "Threat only applies to possessions without shots",
        show: "Show",
        sequenceNumbers: "Sequence Number",
        jerseyNumbers: "Jersey",
        pass: "Pass",
        carryAndPass: "Carry & Pass",
        carryAndAction: "Carry & Action",
        carryAndShot: "Carry & Shot",
        shotFailed: "Failed Shot",
        goal: "Goal",
        savedShot: "Saved Shot",
        missedShot: "Missed Shot",
        shotOnPost: "Shot on Post",
        headerGoal: "Header Goal",
        headerFailed: "Header Failed",
        failed: "failed"
      },
      report: {
        title: "Game Report",
        maps: "Maps",
        xGRace: "xG Race",
        lineups: "Lineups",
        button: "Generate a full PDF report of the game",
        mobileButton: "PDF report",
        most: "Most",
        topXPlayers: "Top {x} Players",
      }
    },
    general: {
      create: "Create",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      go: "Go",
      formErrors: {
        required: "Field is required",
        passwordMatch: "Password doesnt match",
        minLength: "Minimum length",
        maxLength: "Maximum length",
        emailValid: "E-mail must be valid",
        youthAge: "Age must be between 10 and 23",
        seasonYear: "Year must be between 2016 and 2050",
      },
      confirmationTitle: "Are you sure?",
      confirmationMessage: "Please confirm if you want to perform the action",
      yes: "Yes",
      no: "No",
      1: "One",
      2: "Two",
      3: "Three",
      4: "Four",
      5: "Five",
      search: "Search",
      clearFilters: "Clear filters",
      minimum: "Minimum",
      maximum: "Maximum",
      minimumPercent: "(%)Minimum Percent",
      period: "Period",
      exclude: "Exclude",
      team: "Team",
      clear: "Clear",
      all: "All",
      ground1: "All",
      ground2: "Home",
      ground3: "Away",
      filter: "Filter",
      noData: "No results found",
      noDataGivenFilters: "No results found with given filters",
      similarityNoData: "is not included on Similarity tool",
      similarityMinutesWarning: "No data due to less than 450 minutes played",
      close: "Close",
      load: "Load",
      filters: "Filters",
      players: "players",
      teams: "teams",
      compare: "Compare",
      seeMore: "See more",
      seeLess: "See less",
      request: "Request",
      notes: "Notes",
      closeSession: "Exit",
      settings: "Settings",
      player: "Player",
      state: "State",
      updated: "Updated",
      file: "File",
      uploadFile: "Upload file",
      reports: "Reports",
      download: "Download",
      new: "New",
      comparison: "Comparison",
      scout: "Scout",
      favorites: "Favorites",
      moreOptions: "More options",
      lessOptions: "Less options",
      today: "Today",
      home: "Home",
      away: "Away",
      until: "until",
      firstHalf: "First Half",
      secondHalf: "Second Half",
      firstPeriodOT: "First H. OT",
      secondPeriodOT: "Second H. OT",
      postponed: "Postponed",
      stats: "Stats",
      yesterday: "Yesterday",
      today: "Today",
      last: "Last",
      startDate: "Start Date",
      active: "Active",
      playerLimit: "Players Limit",
      type: "Type",
      successMessage: "The operation has been a success",
      failMessage: "The operation has failed",
      by: "By",
      checkYourInbox: "Check your inbox",
      faq: "Glossary",
      globalSearch: "Global Search",
      gamesLost:"Games Lost",
      outOf:"out of",
      avgSeason:"Season Avg.",
      leftDays: "remaining days",
      notifyError:"Notify Error",
      notify:"Notify",
      comments:"Comments",
      searches:"Searches",
      now:"Now",
      twoHoursAgo:"Two hours ago",
      incomings:"Arrivals",
      departures:"Departures",
      transferLoans:"Loans",
      transfers:"Transfers",
      movements:"Movements",
      incomes:"Incomes",
      expenditures:"Expenditures",
      action: "Action",
      target:"Target",
      uses:"Uses",
      users:"Users",
      since:"since",
      mediaMode:"Media Mode",
      white:"White",
      enabled:"Enabled",
      disabled:"Disabled",
      left:"Left",
      right:"Right",
      both:"Both",
      'left-both': 'Left Both',
      'right-both': 'Right Both',
      'left foot': 'Left',
      'right foot': 'Right',
      files:"Files",
      confirm:"Confirm",
      currentStep: "Current Step",
      phases: "Phases",
      entries:"Entries",
      none:"None",
      times: "times",
      darkMode: "Dark Mode",
      client:"Client",
      visits:"Visits",
      lastVisit:"Last Visit",
      strong: "Strong",
      medium: "Medium",
      weak:"Weak",
      goal:"Goal",
      list:"List",
      map:"Map",
      copiedToClipboard:"Copied to clipboard",
      division:"Division",
      many:"Many",
      few:"Few",
      median:"Median",
      topRight: "Top Right",
      topLeft: "Top Left",
      bottomRight: "Bottom Right",
      bottomLeft: "Bottom Left",
      library: "Library",
      mediaLibrary: "Media Library",
      for:"For",
      stat:"Stat",
      position:"Position",
      order:"Order",
      add:"Add",
      visualization: "Visualization",
      basic:"Basic",
      selectAll: "Select All",
      unselectAll: "Unselect All",
      distribution: "Distribution",
      end:"End",
      accuracy: "accuracy",
      opponent: "Opponent",
      center:"Center",
      line: "Line",
      live: "Live",
      unavailable: "unavailable",
      calendar: "Calendar",
      activeLeague:"League in Progress",
      similarity:"Similarity",
      emptyForSelectAll:"Empty select all",
      size:"Size",
      selectPlayersRestriction:"Select between 1 and {x} players",
      group:"Group",
      alerts:"Alerts",
      shortcuts:"Shortcuts",
      share:"Share",
      dataAvailable: "Data will be available soon",
      someStatsAvailableSoon: "Some stats will be available soon",
      monthGamesWarning: 'Games of selected month will be available soon',
      metrics: "Metrics",
      competition:"Competition",
      code:"Code",
      alias:"Alias",
      never: "Never",
      unlimited: "Unlimited",
      user: "User",
      warning: "Warning",
      requests: "Requests",
      contactSales: "Contact Sales",
      comingSoon: "Coming Soon!",
      firstPost: '1st Post',
      secondPost: '2nd Post',
      dZone: 'D Zone',
      penaltySpot: 'Penalty Spot',
      secondPlay: '2nd Play',
      otherZone: 'Other Zone',
      baseline: 'Baseline',
      youth:"Youth",
      male:"Male",
      direct: 'Direct',
      indirect: 'Indirect',
      processing: "Processing",
      addNew: "Add New",
      createdBy: "Created by",
      downloading: "Downloading",
      displayType: "Display Type",
      alreadyExists: 'already exists',
      aggregation:"Aggregation",
      unavailableLeagues: 'You do not have access to any of the leagues in which the player has played',
      meters:"Meters",
      quantity:"Quantity",
      allTime:"All Times",
      games:"Games",
      unit: "Unit",
      categories: "Categories"
    },
    playerScout: {
      dlabDatabase: "Driblab Database",
      league: "League",
      top5: "Top 5",
      topCountries: "Countries",
      tier: "Tier",
      division1: "First Division",
      division2: "Second Division",
      division3: "Third Division",
      division4: "Fourth Division",
      division5: "Fifth Division",
      summary: "Summary",
      offensive: "Off",
      defensive: "Def",
      gk: "GK",
      all: "All",
      physical: "Phys",
      arrigo: "Arrigo",
      yearTooltip: "Only one year allowed",
      expectedThreat: "xThreat",
      expectedThreatTooltip: "Threat added to all possessions",
      expectedThreatOP: "xThreat OP",
      expectedThreatOPTooltip: "Threat added to Open Play possessions",
      expectedThreatInTeam: "xThreat in Team %",
      expectedThreatInTeamTooltip: "Pct. of Threat added by player to the team",
      ballProgression: "Ball Progression",
      ballProgressionTooltip: "Progressions of +10 meters",
      deepProgression: "Deep Progressions",
      deepProgressionTooltip: "Ball Progressions to Last Fifth",
      ballRetention: "% Ball Retention",
      ballRetentionTooltip: "Percentage of Actions where Ball was Successfully Retained",
      ballRetentionOppHalf: "% Ball Retention OH",
      ballRetentionOppHalfExplicit: "Percentage of the time you have possession of the ball and don't end up losing it in the opponent half",
      finishing: "Finishing",
      finishingTooltip: "Pct. of Shots Ending in a Goal",
      scoringContribution: "Scoring Contribution",
      scoringContributionTooltip: "Assists + Goals",
      xgPerShot: "xG per Shot",
      xgPerGoal: "xG per Goal",
      headerPerCross: "Header per Cross",
      completedCrosses: "Completed Crosses",
      crossingPct: "% Crossing",
      crossingEfficiency: "Crossing Efficiency",
      crossingEfficiencyTooltip: "Crossing Efficiency (Measures Quality and Quantity)",
      longBalls: "Long Balls",
      longPassing: "% Long Ball",
      dribblingPct: "% Dribbling",
      throughBalls: "Through Balls",
      oppBoxTouches: "Opp. Box Touches",
      oppBoxTouchesTooltip: "Touches in Opponent Box",
      openPlayKeyPasses: "OP Key Passes",
      openPlayKeyPassesTooltip: "Open Play Passes ending in Shot",
      xGBuildup: "xG Buildup",
      xGBuildupTooltip: "xG of sequences ending in shot where the player was involved (excluding xG of shot and key pass)",
      Assists: "Assists",
      passPercentage: "% Passing",
      passPerLongBall: "Pass per LB",
      passPerLongBallExplicit: "Pass per Long Ball",
      nonPenaltyGoals: "Non-Penalty Goals",
      xG: "xG",
      xGExplicit: "Expected Goals",
      shots: "Shots",
      xGShot: "xG per Shot",
      xGChain: "xG Chain",
      xGChainTooltip: "xG of sequences ending in shot where the player was involved",
      chancesCreated: "Passes followed by a Shot",
      chances: "Chances",
      dribbles: "Dribbles",
      dribblesSuccessfull: "Dribbles Succesfull",
      touches: "Touches in Opponent Box",
      xA: "xA",
      xAExplicit: "Expected Assists",
      xAOpenPlay: "xA OP",
      xAOpenPlayExplicit: "Expected Assists Open Play",
      passesOpponentBox: "Passes in Opponent Box",
      passesOB: "Passes in OB",
      passesFinalThird: "Passes Final ⅓",
      passesFinalThirdTooltip: "Passes Final Third",
      passesSuccessful: "Passes Succ.",
      passesSuccessfulTooltip: "Passes Successful",
      ballProgressionPassing: "BP by Passing",
      ballProgressionPassingTooltip: "Ball Progression by Passing",
      ballProgressionDribbling: "BP by Carrying",
      ballProgressionDribblingTooltip: "Ball Progression by Carrying",
      passesTotal: "Passes",
      passesTotalTooltip: "Total of Passes Attempted",
      shortPassesSuccessful: "Succ. SP",
      shortPassesSuccessfulTooltip: "Number of Short Passes Completed",
      shortPassesTotal: "Total SP",
      shortPassesTotalTooltip: "Number of Short Passes Attempted",
      tackles: "Tackles *",
      adjustedTackles: "Tackles adjusted to Possession",
      interceptions: "Interceptions *",
      adjustedInterceptions: "Interceptions adjusted to Possession",
      aerials: "Aerial Duels",
      aerialsPercent: "% Aerials",
      aerialEfficiency: "Aerial Eff.",
      aerialEfficiencyTooltip: "Aerial Efficiency (Measures Quality and Quantity)",
      twd: "TwD",
      tacklesWasDribbled: "Tackles was Dribbled",
      fouls: "Fouls",
      indPressure: "Individual Pressure",
      pressure: "Pressure",
      dispossessed: "Dispossessed",
      recoveries: "Recoveries",
      primary: "Primary",
      secondary: "Secondary",
      position: "Position",
      nationality: "Nationality",
      height: "Height (cm)",
      minHeight: "Min. Height",
      maxHeight: "Max. Height",
      age: "Age",
      minAge: "Min. Age",
      maxAge: "Max. Age",
      games: "Games",
      minGames: "Min. Games",
      maxGames: "Max. Games",
      minutes: "Minutes",
      minMinutes: "Min. Minutes",
      maxMinutes: "Max. Minutes",
      minPercentMinutes: "Min. Percent Minutes",
      dates: "Dates",
      marketValue: "(€) Market Value",
      teams: "Teams",
      contractEnd: "Contract End",
      minValue: "Min. Value",
      maxValue: "Max. Value",
      excludeTeams: "Exclude Teams",
      recentSearches: "Recent searches",
      saveSearch: "Save search",
      loadSearch: "Load search",
      search: "Search",
      searchesList: "Search lists",
      mySearches: "My searches",
      mySearchesDescription: "That ones you saved previously",
      recentSearchesDescription: "Last 10 searches you did",
      searchToLoad: "Search to load",
      recentSearch: "Recent search",
      saveSearchSuccess: "Search saved successfully",
      removeSearch: "Delete search",
      removeSearchMessage: "Are you sure you want to delete the search?",
      deleteSearchSuccess: "Search has been deleted",
      playersFound: "players found",
      addToCollection: "Add to collection",
      npg: "NPG",
      goals: "Goals",
      value: "Value",
      nationalTeams:"National Teams",
      gbeScore: "GBE",
      dlIndex: "Score",
      minGbe: "Min. GBE",
      goalsConceded: "Goals Conceded",
      npgConceded: "NPG Conceded",
      npgConcededTooltip: "Non-Penalty Goals Conceded",
      xGOTConceded: "xG On Target Conceded",
      xGOTConcededTooltip: "xG of Shots Received on Target",
      goalsPrevented: "Goals Prevented",
      xGFacedPerShotOnTarget: "xGOT per Shot",
      xGFacedPerShotOnTargetTooltip: "xG on Target per Shot conceded",
      xGSavedPerxGFacedOnTarget: "xG Saving",
      xGSavedPerxGFacedOnTargetTooltip: "Percentage of Saving taking xG into account",
      savesPct: "% Saving",
      savesOutOfBoxPct: "% Saving Out of Box",
      savesInBoxPct: "% Saving In Box",
      xGFacedPerGoal: "xG Faced per Goal",
      xGFacedPerGoalTooltip: "xG Needed to Score a Goal",
      catchingPct: "% Catching",
      catchingTooltip: "Pct. of Saves Caught",
      passingOwnHalfPct: "% Passing Own Half",
      passingOwnHalfPctTooltip: "Percentage of Successful Passes in Own Half",
      passingOppHalfPct: "% Passing Opp. Half",
      passingOppHalfPctTooltip: "Percentage of Successful Passes in Opponent Half",
      passingContribution: "% Passing Cont.",
      passingContributionTooltip: "Contribution of Threat by Passing the Ball - Above Average",
      shotsPerGoal: "Shots per Goal",
      passesFinalThird: "Passes Final ⅓",
      passingFinalThird: "% Passing Final ⅓",
      claimAccuracy: "Claim Accuracy",
      claimAccuracyTooltip: "Balls Claimed above Average",
      highTurnovers: "High Turnovers",
      highTurnoversTooltip: "Turnovers closer than 40 meters to goal",
      shotEndingHighTurnovers: "Shot Ending HT",
      shotEndingHighTurnoversTooltip: "Shot Ending High Turnovers",
      goalEndingHighTurnovers: "Goal Ending HT",
      goalEndingHighTurnoversTooltip: "Goal Ending High Turnovers",
      avgCarriesProgress: "Average Progress",
      avgCarriesProgressTooltip: "Average distance moving the ball vertically (meters)",
      carriesChance: "Chance Ending",
      carriesChanceTooltip: "Carries followed by a Key Pass",
      carriesAssist: "Assist Ending",
      carriesAssistTooltip: "Carries followed by an Assist",
      carriesShot: "Shot Ending",
      carriesShotTooltip: "Carries followed by a Shot",
      carriesGoal: "Goal Ending",
      carriesGoalTooltip: "Carries followed by a Goal",
      shotEndingSequence: "Shot Ending",
      shotEndingSequenceTooltip: "Number of Sequences ending in a Shot where the player was involved",
      goalEndingSequence: "Goal Ending",
      goalEndingSequenceTooltip: "Number of Sequences ending in a Goal where the player was involved",
      gbeScoreTooltip: "FA Football's Governing Body Endorsement",
      goalsPreventedTooltip: "Non-Penalty Goals saved by Goalkeeper (xG Faced - NPG Conceded)",
      freePlayers:"Free Players",
      index:"Index",
      playerName:"Name",
      teamName:"Team",
      secondPos:"Second Pos.",
      side:"Side",
      dob:"Birth",
      countryName:"Country",
      secondCountryName:"Second Country",
      leagueName:"League",
      seasonYear:"Season",
      assists:"Assists",
      placeholder: "You can start adding some league filters",
      placeholder2: "Click search button to show results",
      passesPct:"% Passes",
      passingPct:"% Passes",
      oppBoxPasses:"Passes in Opp. Box",
      adjustedClearances:"Adjusted Clearances",
      aerialsPct:"% Aerials",
      leagueCountryCode:"League Country Code",
      shooting:"% Shots on Target",
      xtPassing:"xT Passing",
      xtPassingTooltip:"Threat added by passing",
      xtDribbling:"xT Carries",
      xtDribblingTooltip:"Threat added by carrying",
      foot: "Strong Foot",
      aggressiveActions: "Aggressive Actions",
      aggressiveActionsTooltip: "Number of tackles attempted in the next two seconds after losing the possession",
      tacklesAttempted: "Total Tackles Attempted",
      highDefensiveActionPct: "% HD Actions",
      highDefensiveActionPctTooltip: "Percentage of Defensive Actions made 40 meters close to the opponent goal",
      individualPressureOppHalf: "Pressure Opp. Half",
      individualPressureOppHalfTooltip: "Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent in the opponent half",
      xGBuildUp5Pass: "xG Buildup 5p",
      xGBuildUp5PassTooltip: "Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)",
      chancesCreatedOpenPlay: "Chances Created OP",
      chancesCreatedOpenPlayTooltip: "Number of passes leading to a shot during open play",
      fmf:{
        "Defender":"Defender",
        "aerial":"Aerial",
        "goodDefender": "Good Defender",
        "goodPresence": "Good Presence",
        "playmaking": "Playmaking",
        "Fullback":"Fullback",
        "defensiveness":"Defensiveness",
        "offensiveness":"Offensiveness",
        "fast":"Fast",
        "Forward":"Forward",
        "goalChances":"Goal Chances",
        "goodDecissions":"Good Decissions",
        "individualTechnique":"Individual Technique",
        "Goalkeeper":"Goalkeeper",
        "footWork":"Footwork",
        "leadership":"Leadership",
        "Midfielder":"Defensive Midfielder",
        "balance":"Balance",
        "ballRetention":"% Ball Retention",
        "offensivePasses":"Offensive Passes",
        "recoveries":"Recoveries",
        "shotToGoal":"Shot to Goal",
        "Attacking-Midfielder":"Attacking Midfielder",
        "defensiveGame":"Defensive Game",
        "offensiveGame":"Offensive Game",
        "Winger":"Winger",
        "crossing":"Crossing",
        "deepProgressions":"Deep Progressions",
        "defendingEffort":"Defending Effort",
        "facing":"Facing"
      },
      yellowCards:"Yellow Cards",
      redCards: "Red Cards",
      alert:"Alert",
      yearOfBirth: "Year of Birth",
      minYearOfBirth: "Min. Year of Birth",
      maxYearOfBirth: "Max. Year of Birth",
      women: "Women",
      continental: "Continental",
      countryCup: "Country Cup",
      statsName: "Stat name",
      abbreviation: "Abbreviation",
    },
    playerComparison: {
      upTo5Players: "Compare up to 5 players",
      requestReport: "Request report",
      searchBarPlaceholder: "To compare a player, search and select it",
      allStats: "All Stats",
      placeholder: "You can start adding some players"
    },
    reports: {
      detailedInsights: "Get Detailed Insights",
      features: "Features of the report",
      performance: "Performance",
      evolution: "Evolution",
      compareWithMyTeam: "Compare with my team",
      similarPlayers: "Similar Players",
      potentialTeams: "Potential Teams",
      requestSuccess: "Request sent successfully",
      requestAt: "Requested",
      reportConversation:"Report Conversation",
      writeYourMessage:"Write your message...",
      you:"You"
    },
    state: {
      requested: "Requested",
      inProgress: "In progress",
      delivered: "Delivered",
    },
    langs: {
      es: "Spanish",
      en: "English",
      fr: "French",
      de: "German",
      it: "Italian",
      pt: "Portuguese",
      tr: "Turkish",
      jp: "Japanese",
      cn: "Chinese",
      sa: "Arabic"
    },
    inbox: {
      subtitle: "Stay updated",
      new_injury_alert:"New Injury Alert",
      new_contract_alert:"New Contract Alert",
      new_team_alert:"New Signing Alert",
      new_marketValue_alert:"New Market Value Alert",
      new_game_alert:"New Game Played Alert",
      receive_mail: "Receive Mail",
      receive_mail_subtitle: "Receive Daily Mail with players that meet filters",
      receive_notifications: "Notifications",
      receive_notifications_subtitle: "Receive Notifications in the app with players that meet filters",
      changedTo: "Changed to",
      alerts: "Alerts",
      includedIn: "Included in",
      noContract: "No Contract",
      newMessages:"New Messages",
      reply: {
        reply: "Reply",
        replyTitle: "Give feedback to the client:",
        replyPlaceholder: "The user will receive the reply along with the status update"
      }
    },
    gameAnalysis: {
      subtitle: "Get insights from the latests matches",
      subtitle2: "Showing Games in next seven days",
      subtitle3: "Get insights from the latests matches and explore the next ones",
      seeDetail: "See details"
    },
    statsNaming: {
      Possession: 'Possession',
      TimePossession: 'Time Possession',
      PassesPerShots: 'Passes per Shot',
      PPDA: 'PPDA',
      ExpectedPoints: 'Expected Points',
      Points: 'Points',
      Directness: 'Directness',
      PassesPerLongBall: 'Passes per Long Ball',
      CrossingPerXG: 'Crosses per xG',
      PenaltySavedPenaltyFaced: 'Penalty Saved/Penalty Faced',
      Goals: "Goals",
      NonPenaltyGoals: 'Non-Penalty Goals',
      NPGOpenPlay: "NPG Open Play",
      NPGSetPiece: "NPG Set Piece",
      Shooting: 'Shooting',
      Finishing: 'Finishing',
      xGEfficiency: 'xG Efficiency',
      HeaderPerShot: 'Header per Shot',
      HeaderPerCross: 'Header per Cross',
      Assists: 'Assists',
      ThroughBalls: 'Through Balls',
      CrossEfficiency: 'Cross Efficiency',
      ScoringContribution: 'Scoring Contribution',
      xAssistsOpenPlay: 'xAssists Open Play',
      xAssistsSetPiece: 'xAssists Set Piece',
      xAssistsOpenPlayInTeam: 'xAssists Open Play in Team',
      xAssistsSetPieceInTeam: 'xAssists Set Piece in Team',
      xGBuildupFinalThird: 'xG Build Up Final ⅓',
      xGChainFinalThird: 'xG Chain Final ⅓',
      BallProgressionPassing: 'Ball Prog. by Passing',
      BallProgressionDribbling: 'Ball Prog. by Carrying',
      TacklesWasDribbled: 'Tackles/Was Dribbled',
      TacklesSuccessful: 'Successful Tackles',
      Interceptions: 'Interceptions',
      Clearances: 'Clearances',
      Fouls: 'Fouls',
      Recoveries: 'Recoveries',
      Shots: 'Shots',
      ShotsPerGoal: 'Shots per Goal',
      ShortPassesSuccessful: 'Successful Short Passes',
      PassingSuccessForwardPct: '% Passing Success Forward',
      PassingSuccessBackwardPct: '% Passing Success Backward',
      PassingForwardBackwardPct: '% Passing Forward per Backward',
      LongBallPerPassesPct: '% Long Ball per Passes',
      LongBallReceived: 'Long Balls Received',
      LongBallReceivedOppHalf: 'Long Balls received Opp. Half',
      OffensiveActions: 'Offensive Actions',
      DribblesAttempted: 'Dribbles Attempted',
      SuccessfulDribblesPct: '% Successful Dribbles',
      OffensiveTouchesOutBoxPct: '% Offensive Touches Out of Box',
      BallRetention: '% Ball Retention',
      PassingPct: '% Passing',
      PassingOwnHalfPct: '% Passing Own Half',
      PassingOppHalfPct: '% Passing Opp. Half',
      PassingFinalThird: 'Passes Into Final ⅓',
      PassingFinalThirdPct: '% Passing Into Final ⅓',
      LongBallSuccessful: 'Completed Long Balls',
      LongBallPct: '% Long Balls',
      SavesPct: '% Saves',
      SavesInBoxPct: '% Saves in Box',
      SavesOutOfBoxPct: '% Saves Out of Box',
      xGSavedPerXGFacedOnTarget: 'xG Saved/xG Faced on Target',
      xGFacedOnTargetPerGoalReceived: 'xG Faced per Goal',
      xGFacedOnTargetEfficiency: 'Goals Prevented',
      xGFacedOnTarget: "xG Faced on Target",
      IndividualPressure: 'Individual Pressure',
      AerialEfficiency: 'Aerial Efficiency',
      AerialWins: 'Aerial Wins',
      AerialWinsPct: '% Aerial Wins',
      xG: 'Expected Goals',
      xGDiff: "xG Difference",
      xGOpenPlay: "xG Open Play",
      xGSetPiece: "xG Set Piece",
      xGPerShot: 'xG per Shot',
      ChancesCreated: 'Chances Created',
      CompletedCrosses:"Completed Crosses",
      Crossing: '% Crossing',
      OpenPlayKeyPasses: 'Open Play Key Passes',
      OpenPlayKeyPassesInTeam: '% Open Play Key Passes in Team',
      OpenPlayPassesIntoOpponentBox: 'Total OP Passes Into Box',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OP Passes Into Box',
      xAssists: 'Expected Assists',
      xGChain: 'xG Chain',
      xGBuildup: 'xG Build Up',
      xGBuildupInTeam: 'xG Build Up in Team',
      BallProgression: 'Ball Progression',
      SuccessfulDribbles: 'Successful Dribbles',
      Dispossessed: 'Dispossessed',
      TouchesInOpponentBox: 'Touches In Opponent Box',
      xGSavedPerShot: 'xG Saved per Shot',
      BallRetentionOppHalf: '% Ball Retention in Opp. Half',
      DeepProgression: 'Deep Progression',
      DeepProgressionFinalThird: 'Deep Progression into Final ⅓',
      FoulsTaken: 'Fouls Received',
      PenaltiesTaken: 'Penalties Taken',
      BlockedCrosses: 'Blocked Crosses',
      BlockedShots: 'Blocked Shots',
      Blocks: 'Blocks',
      NonPenaltyGoalsAgainst: 'Non-Penalty Goals Received',
      Headers: "Headers",
      AveragePassDistance: "Average Pass Distance",
      ProgressiveRuns: "Progressive Carries",
      xT: "Expected Threat (xT)",
      xTOpenPlay: "xT Open Play",
      xTSetPiece: "xT Set Piece",
      xGOT:"Expected Goals On Target",
      BadActions: 'Bad Actions',
      BadActionsOwnHalf: "Bad Actions Own Half",
      AerialsWonOwnBox: "Aerial Wins Own Box",
      AerialsWonOppBox: "Aerial Wins Opp Box",
      AerialsTotalOppBox: "Aerials Total Opp Box",
      AerialsTotalOwnBox: "Aerials Total Own Box",
      FoulsOwnHalfPct: "% Fouls Own Half",
      RecoveriesOppHalf: "Recoveries Opp. Half",
      DuelsPct: "% Successful Duels",
      TacklesUnsuccessful: "Unsuccessful Tackles",
      TacklesWasDribbledFirstThird: "Tackles/Was Dribbled ⅓",
      TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
      TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
      BallProgressionFinalThird: "Ball Progression Final ⅓",
      DuelsTotal: "Duels",
      QuickRecoveries: "Quick Recoveries",
      ShotsPerNPG: "Shots per NPG",
      ShotsOutBox: "Shots out of Box",
      GoalsOutBox: "Goals out of Box",
      ShootingOutBox: "% Shooting out of Box",
      HandPassing: "% Hand Passing",
      Catching: "% Catching",
      ClaimAccuracy: "Claim Accuracy",
      HighTurnovers: "High Turnovers",
      ShotEndingHighTurnovers: "Shot Ending High Turnovers",
      GoalEndingHighTurnovers: "Goal Ending High Turnovers",
      AverageCarriesProgress: "Average Carries Progress",
      ChanceEndingCarries: "Chance Ending Carries",
      AssistEndingCarries: "Assist Ending Carries",
      ShotEndingCarries: "Shot Ending Carries",
      GoalEndingCarries: "Goal Ending Carries",
      ShotEndingSequence: "Shot Ending Sequence",
      GoalEndingSequence: "Goal Ending Sequence",
      xGPerNPG: "xG per NPG",
      AerialWonOffensive: "Aerial Wins Offensive",
      AerialWonDefensive: "Aerial Wins Defensive",
      xGAgainst: "xG Received",
      xGDiffAgainst: "xG Diff Conceded",
      xGPerNPGAgainst: "xG per NPG Received",
      xGSetPieceAgainst: "xG Set Piece Conceded",
      xGOpenPlayAgainst: "xG Open Play Conceded",
      xGPerShotAgainst: "xG per Shot Conceded",
      ShotsAgainst: "Shots Received",
      ShotsOnTargetAgainst: "Shots on Target Conceded",
      RivalPossession: "Opponent Possession",
      AerialDefensivePct: "% Aerial Defensive",
      HighRecoveries: "High Recoveries",
      HighDefensiveActionPct: "% High Defensive Actions",
      HighDefensiveDistance: "High Defensive Distance",
      PassesPerPossession: "Passes per Possession",
      LengthPerPossession: "Distance per Possession",
      xTNet:"Net xT",
      AvgCarriesDistance:"Avg. Carries Distance",
      PassesForwardPct:"% Passes Go Forward",
      TacklesAttempted:"Tackles Attempted",
      DuelsLost:"Duels Lost",
      Carries:"Carries",
      CarriesPct: "% Carries",
      Aerials:"Aerial Duels",
      ProgressivePassesReceivedIntoBox:"Progressive Passes Receive Into Box",
      PassesOppHalf: "Passes Opp. Half",
      ShotsOnTarget:"Shots on Target",
      AggressiveActions: "Aggresive Actions",
      Crosses:"Crosses",
      xGBuildup5pass: "xGBuildup 5 passes",
      DefensiveDistance: "Defensive Distance",
      SpeedSequence: "Sequence's Speed",
      Touches: "Touches",
      AerialsTotalOppHalf: "Aerials Total Opp. Half",
      AerialsOppHalf: "Aerials Opp. Half",
      AerialsWonOppHalfPct: "% Aerial Wins Opp. Half",
      AerialsPctOppBox: "% Aerial Wins Opp. Box",
      AerialsPctOwnBox: "% Aerial Wins Own Box",
      AerialDefensive: "Aerials Defensive",
      AerialOffensive: "Aerials Offensive",
      AerialOffensivePct: "% Aerials Offensive",
      IndividualPressureOppHalf: "Individual Pressure Opp. Half",
      ChancesCreatedOP: "Chances Created Open Play",
      TouchesPerShot: "Touches per Shot",
      PassesFinalThirdTotalPct: "% Passes Final ⅓",
      xACrosses: "xA from Crosses",
      Passes: "Passes",
      PassesSuccessful: "Passes Successful",
      TacklesWasDribbledFouls: "% Ground Duels",
      OffsidesCaught: "Offsides Caught",
      ProgressivePassesReceivedFinalThird: "Progressive Passes Received Final ⅓",
      ProgressivePassesReceived: "Progressive Passes Received",
      Breadth: "Breadth",
      DuelsDefTotal: "Defensive Duels",
      DefensiveActions: "Defensive Actions",
      ProgressivePassesReceivedOppHalf: "Prog. Passes Received Opp. Half",
      CompletedCrossesOP: "Completed Crosses Open Play",
      CrossingOP: "% Crossing Open Play",
      PassingContribution: "% Passing Contribution",
    	BallProgressionOppHalfInTeam: "% Ball Progression Opp. Half in Team",
    	PassesOPIntoBoxInTeam: "% Passes Open Play into Box in Team",
    	TouchesOppBoxInTeam: "% Touches Opp. Box in Team",
    	xGOPInTeam: "% xG Open Play in Team",
      DeepPasses: "Deep Passes",
      DefensiveDuelsPct: "% Defensive Duels",
      DefensiveDistance: "Defensive Distance",
      QuickRecoveriesPct: "% Quick Recoveries",
      DiffDefensiveDistanceTeam: "Diff. Defensive Distance Team",
      xTPassing: "xT Passing",
      xTPassing100Passes: "xT Passing 100 Passes",
      ProgressivePassesAccurate: "Progressive Passes",
      PassAbility: "Pass Ability",
      OPPassesIntoOppBoxPct: "% Open Play Passes Into Opp. Box",
      EntriesOppBox: "Entries Opp. Box",
      Crosses6yardBox: "Crosses Six-Yard Box",
      Cutbacks: "Cutbacks",
      xTDribbling: "xT Dribbling",
      AvgShotDistance: "Avg Shot Distance",
      xGOnTarget: "xG on Target",
      FinishingxGOT: "Finishing xGOT",
      DribblesWonOwnHalf: "Dribbles Completed Own Half",
      DribblesOwnHalf: "Dribbles Own Half",
      DribblesOwnHalfPct: "% Dribbles Own Half",
      DribblesWonOppHalf: "Dribbles Completed Opp Half",
      DribblesOppHalf: "Dribbles Opp Half",
      DribblesOppHalfPct: "% Dribbles Opp Half",
      DribblesWonFinalThird: "Dribbles Completed Final ⅓",
      DribblesFinalThird: "Dribbles Final ⅓",
      DribblesFinalThirdPct: "% Dribbles Final ⅓",
      Score: 'Score',
      PDScore: 'Physical Score',
      OrlegiScore: "Score Orlegi",
      EstorilScore: "Score Estoril",
      PecScore: "Score PEC",
      PaokScore: "Score PAOK",
      SDLScore: "SDL Score",
      Hud1Score: "Hud Score 1",
      Hud2Score: "Hud Score 2",
      Hud3Score: "Hud Score 3",
      Hud4Score: "Hud Score 4",
      xTOPInTeam: "xT OP in Team",
      YellowCards: "Yellow Cards",
      RedCards: "Red Cards",
      xTOpenPlayAgainst: "xT Open Play Conceded",
      xTSetPieceAgainst: "xT Set Piece Conceded",
      NPGOpenPlayAgainst: "NPG Open Play Conceded",
      NPGSetPieceAgainst: "NPG Set Piece Conceded",
      PassesOppHalfPerPossession: "Passes Opp. Half per Possession",
      AverageTimeRecovery: "Avg Time Recovery",
      ExpectedPassing: "% Expected Passing",
      NumPossession10Passes: "Possessions 10 Passes",
      PassesReceived: "Passes Received",
      PassesReceivedFinalThird: "Passes Received Final ⅓",
      ProgressivePassesTotalPct: "% Progressive Passes",
      ShortPassesPct: '% Short Passes',
      //Physical Stats
      TotalDistance: "Total Distance",
      DistanceTIP: "Distance TIP",
      DistanceOTIP: "Distance OTIP",
      SprintsNumber: "Sprints Quantity",
      SprintsDistance: "Sprints Distance",
      WalkingDistance: "Walking Distance",
      JoggingDistance: "Jogging Distance",
      RunningDistance: "Running Distance",
      ExtremeAccelerations: "Extreme Accelerations",
      NumberOfRuns: "Runs Quantity",
      HsrNumber: "HSR Quantity",
      HsrDistance: "HSR Distance",
      SprintNumberDeclinePct: "% Sprint Quantity Decline",
      SprintDistanceDeclinePct: "% Sprint Distance Decline",
      HsrDistancePct: "% HSR Distance",
      SprintDistancePct: "% Sprint Distance",
      Accelerations: "Accelerations",
      ExplosiveDistance: "Explosive Distance",
      MaxSpeed: "Max. Speed",
      AvgMaxSpeed: "Avg. Max. Speed",
      MaxAccelerations: "Max. Accelerations",
      //Arrigo
      BypassedPlayers: "Bypassed Players",
      BypassedDefenders: "Bypassed Defenders",
      PassesBypassingPlayers: "Passes Bypassing Players",
      PassesBypassingDefenders: "Passes Bypassing Defenders",
      BypassedPlayersPerPass: "Bypassed Players per Pass",
      BypassedDefendersPerPass: "Bypassed Defenders per Pass",
      LineBreakingPasses: "Line Breaking Passes",
      LineBreakingPassesFM: "Line Breaking Passes FM",
      LineBreakingPassesMD: "Line Breaking Passes MD",
      LineBreakingThroughBalls: "Line Breaking Through Balls",
      LineBreakingPassesPerPass: "Lines Broken per Pass",
      TotalPassesUnderStrongPressure: "Total Passes Under Strong Pressure",
      TotalPassesUnderLightPressure: "Total Passes Under Pressure",
      PassesUnderStrongPressure: "Passes Under Strong Pressure",
      PassesUnderLightPressure: "Passes Under Pressure",
      PassingUnderStrongPressure: "% Passing Under Strong Pressure",
      PassingUnderLightPressure: "% Passing Under Pressure",
      PassMadeReceiptsInSpace: "Pass Receipts Made in Space",
      PassReceiptsInSpace: "Pass Receipts in Space",
      TotalStrongOnBallPressures: "Total Strong on Ball Pressures",
      TotalLightOnBallPressures: "Total on Ball Pressures",
      StrongOnBallPressures: "Strong on Ball Pressures",
      LightOnBallPressures: "On Ball Pressures",
      StrongOnBallPressuresPct: "% Strong on Ball Pressures",
      LightOnBallPressuresPct: "% On Ball Pressures",
      description: {
        Possession: "Percentage of ball possession of the team",
        TimePossession: 'Time of ball possession of the team',
        PassesPerShots: "Average number of passes given per shot",
        PPDA: "Conceded Passes per Defensive Action. PPDA measures the pressure that the team puts on the opposition players when they are in possession of the ball. The value corresponds with the average number of passes on a row the opponent was able to complete before being interrupted. The higher the value is, the more passes the opponent was allowed to complete",
        Directness: "Measures how direct a team is. A high value of directness is related to a higher quantity of forward passes with respect to sideways passes",
        ExpectedPoints: "Number of points expected by a team, calculated based on the Expected Goals generated and conceded. This metric allows us to better assess the performance of a team during a game (or a set of games) when compared to the number of points actually achieved",
        PassesPerLongBall: "Percentage of successful long passes out of the total number of completed passes",
        CrossingPerXG: "Percentage of Expected Goals coming from crosses",
        PenaltySavedPenaltyFaced: "Percentage of Penalty Shots Saved out of all Penalty Shots Faved",
        Goals: "Number of goals scored per 90 minutes of play",
        NonPenaltyGoals: "Number of goals scored per 90 minutes of play excluding penalty goals",
        NPGOpenPlay: "Number of goals scored per 90 minutes of play by open play actions excluding penalty goals",
        NPGSetPiece: "Number of goals scored per 90 minutes of play by set piece actions excluding penalty goals",
        Shooting: "Percentage of shots on target",
        Finishing: "Percentage of shots ending in a goal",
        xGEfficiency: "Quantity of expected goals needed for a player to score a goal",
        HeaderPerShot: "Number of headers made per 90 minutes of play",
        HeaderPerCross: "Percentage of crosses headed by the player out of the total number of crosses completed by the team",
        Assists: "Number of assists per 90 minutes of play",
        ThroughBalls: "Number of balls played through for player making an attacking run to create a change on goal per 90 minutes of play",
        CrossEfficiency: "Metric that combines percentage of successful crosses together with the volume of successful crosses made",
        ScoringContribution: "Number of assists and goals per 90 minutes of play",
        xAssistsOpenPlay: "Number of expected assists per 90 minutes of play generated by open play",
        xAssistsSetPiece: "Number of expected assists per 90 minutes of play generated by set piece",
        xAssistsOpenPlayInTeam: 'Number of expected assists generated by open play in team',
        xAssistsSetPieceInTeam: 'Number of expected assists generated by set piece in team',
        xGChainFinalThird: "Quantity of xG a player has taken part in the final third",
        xGBuildupFinalThird: "Quantity of xG a player has taken part in the final third (excluding shots and passes leading to a shot)",
        BallProgressionPassing: "Number of times the player progresses the ball 10 meters or more by passing the ball",
        BallProgressionDribbling: "Number of times the player progresses the ball 10 meters or more by carrying the ball",
        TacklesWasDribbled: "Metric that takes into account the percentage of times the player recovers the ball via tackling vs. the times it was passed/run. The higher the indicator the better",
        TacklesSuccessful: "Number of successful tackles made by the player",
        Interceptions: "Number of times the player intercepts a pass to prevent the ball reaching its target per 90 minutes of play",
        Clearances: "Number of times the player hits the ball clear of the defensive zone per 90 minutes of play",
        Fouls: "Number of fouls committed by the player per 90 minutes of play",
        Recoveries: "Number of balls recovered by a player per 90 minutes of play",
        Shots: "Number of total shots made per 90 minutes of play",
        ShotsPerGoal: "Shots on target needed to score a non-penalty goal to the Goalkeeper",
        ShortPassesSuccessful: "Short passes (under 12 meters) completed per 90 minutes of play",
        PassingSuccessForwardPct: 'Percentage of successful passes in the forward direction',
        PassingSuccessBackwardPct: 'Percentage of successful passes backwards',
        PassingForwardBackwardPct: 'Ratio of passes in the forward direction against passes backwards',
        LongBallPerPassesPct: "Percentage of long passes completed (>32 meters) out of all passes completed by the player.",
        LongBallReceived: "Long passes (>32 meters) received by the played",
        LongBallReceivedOppHalf: "Long passes (>32 meters) received by the played on the opponent half",
        OffensiveActions: 'Offensive Actions',
        DribblesAttempted: "Dribbles attempted per 90 minutes of play",
        SuccessfulDribblesPct: "Successful dribbles/total of dribbling attempts",
        OffensiveTouchesOutBoxPct: '% Offensive Touches Out of Box',
        BallRetention: "Percentage of the time you have possession of the ball and don't end up losing it",
        PassingPct: "Percentage of passes completed out of all passes given by the player",
        PassingOwnHalfPct: "Percentage of passes completed out of all passes given by the player (only passes on the own half)",
        PassingOppHalfPct: "Percentage of passes completed out of all passes given by the player (only passes into opponent half)",
        PassingFinalThird: "Completed passes to the final third per 90 minutes",
        PassingFinalThirdPct: "Percentage of passes completed out of all passes given by the player (only passes into final third)",
        LongBallSuccessful: "Completed passes over 32 meters",
        LongBallPct: "Completed passes over 32 meters/ Total passes over 32 attempted.",
        SavesPct: "Percentage of saves out of the total number of shots conceded",
        SavesInBoxPct: "Percentage of saved shots shots coming inside the box",
        SavesOutOfBoxPct: "Percentage of saved shots coming outside the box",
        xGSavedPerXGFacedOnTarget: "Coefficient that indicates the percentage of the expected xG that are saved by the Goalkeeper. A value of 1 in this metric would mean that the goalkeeper saves all expected goals of the shots conceded by the team, while a value of 0 would mean that all expected goals generated by the opponent end up in goal",
        xGFacedOnTargetPerGoalReceived: "Metric that indicates how many Expected Goals are needed to score a goal to a certain Goalkeeper. A high score in this metric means that to convert a goal to this Goalkeeper it is necessary to create a high number of xG",
        xGFacedOnTargetEfficiency: "Number of Non-Penalty Goals prevented by the Goalkeeper. This is the number of Expected Goals On Target received by the Goalkeeper minus the number of (non-penalty) goals conceded. Indicates the number of goals that were not scored by the opponent thanks to the goalkeeper",
        xGFacedOnTarget: "Total xG (saved and scored) faced by the goalkeeper",
        IndividualPressure: "Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent",
        AerialEfficiency: "Metric that combines percentage of successful aerial duels together with the volume of aerial duel wins",
        AerialWins: "Number of aerials that the player wins per 90 minutes",
        AerialWinsPct: "Number of aerials that the player wins out of the total number of aerial duels where the player was involved",
        xG: "Expected Goals generated per 90 minutes of play. This metrics measures a shots's probability of ending in a goal based on different variables (distance, angle, type of play, part of the body, ...) of such action. You can learn more at <b><a href='https://www.driblab.com/analysis-team/expected-goals-xg-what-it-is-and-how-it-works'>Expected Goals: What it is and how it works</a></b>",
        xGDiff: "Difference between xG and Goals",
        xGOpenPlay: "Expected Goals generated by Open Play",
        xGSetPiece: "Expected Goals generated by Set Piece",
        xGPerShot: "Average xG of the shots made by a player. This metric measures the average dangerousness of the shots taken. The higher, the more likely it is that your shots will end up in goal. An xG per high shot means that the player chooses his shots well.",
        ChancesCreated: "Number of passes leading to a shot",
        CompletedCrosses:"Number of Crosses Completed per 90 minutes of play",
        Crossing: "Percentage of crosses that have been completed out of crosses attempted",
        OpenPlayKeyPasses: "Number of passes completed by the player during open play per 90 minutes of play",
        OpenPlayKeyPassesInTeam: 'Percentage of passes completed by the player during open play in team',
        OpenPlayPassesIntoOpponentBox: 'Total number of passes attempted by the player into the opponent box during open play per 90 minutes of play',
        OpenPlayPassesIntoOpponentBoxSuccessful: 'Number of passes completed by the player into the opponent box during open play per 90 minutes of play',
        xAssists: "Metric that analyses the quality of the chances created that take place in a match. Each shooting assists has a value based on the probability that the shot ends up being scored. This value is assigned according to the place of the pass, the type (cross throughball set piece…), state of the game etc. Unlike xG, xA is a metric that ideally a player would have higher than his assist numbers since a creator can only control his quality passes (xA), whereas his assist number depend on the finisher",
        xGChain: "Quantity of xG a player has taken part in",
        xGBuildup: "Similar to xG Chain but not taking into account the last 2 players of the sequence (excluding shots and passes leading to a shot)",
        xGBuildupInTeam: 'Similar to xG Chain but not taking into account the last 2 players of the sequence (excluding shots and passes leading to a shot) in team',
        BallProgression: "Number of times the player advances 10 or more meters either by passing, by carrying the ball or a combination of both (per 90 minutes of play)",
        SuccessfulDribbles: "Dribbles successfully completed per 90 minutes of play",
        Dispossessed: "Number of times a player is tackled and loses possession of the ball per 90 minutes of play",
        TouchesInOpponentBox: "Number of times a player has possession of the ball in the opponent box per 90 minutes of play",
        xGSavedPerShot: "Average probability of goal of conceded shots on target",
        BallRetentionOppHalf: "Percentage of the time you have possession of the ball and don't end up losing it in the opponent half",
        DeepProgression: "Number of times a player reaches the last fifth of the pitch by carrying the ball, plus the number of times the player has possession of the ball in the last fifth",
        DeepProgressionFinalThird: "Number of times a player reaches the final third of the pitch by carrying the ball, plus the number of times the player has possession of the ball in the final third",
        FoulsTaken: "Number of times the player was fouled per 90 minutes of play",
        PenaltiesTaken: "Number of times the player was fouled in the opponent box per 90 minutes of play",
        BlockedCrosses: "Crosses blocked by the player per 90 minutes of play",
        BlockedShots: "Shots blocked by the player per 90 minutes of play",
        NonPenaltyGoalsAgainst: "Number of non-penalty goals conceded per 90 minutes of play",
        Headers: "Number of Shots made with the Head",
        AveragePassDistance: "Average Distance of Passes in meters",
        ProgressiveRuns: "Successful carries that bring the possession a 20% closer to the opponent goal",
        xT: "Expected Threat (xT) is a metric that measures the threat a player creates to the opponent by carrying or passing the ball to areas where the possession's probability of ending in a goal is higher. You can learn more at <b><a href='https://www.driblab.com/driblab-en/expected-threat-map-visualizing-credit-at-football/'>Expected Threat Map: Visualizing credit at football</a></b>",
        xTOpenPlay: "Expected Threat generated during open play per 90 minutes of play",
        xTSetPiece: "Expected Threat generated by set piece per 90 minutes of play",
        xGOT:"Expected Goals On Target. Number of Expected Goals faced by the Goalkeeper. This metric only takes into account shots on target (Shots missed and shots on post are exluded)",
        BadActions: 'Sum of all bad actions committed (pass unsuccesful, take on unsuccesful, dispossessed, offside pass, ball touch unsuccessful)',
        BadActionsOwnHalf: "Sum of all bad actions committed (pass unsuccesful, take on unsuccesful, dispossessed, offside pass, ball touch unsuccessful) in the own half",
        AerialsWonOwnBox: "Aerial Duel Wins Own Box",
        AerialsWonOppBox: "Aerials Duel Wins Opp Box",
        AerialsTotalOppBox: "Aerials Duels Total Opp Box",
        AerialsTotalOwnBox: "Aerials Duels Total Own Box",
        FoulsOwnHalfPct: "Percentage of Fouls commited in the own half",
        RecoveriesOppHalf: "Number of balls recovered by a player in the opponent half per 90 minutes of play",
        DuelsPct: "Percentage of Successful Duels",
        TacklesUnsuccessful: "Number of times a player fails to win the ball as an opponent successfully dribbles past them",
        TacklesWasDribbledFirstThird: "Percentage of times the player recovers the ball when faced in the final third",
        TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
        TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
        BallProgressionFinalThird: "Ball Progression Final Third",
        DuelsTotal: "Total number of Tackles, Aerials, Ball Touches, Dribbles and Fouls committed per 90 minutes",
        QuickRecoveries: "Recoveries 40 meters or more from the own goal made 5 seconds after losing the possession of the ball",
        ShotsPerNPG: "Average number of shots to score a Non-Penalty Goal",
        ShotsOutBox: "Number of Shots from outside the box per 90 minutes",
        GoalsOutBox: "Number of Goals from outside the box per 90 minutes",
        ShootingOutBox: "Percentage of shots on target from outside of Box",
        HandPassing: "Passing Accuracy with Hands",
        Catching: "Percentage of Saves in which the Goalkeeper catches the ball",
        ClaimAccuracy: "Measures how good a Goalkeeper is at catching/blocking aerial balls. A number above 1 indicates that the Goalkeeper catches more aerial balls than expected",
        HighTurnovers: "Turnovers closer than 40 meters from the own goal",
        ShotEndingHighTurnovers: "High Turnovers (turnovers closer than 40 meters from the own goal) ending in a shot of the opponent team",
        GoalEndingHighTurnovers: "High Turnovers (turnovers closer than 40 meters from the own goal) ending in a goal of the opponent team",
        AverageCarriesProgress: "Average distance that a player moves the ball vertically per carry (meters)",
        ChanceEndingCarries: "Carries of at least 7 meters ending in a pass that is followed by a shot",
        AssistEndingCarries: "Carries of at least 7 meters ending in a pass that is followed by a goal",
        ShotEndingCarries: "Carries of at least 7 meters ending in a shot",
        GoalEndingCarries: "Carries of at least 7 meters ending in a goal",
        ShotEndingSequence: "Number of Sequences ending in a Shot where the player was involved",
        GoalEndingSequence: "Number of Sequences ending in a Goal where the player was involved",
        xGPerNPG: "Expected Goals needed to score a non-penalty goal",
        AerialWonOffensive: "Offensive Aerial Duel Wins",
        AerialWonDefensive: "Defensive Aerial Duel Wins",
        xGAgainst: "Expected Goals Conceded",
        xGDiffAgainst: "Difference between Expected Goals Conceded and Goals Conceded",
        xGPerNPGAgainst: "Expected Goals received per Non-Penalty Goal Conceded",
        xGSetPieceAgainst: "Expected Goals generated by Set Piece Conceded",
        xGOpenPlayAgainst: "Expected Goals generated by Open Play Conceded",
        xGPerShotAgainst: "Expected Goals Received per Shot Conceded",
        ShotsAgainst: "Number of Shots Conceded per 90 minutes of play",
        ShotsOnTargetAgainst: "Number of Shots on Target Conceded per 90 minutes of play",
        RivalPossession: "Possession of the opponent",
        AerialDefensivePct: "Percentage of Aerial wins without ball possession",
        HighRecoveries: "Recoveries made 40 meters close to the opponent goal",
        HighDefensiveActionPct: "Percentage of Defensive Actions (Tackles, Interceptions, Blocks, Fouls y 1vs1) made 40 meters over the own baseline",
        HighDefensiveDistance: "Average distance from own goal of all Defensive Actions",
        PassesPerPossession: "Number of Passes per Possession",
        LengthPerPossession: "Distance per Possession",
        xTNet:"Net xT",
        AvgCarriesDistance:"Average Carries Distance",
        PassesForwardPct:"% Passes Go Forward",
        TacklesAttempted:"Tackles Attempted",
        DuelsLost:"Duels Lost",
        Carries:"Carries",
        CarriesPct: "% Carries",
        Aerials:"Total number of Aerial Duels",
        ProgressivePassesReceivedIntoBox:"Progressive Passes Receive Into Box",
        PassesOppHalf: "Successful passes ending into the opponent half",
        ShotsOnTarget:"Shots made on Target per 90 minutes",
        AggressiveActions: "Number of Tackles attempted in the next two seconds after losing the possession",
        Crosses:"Total Number or Crosses per 90 minutes of play",
        xGBuildup5pass: "Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)",
        DefensiveDistance: "Average distance to opponent goal of all defensive actions",
        SpeedSequence: "Average Speed (meters covered by time spent) of all possessions of a team",
        Touches: "Number of times a player has possession of the ball per 90 minutes of play",
        AerialsTotalOppHalf: "Aerial duels total into opponent half per 90 minutes of play",
        AerialsOppHalf: "Aerial duels successful into opponent half per 90 minutes of play",
        AerialsWonOppHalfPct: "Percentage of aerial duel wins into opponent half",
        AerialsPctOppBox: "Percentage of aerial duel wins into opponent box",
        AerialsPctOwnBox: "Percentage of aerial duel wins into own box",
        AerialDefensive: "Total number of Aerials when own team has possession",
        AerialOffensive: "Total number of Aerials when opponent team has possession",
        AerialOffensivePct: "Percentage of Aerial wins when own team has possession",
        IndividualPressureOppHalf: "Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent in the opponent half",
        ChancesCreatedOP: "Number of passes leading to a shot during open play per 90 minutes of play",
        TouchesPerShot: "Number of times players touch the ball per shot",
        PassesFinalThirdTotalPct: "Percentage of passes (successful and unsuccessful) into final third",
        xACrosses: "Expected assists generated from crosses per 90 minutes of play",
        Passes: "Total number of passes per 90 minutes of play",
        PassesSuccessful: "Number of Completed Passes per 90 minutes of play",
        TacklesWasDribbledFouls: "Percentage of tackles won with respect to total tackles and fouls committed",
        OffsidesCaught: "Offsides Caught",
        ProgressivePassesReceivedFinalThird: "Progressive Passes Received Final ⅓",
        ProgressivePassesReceived: "Progressive Passes Received",
        Breadth: "Sum of Tackles, Challenges, Interceptions and Fouls Committed, on the sides of the field",
        DuelsDefTotal: "Sum of total Tackles, Defensive Aerial Duels and Fouls committed",
        DefensiveActions: "Defensive Actions when an opponent tries to dribble (Tackles, Challenges and Fouls)",
        ProgressivePassesReceivedOppHalf: "Progressive Passes Received Opp. Half",
        CompletedCrossesOP: "Completed Crosses Open Play",
        CrossingOP: "Percentage of crosses completed out of all crosses attempted open play",
        PassingContribution: "Percentage that measures threat of passes taking into account the position of the receiver",
      	BallProgressionOppHalfInTeam: "% Ball Progression Opp. Half in Team",
      	PassesOPIntoBoxInTeam: "% Passes Open Play into Box in Team",
      	TouchesOppBoxInTeam: "% Touches Opp. Box in Team",
      	xGOPInTeam: "% xG Open Play in Team",
        DeepPasses: "Passes from outside a 20-metre radius of the opponent goal that end inside that area",
        DefensiveDuelsPct: "Percentage of defensive duels won out of total defensive duels",
        DefensiveDistance: "Average distance to own goal of defensive duels performed",
        QuickRecoveriesPct: "Percentage of quick recoveries to interceptions and attempted tackles",
        DiffDefensiveDistanceTeam: "Difference between the player's defensive distance and his team's defensive distance",
        xTPassing: "Expected threat generated only from passes",
        xTPassing100Passes: "Expected threat generated only from passes and per 100 passes",
        ProgressivePassesAccurate: "Completed passes of 10 metres or more in the X-axis",
        PassAbility: "Ratio of completed passes to expected passes (xP)",
        OPPassesIntoOppBoxPct: "Percentage of open play completed passes into the opponent box and open play attempted passes into the opponent box",
        EntriesOppBox: "Number of passes and carries into the opponent box",
        Crosses6yardBox: "Total number of crosses ending in the six-yard box",
        Cutbacks: "Passing from baseline to back and inside the opponent box",
        xTDribbling: "Expected threat generated only from dribbles",
        AvgShotDistance: "Average distance of the total number of shots taken",
        xGOnTarget: "Expected goals from shots made on target. Measures the probability of a shot ending in a goal using the end location of the shot",
        FinishingxGOT: "Percentage of shots on target ending in a goal above average. This metric measures how much value the striker adds with the quality of his shots",
        DribblesWonOwnHalf: "Successful dribbles made in own half",
        DribblesOwnHalf: "Number of attempted dribbles made in own half",
        DribblesOwnHalfPct: "Percentage of successful dribbles and attempted dribbles made in own half",
        DribblesWonOppHalf: "Successful dribbles made in opponent half",
        DribblesOppHalf: "Number of attempted dribbles made in opponent half",
        DribblesOppHalfPct: "Percentage of successful dribbles and attempted dribbles made in opponent half",
        DribblesWonFinalThird: "Successful dribbles made in the final third",
        DribblesFinalThird: "Number of attempted dribbles made in the final third",
        DribblesFinalThirdPct: "Percentage of successful dribbles and attempted dribbles made in the final third",
        Score: "Player performance based on different metrics",
        PDScore: 'Player physical performance based on different physical metrics',
        OrlegiScore: "Score Orlegi",
        EstorilScore: "Score Estoril",
        PecScore: "Score PEC",
        PaokScore: "Score PAOK",
        Hud1Score: "Huddersfield Score 1",
        Hud2Score: "Huddersfield Score 2",
        Hud3Score: "Huddersfield Score 3",
        Hud4Score: "Huddersfield Score 4",
        SDLScore: "Player Performance based on different metrics",
        Hud1Score: "Huddersfield Score 1",
        Hud2Score: "Huddersfield Score 2",
        Hud3Score: "Huddersfield Score 3",
        Hud4Score: "Huddersfield Score 4",
        xTOPInTeam: "Expected threat generated during open play in team",
        YellowCards: "Yellow cards received",
        RedCards: "Red cards received",
        xTOpenPlayAgainst: "Expected Threat conceded during open play",
        xTSetPieceAgainst: "Expected Threat conceded by set piece",
        NPGOpenPlayAgainst: "Number of goals conceded by open play actions excluding penalty goals",
        NPGSetPieceAgainst: "Number of goals conceded by set piece actions excluding penalty goals",
        PassesOppHalfPerPossession: "Passes Opp. Half per Possession",
        AverageTimeRecovery: "Avg Time Recovery",
        ExpectedPassing: "Percentage of Passes that should have been completed",
        NumPossession10Passes: "Possessions generated by 10 or more passes",
        PassesReceived: "Passes Received",
        PassesReceivedFinalThird: "Passes Received Final ⅓",
        ProgressivePassesTotalPct: "Percentage of Progressive Passes",
        ShortPassesPct: 'Percentage of Short Passes',
        //Physical Stats
        TotalDistance: "Total distance that the Player has travelled during a match",
        WalkingDistance: "Total distance that the Player has travelled during a match at a speed lower than 2 m/s (7.2 km/h)",
        JoggingDistance: "Total distance that the Player has travelled during a match at a speed between 2 m/s (7.2 km/h) and 4 m/s (14.4 km/h)",
        RunningDistance: "Total distance that the Player has travelled during a match at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h)",
        ExtremeAccelerations: "Number of times that the Player accelerates more than 3 m/s<sup>2</sup>",
        NumberOfRuns: "Number of runs completed at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h)",
        DistanceTIP: "Distance (Team In Possession) that the Player has travelled during a match with possession",
        DistanceOTIP: "Distance OTIP (Opponent Team In Possession) that the Player has travelled during a match without possession",
        HsrNumber: "Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second",
        HsrDistance: "Total distance that the Player has travelled during a match at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h)",
        HsrDistancePct: "Percentage of HSR (High Speed Run) Distance with respect to total distance travelled",
        SprintsNumber: "Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second",
        SprintsDistance: "Total distance that the Player has travelled during a match at a speed that is greater than or equal to 7 m/s (25.2 km/h)",
        SprintNumberDeclinePct: "Percentage decrease in the number of sprints performed compared to the second half of the match",
        SprintDistanceDeclinePct: "Percentage decrease in the distance run by while sprinting compared to the second half of the match",
        SprintDistancePct: "Percentage of Sprint Distance with respect to total distance travelled",
        Accelerations: "Number of times that the Player accelerates between 1.5 m/s<sup>2</sup> and 3 m/s<sup>2</sup>",
        ExplosiveDistance: "Explosive Distance",
        MaxSpeed: "Maximum speed achieved by the player",
        AvgMaxSpeed: "Average of maximum speed achieved by the player",
        MaxAccelerations: "Maximum metres/second<sup>2</sup> achieved by the player",
        BypassedPlayers: "Number of players goal side of the ball carrier at the beginning of the touch event, minus the number of players goal side at the end of the touch event",
        BypassedDefenders: "Number of defenders goal side of the ball carrier at the beginning of the touch event, minus the number of defenders goal side at the end of the touch event",
        PassesBypassingPlayers: "Number of passes that bypassed players",
        PassesBypassingDefenders: "Number of passes that bypassed defenders",
        BypassedPlayersPerPass: "Total number of players bypassed per passes",
        BypassedDefendersPerPass: "Total number of defenders bypassed per passes",
        LineBreakingPasses: "Completed passes that advance the ball at least 10% closer to the opponent goal and intersect a pair of defenders in close proximity or pass behind the defensive line",
        LineBreakingPassesFM: "Number of midfield to forward line breaking passes",
        LineBreakingPassesMD: "Number of defenders to midfielders line breaking passes",
        LineBreakingThroughBalls: "Line Breaking Through Balls",
        LineBreakingPassesPerPass: "Number of lines broken per pass",
        TotalPassesUnderStrongPressure: "Total number of passes made under strong pressure (within 0-1.5 meters of the nearest opponent)",
        TotalPassesUnderLightPressure: "Total number of passes made under pressure (within 1.5-3 meters of the nearest opponent)",
        PassesUnderStrongPressure: "Number of successful passes made under strong pressure (within 0-1.5 meters of the nearest opponent)",
        PassesUnderLightPressure: "Number of successful passes made under pressure (within 1.5-3 meters of the nearest opponent)",
        PassingUnderStrongPressure: "Percentage of successful passes and total passes both under strong pressure (within 0-1.5 meters of the nearest opponent)",
        PassingUnderLightPressure: "Percentage of successful passes and total passes both under pressure (within 1.5-3 meters of the nearest opponent)",
        PassMadeReceiptsInSpace: "Passes made where the receiver is in the attacking half and has no defender in a 5 meter radius towards the direction of the goal",
        PassReceiptsInSpace: "Passes received in the attacking half and there is no defender in a 5 meter radius towards the direction of the goal",
        TotalStrongOnBallPressures: "Number of strong on-ball pressures (within 0-1.5 meters of the ball carrier)",
        TotalLightOnBallPressures: "Number of on-ball pressures (within 1.5-3 meters of the ball carrier)",
        StrongOnBallPressures: "Number of successful strong on-ball pressures (within 0-1.5 meters)",
        LightOnBallPressures: "Number of successful on-ball pressures (within 1.5-3 meters)",
        StrongOnBallPressuresPct: "Percentage of successful and total strong on-ball pressures (within 0-1.5 meters of the nearest opponent)",
        LightOnBallPressuresPct: "Percentage of successful and total on-ball pressures (within 1.5-3 meters of the nearest opponent)",
      },
      subtitles: {
        Possession: "Percentage of ball possession of the team",
        TimePossession: 'Time of ball possession of the team',
        PassesPerShots: "Average number of passes given per shot",
        PPDA: "Pressure that the team puts on the opposition players when they are in possession",
        Directness: "Higher quantity of forward passes with respect to sideways passes",
        ExpectedPoints: "Number of points expected by a team, calculated based on the Expected Goals",
        PassesPerLongBall: "Percentage of successful long passes out of the total number of completed passes",
        CrossingPerXG: "Percentage of Expected Goals coming from crosses",
        PenaltySavedPenaltyFaced: "Percentage of penalty shots saved out of all penalty shots faced",
        AerialWins: "Aerial duel wins per 90 mins",
        AerialEfficiency: "Metric that combines aerial duel wins with aerial duels total per 90 mins",
        AerialWinsPct: "Percentage of aerial duel wins",
        Assists: "Assists per 90 mins",
        Catching: "Percentage of saves in which the GK catches the ball",
        ChancesCreated: "Number of passes leading to a shot per 90 mins",
        ClaimAccuracy: "Balls claimed above average",
        CompletedCrosses: "Crosses successfully completed per 90 mins",
        Crossing: "Percentage of successful crosses",
        Dispossessed: "Turnovers per 90 mins",
        Finishing: "Percentage of shots ending in a goal",
        xGEfficiency: "Quantity of expected goals needed for a player to score a goal",
        Fouls: "Fouls commited per 90 mins",
        FoulsTaken: "Fouls received per 90 mins",
        IndividualPressure: "Successful efforts (possessions recovered) per 90 mins",
        Interceptions: "Ball Interceptions per 90 mins",
        LongBallPct: "Percentage of Completed Passes of at least 32 meters",
        LongBallSuccessful: "Completed Passes of at least 32 meters per 90 mins",
        Goals: "Number of goals scored per 90 minutes of play",
        NonPenaltyGoals: "Goals (excluding penalties) per 90 mins",
        NPGOpenPlay: "Goals (excluding penalties) by open play actions per 90 mins",
        NPGSetPiece: "Goals (excluding penalties) by set piece actions per 90 mins",
        OpenPlayKeyPasses: "Passes ending in a Shot (excluding assists) in Open Play per 90 mins",
        OpenPlayKeyPassesInTeam: 'Percentage of passes ending in a shot (excluding assists) in open play in Team',
        PassingFinalThird: "Successful Passes in Final Third per 90 mins",
        PassingFinalThirdPct: "Percentage of Successful Passes in Final Third",
        PassingOppHalfPct: "Percentage of Successful Passes into the Opponent Half",
        PassingOwnHalfPct: "Percentage of Successful Passes into the Own Half",
        PassingPct: "Percentage of Successful Passes",
        Recoveries: "Ball Recoveries (via Tackles or Interceptions) per 90 mins",
        SavesInBoxPct: "Percentage of Saves from Shots in Box per 90 mins",
        SavesOutOfBoxPct: "Percentage of Saves from Shots out of Box per 90 mins",
        SavesPct: "Percentage of Saves",
        ScoringContribution: "Number of assists and goals per 90 mins",
        xAssistsOpenPlay: "Number of expected assists per 90 minutes of play generated by open play",
        xAssistsSetPiece: "Number of expected assists per 90 minutes of play generated by set piece",
        xAssistsOpenPlayInTeam: 'Number of expected assists per 90 minutes of play generated by open play in team',
        xAssistsSetPieceInTeam: 'Number of expected assists per 90 minutes of play generated by set piece in team',
        xGChainFinalThird: "Quantity of xG a player has taken part in the final third",
        xGBuildupFinalThird: "Quantity of xG a player has taken part in the final third (excluding shots and passes leading to a shot)",
        BallProgressionPassing: "Number of times the player progresses the ball 10 meters or more by passing the ball",
        BallProgressionDribbling: "Number of times the player progresses the ball 10 meters or more by carrying the ball",
        Shooting: "Percentage of Shots (excluding penalties) on Target",
        Shots: "Number of Shots made per 90 mins",
        ShotsPerGoal: "Average Number of Shots made to score a Goal",
        SuccessfulDribbles: "Successful Dribbles per 90 mins",
        TacklesSuccessful: "Total Number of Tackles per 90 mins",
        TacklesWasDribbled: "Percentage of Duels Won via Tackling",
        ThroughBalls: "Number of Passes that break the defensive line per 90 mins",
        TouchesInOpponentBox: "Number of Controls of the Ball in the Opponent Box per 90 mins",
        xAssists: "Expected Assists generated per 90 mins",
        xG: "Expected Goals generated per 90 mins",
        xGDiff: "Difference between xG and Goals",
        xGOpenPlay: "Expected goals generated by open play per 90 mins",
        xGSetPiece: "Expected goals generated by set piece per 90 mins",
        xGBuildup: "Involvement in xG Built per 90 mins",
        xGBuildupInTeam: 'Involvement in xG Built per 90 mins in team',
        BallProgression: "Progressions by passing or carrying the ball at least 10 meters per 90 mins",
        xGChain: "Involvement in xG Chained per 90 mins",
        xGPerNPG: "Expected goals needed to score a non-penalty goal per 90 mins",
        xGPerShot: "Average xG per Shot",
        xGSavedPerShot: "Average xG Saved per Shot faced",
        xGSavedPerXGFacedOnTarget: "Average xG saved per xG faced on target",
        xGFacedOnTargetPerGoalReceived: "Expected Goals are needed to score a goal to a certain Goalkeeper",
        xGFacedOnTargetEfficiency: "Number of Non-Penalty Goals prevented by the Goalkeeper per 90 mins",
        xGFacedOnTarget: "Total xG (saved and scored) faced by the goalkeeper per 90 mins",
        HighTurnovers: "Turnovers closer than 40 meters from the own goal",
        OpenPlayPassesIntoOpponentBox: 'Total open play passes by the player into the opponent box per 90 mins',
        OpenPlayPassesIntoOpponentBoxSuccessful: 'Open play completed passes by the player into the opponent box per 90 mins',
        DeepProgressionFinalThird: "Times the player has the possession in the final third per 90 mins",
        ChancesCreatedOP: "Number of passes leading to a shot during open play per 90 mins",
        PenaltiesTaken: "Number of times the player was fouled in the opponent box per 90 mins",
        BlockedCrosses: "Crosses blocked by the player per 90 minutes of play",
        BlockedShots: "Shots blocked by the player per 90 minutes of play",
        NonPenaltyGoalsAgainst: "Number of non-penalty goals conceded per 90 minutes of play",
        Headers: "Number of Shots made with the Head",
        AveragePassDistance: "Average distance of passes in meters",
        ProgressiveRuns: "Successful carries that bring the possession a 20% closer to the opponent goal",
        xT: "Threat generated by moving the ball to dangerous areas per 90 mins",
        xTOpenPlay: "Expected Threat generated during open play per 90 minutes of play",
        xTSetPiece: "Expected Threat generated by set piece per 90 minutes of play",
        xGOT:"Number of expected goals faced by the goalkeeper",
        BadActions: 'Sum of all bad actions committed',
        BadActionsOwnHalf: "Sum of all bad actions committed in the own half",
        AerialsWonOwnBox: "Aerial Duel Wins Own Box",
        AerialsWonOppBox: "Aerials Duel Wins Opp Box",
        AerialsTotalOppBox: "Aerials Duels Total Opp Box",
        AerialsTotalOwnBox: "Aerials Duels Total Own Box",
        FoulsOwnHalfPct: "Percentage of Fouls commited in the Own Half",
        RecoveriesOppHalf: "Number of balls recovered by a player in the opponent half per 90 mins",
        DuelsPct: "Percentage of Successful Duels",
        TacklesUnsuccessful: "Number of times a player fails to win the ball as an opponent successfully dribbles past them",
        TacklesWasDribbledFirstThird: "Percentage of times the player recovers the ball when faced in the final third",
        TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
        TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
        BallProgressionFinalThird: "Number of times a player advances 10 or more meters in the final third",
        DuelsTotal: "Total number of tackles, aerials, ball touches, dribbles and fouls committed per 90 minutes",
        QuickRecoveries: "Recoveries 40 meters or more from the own goal made 5 seconds after losing the possession",
        ShotsPerNPG: "Average number of shots to score a Non-Penalty Goal",
        ShotsOutBox: "Number of Shots from outside the box per 90 minutes",
        GoalsOutBox: "Number of Goals from outside the box per 90 minutes",
        ShootingOutBox: "Percentage of shots on target from outside of Box",
        HandPassing: "Passing Accuracy with Hands",
        ShotEndingHighTurnovers: "High Turnovers (turnovers closer than 40 meters from the own goal) ending in a shot of the opponent team",
        GoalEndingHighTurnovers: "High Turnovers (turnovers closer than 40 meters from the own goal) ending in a goal of the opponent team",
        AverageCarriesProgress: "Average distance that a player moves the ball vertically per carry (meters)",
        ChanceEndingCarries: "Carries of at least 7 meters ending in a pass that is followed by a shot",
        AssistEndingCarries: "Carries of at least 7 meters ending in a pass that is followed by a goal",
        ShotEndingCarries: "Carries of at least 7 meters ending in a shot",
        GoalEndingCarries: "Carries of at least 7 meters ending in a goal",
        ShotEndingSequence: "Number of Sequences ending in a Shot where the player was involved",
        GoalEndingSequence: "Number of Sequences ending in a Goal where the player was involved",
        AerialWonOffensive: "Offensive aerial duel wins per 90 mins",
        AerialWonDefensive: "Defensive aerial duel wins per 90 mins",
        xGAgainst: "Expected goals conceded",
        xGDiffAgainst: "Difference between Expected Goals Conceded and Goals Conceded",
        xGPerNPGAgainst: "Expected goals received per non-penalty goal conceded",
        xGOpenPlayAgainst: "Expected goals generated by open play conceded",
        xGSetPieceAgainst: "Expected goals generated by set piece conceded",
        xGPerShotAgainst: "Expected goals received per shot conceded",
        ShotsAgainst: "Shots conceded per 90 mins",
        ShotsOnTargetAgainst: "Shots on target conceded per 90 mins",
        RivalPossession: "Possession of opponent",
        AerialDefensivePct: "Percentage of aerial wins without ball possession",
        HighRecoveries: "Recoveries made 40 meters close to the opponent goal",
        HighDefensiveActionPct: "Percentage of Defensive Actions (Tackles, Interceptions, Blocks, Fouls y 1vs1) made 40 meters over the own baseline",
        HighDefensiveDistance: "Average distance from own goal of all Defensive Actions",
        PassesPerPossession: "Number of passes per possession",
        LengthPerPossession: "Distance per possession",
        xTNet:"Net xT",
        AvgCarriesDistance:"Average Carries Distance",
        PassesForwardPct:"% Passes Go Forward",
        TacklesAttempted:"Tackles Attempted",
        DuelsLost:"Duels Lost",
        Carries:"Carries",
        CarriesPct: "% Carries",
        Aerials:"Total number of aerial duels per 90 minutes of play",
        ProgressivePassesReceivedIntoBox:"Progressive Passes Receive Into Box",
        PassesOppHalf: "Successful passes ending into the opponent half",
        LongBallReceived:"Number of Long Passes (>32 meters) Received",
        ShotsOnTarget:"Shots made on Target per 90 minutes",
        AggressiveActions: "Number of Tackles attempted in the next two seconds after losing the possession",
        Crosses:"Total Number or Crosses per 90 minutes of play",
        xGBuildup5pass: "Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)",
        DefensiveDistance: "Average distance to opponent goal of all defensive actions",
        SpeedSequence: "Average Speed (meters covered by time spent) of all possessions of a team",
        Touches: "Number of times a player has possession of the ball per 90 minutes of play",
        AerialsTotalOppHalf: "Aerial duels total into opponent half per 90 minutes of play",
        AerialsOppHalf: "Aerial duels successful into opponent half per 90 minutes of play",
        AerialsWonOppHalfPct: "Percentage of aerial duel wins into opponent half",
        AerialsPctOppBox: "Percentage of aerials duel wins into opponent box",
        AerialsPctOwnBox: "Percentage of aerials duel wins into own box",
        AerialDefensive: "Total number of aerials when own team has possession",
        AerialOffensive: "Total number of aerials when opponent team has possession",
        AerialOffensivePct: "Percentage of aerial wins when own team has possession",
        IndividualPressureOppHalf: "Possessions recovered by a player when pressing the opponent in the opponent half",
        TouchesPerShot: "Number of times players touch the ball per shot",
        PassesFinalThirdTotalPct: "Percentage of passes (successful and unsuccessful) into final third",
        xACrosses: "Expected assists generated from crosses per 90 minutes of play",
        Passes: "Total number of passes per 90 minutes of play",
        PassesSuccessful: "Number of Completed Passes per 90 minutes of play",
        TacklesWasDribbledFouls: "Percentage of tackles won with respect to total tackles and fouls committed",
        OffsidesCaught: "Offsides Caught",
        ProgressivePassesReceivedFinalThird: "Progressive Passes Received Final ⅓",
        ProgressivePassesReceived: "Progressive Passes Received",
        Breadth: "Sum of tackles, challenges, interceptions and fouls committed, on the sides of the field per 90 mins",
        DuelsDefTotal: "Sum of total tackles, defensive aerial duels and fouls committed",
        DefensiveActions: "Defensive Actions when an opponent tries to dribble (Tackles, Challenges and Fouls)",
        ProgressivePassesReceivedOppHalf: "Progressive Passes Received Opp. Half",
        CompletedCrossesOP: "Completed Crosses Open Play",
        CrossingOP: "Percentage of crosses completed out of all crosses attempted open play",
        PassingContribution: "Percentage that measures threat of passes taking into account the position of the receiver",
      	BallProgressionOppHalfInTeam: "% Ball progression in opponent half in team",
      	PassesOPIntoBoxInTeam: "% Passes open play into box in team",
      	TouchesOppBoxInTeam: "% Touches opponent box in team",
      	xGOPInTeam: "% xG open play in team",
        DeepPasses: "Passes from outside a 20-metre radius of the opponent goal that end inside that area",
        DefensiveDuelsPct: "Percentage of defensive duels won out of total defensive duels",
        DefensiveDistance: "Average distance to own goal of defensive duels performed",
        QuickRecoveriesPct: "Percentage of quick recoveries to interceptions and attempted tackles",
        DiffDefensiveDistanceTeam: "Difference between the player's defensive distance and his team's defensive distance",
        xTPassing: "Expected threat generated only from passes",
        xTPassing100Passes: "Expected threat generated only from passes and per 100 passes",
        ProgressivePassesAccurate: "Completed passes of 10 metres or more in the X-axis",
        PassAbility: "Ratio of completed passes to expected passes (xP)",
        OPPassesIntoOppBoxPct: "Percentage of open play completed passes into the opponent box and open play attempted passes into the opponent box",
        EntriesOppBox: "Number of passes and carries into the opponent box",
        Crosses6yardBox: "Total number of crosses ending in the six-yard box",
        Cutbacks: "Passing from baseline to back and inside the opponent box",
        xTDribbling: "Expected threat generated only from dribbles",
        AvgShotDistance: "Average distance of the total number of shots taken",
        xGOnTarget: "Expected goals from shots made on target per 90 mins.",
        FinishingxGOT: "Percentage of shots on target ending in a goal above average",
        DribblesWonOwnHalf: "Successful dribbles made in own half",
        DribblesOwnHalf: "Number of attempted dribbles made in own half",
        DribblesOwnHalfPct: "Percentage of successful dribbles and attempted dribbles made in own half",
        DribblesWonOppHalf: "Successful dribbles made in opponent half",
        DribblesOppHalf: "Number of attempted dribbles made in opponent half",
        DribblesOppHalfPct: "Percentage of successful dribbles and attempted dribbles made in opponent half",
        DribblesWonFinalThird: "Successful dribbles made in the final third",
        DribblesFinalThird: "Number of attempted dribbles made in the final third",
        DribblesFinalThirdPct: "Percentage of successful dribbles and attempted dribbles made in the final third",
        Score: 'Player performance based on different metrics',
        PDScore: 'Player physical performance based on different physical metrics',
        OrlegiScore: "Score Orlegi",
        EstorilScore: "Score Estoril",
        PecScore: "Score PEC",
        PaokScore: "Score PAOK",
        Hud1Score: "Hud Score 1",
        Hud2Score: "Hud Score 2",
        Hud3Score: "Hud Score 3",
        Hud4Score: "Hud Score 4",
        SDLScore: "Player Performance based on different metrics",
        xTOPInTeam: "Expected threat generated during open play in team",
        YellowCards: "Yellow cards received per 90 minutes of play",
        RedCards: "Red cards received per 90 minutes of play",
        xTOpenPlayAgainst: "Expected Threat conceded during open play per 90 minutes of play",
        xTSetPieceAgainst: "Expected Threat conceded by set piece per 90 minutes of play",
        NPGOpenPlayAgainst: "Number of non penalty goals conceded per 90 minutes of play by open play actions",
        NPGSetPieceAgainst: "Number of non penalty goals conceded per 90 minutes of play by set piece actions",
        PassesOppHalfPerPossession: "Passes Opp. Half per Possession",
        AverageTimeRecovery: "Avg Time Recovery",
        ExpectedPassing: "Percentage of Passes that should have been completed",
        NumPossession10Passes: "Possessions generated by 10 or more passes",
        PassesReceived: "Passes Received",
        PassesReceivedFinalThird: "Passes Received Final ⅓",
        ProgressivePassesTotalPct: "Percentage of Progressive Passes",
        ShortPassesPct: 'Percentage of Short Passes',
        //Physical Stats
        TotalDistance: "Total Distance",
        WalkingDistance: "Total distance that the Player has travelled during a match at a speed lower than 2 m/s (7.2 km/h)",
        JoggingDistance: "Total distance that the Player has travelled during a match at a speed between 2 m/s (7.2 km/h) and 4 m/s (14.4 km/h)",
        RunningDistance: "Total distance that the Player has travelled during a match at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h)",
        ExtremeAccelerations: "Number of times that the Player accelerates more than 3 m/s<sup>2</sup>",
        NumberOfRuns: "Number of runs completed at a speed between 14.4 km/h and 19.8 km/h",
        HsrDistance: "High Speed Running Distance > 19.8 km/h",
        HsrNumber: "High Speed Running Quantity > 19.8 km/h",
        HsrDistancePct: "% HSR Distance",
        SprintsNumber: "Sprints Quantity > 25.2 km/h",
        SprintsDistance: "Sprints Distance > 25.2 km/h",
        SprintNumberDeclinePct: "% Sprint Quantity Decline",
        SprintDistanceDeclinePct: "% Sprint Distance Decline",
        SprintDistancePct: "% Sprint Distance",
        Accelerations: "Accelerations Quantity",
        MaxSpeed: "Max. Speed",
        AvgMaxSpeed: "Average of maximum speed achieved by the player",
        MaxAccelerations: "Maximum metres/second<sup>2</sup> achieved by the player",
        BypassedPlayers: "This value is negative if the team recovers players behind the ball carrier during the carry event",
        BypassedDefenders: "This value is negative if the team recovers defenders behind the ball carrier during the carry event",
        PassesBypassingPlayers: "Number of passes that bypassed players",
        PassesBypassingDefenders: "Number of passes that bypassed defenders",
        BypassedPlayersPerPass: "Total number of players bypassed per passes",
        BypassedDefendersPerPass: "Total number of defenders bypassed per passes",
        LineBreakingPasses: "Completed passes at least 10% closer to the opp. goal and intersect a pair of players",
        LineBreakingPassesFM: "Number of midfield to forward line breaking passes",
        LineBreakingPassesMD: "Number of defenders to midfielders line breaking passes",
        LineBreakingThroughBalls: "Line Breaking Through Balls",
        LineBreakingPassesPerPass: "Number of lines broken per pass",
        TotalPassesUnderStrongPressure: "Total number of passes made under strong pressure (within 0-1.5 meters of the nearest opponent)",
        TotalPassesUnderLightPressure: "Total number of passes made under pressure (within 1.5-3 meters of the nearest opponent)",
        PassesUnderStrongPressure: "Number of successful passes made under strong pressure (within 0-1.5 meters of the nearest opponent)",
        PassesUnderLightPressure: "Number of successful passes made under pressure (within 1.5-3 meters of the nearest opponent)",
        PassingUnderStrongPressure: "Percentage of successful passes and total passes both under strong pressure (within 0-1.5 meters of the nearest opponent)",
        PassingUnderLightPressure: "Percentage of successful passes and total passes both under pressure (within 1.5-3 meters of the nearest opponent)",
        PassMadeReceiptsInSpace: "Passes made where the receiver is in the attacking half and has no defender in a 5 meter radius towards the direction of the goal",
        PassReceiptsInSpace: "Passes received in the attacking half and there is no defender in a 5 meter radius towards the direction of the goal",
        TotalStrongOnBallPressures: "Number of strong on-ball pressures (within 0-1.5 meters of the ball carrier)",
        TotalLightOnBallPressures: "Number of on-ball pressures (within 1.5-3 meters of the ball carrier)",
        StrongOnBallPressures: "Number of successful strong on-ball pressures (within 0-1.5 meters)",
        LightOnBallPressures: "Number of successful on-ball pressures (within 1.5-3 meters)",
        StrongOnBallPressuresPct: "Percentage of successful and total strong on-ball pressures (within 0-1.5 meters of the nearest opponent)",
        LightOnBallPressuresPct: "Percentage of successful and total on-ball pressures (within 1.5-3 meters of the nearest opponent)",
      },
      abbr:{
        Possession: "POS%",
        TimePossession: "TP",
        PassesPerShots: "PPS",
        PPDA: "PPDA",
        ExpectedPoints: "xP",
        Points: "P",
        Directness: "DIR",
        PassesPerLongBall: "PPLB",
        CrossingPerXG: "CPxG",
        PenaltySavedPenaltyFaced: "PSPF",
        Goals: "GOA",
        NonPenaltyGoals: "NPG",
        NPGOpenPlay: "NPGOP",
        NPGSetPiece: "NPGSP",
        Shooting: "SHO%",
        Finishing: "FIN%",
        xGEfficiency: "xGE",
        HeaderPerShot: "HPS",
        HeaderPerCross: "HPC",
        Assists: "ASS",
        ThroughBalls: "TB",
        CrossEfficiency: "CE",
        ScoringContribution: "SC",
        xAssistsOpenPlay: "xAOP",
        xAssistsSetPiece: "xASP",
        xAssistsOpenPlayInTeam: "xAOPiT",
        xAssistsSetPieceInTeam: "xASPiT",
        xGBuildupFinalThird: "xGBUPFT",
        xGChainFinalThird: "xGCFT",
        BallProgressionPassing: "BPP",
        BallProgressionDribbling: "BPD",
        TacklesWasDribbled: "TWD%",
        TacklesSuccessful: "STA",
        Interceptions: "INT",
        Clearances: "CLE",
        Fouls: "FOU",
        Recoveries: "REC",
        Shots: "SHO",
        ShotsPerGoal: "SPG",
        ShortPassesSuccessful: "SPS",
        PassingSuccessForwardPct: "PSF%",
        PassingSuccessBackwardPct: "PSB%",
        PassingForwardBackwardPct: "PFB%",
        LongBallPerPassesPct: "LBP%",
        LongBallReceived: "LBR",
        LongBallReceivedOppHalf: "LBROH",
        OffensiveActions: "OA",
        DribblesAttempted: "DAT",
        SuccessfulDribblesPct: "SD%",
        OffensiveTouchesOutBoxPct: "OTOB%",
        BallRetention: "BR",
        PassingPct: "PA%",
        PassingOwnHalfPct: "POH%",
        PassingOppHalfPct: "POPH%",
        PassingFinalThird: "PFT",
        PassingFinalThirdPct: "PT%",
        LongBallSuccessful: "LBS",
        LongBallPct: "LB%",
        SavesPct: "S%",
        SavesInBoxPct: "SIB%",
        SavesOutOfBoxPct: "SOOB%",
        xGSavedPerXGFacedOnTarget: "xGSPFOT",
        xGFacedOnTargetPerGoalReceived: "xGFOTPGR",
        xGFacedOnTargetEfficiency: "xGFOTE",
        xGFacedOnTarget: "xGFOT",
        IndividualPressure: "IP",
        AerialEfficiency: "AE",
        AerialWins: "AEW",
        AerialWinsPct: "AE%",
        xG: "xG",
        xGDiff: "xGD",
        xGOpenPlay: "xGOP",
        xGSetPiece: "xGSP",
        xGPerShot: "xGPS",
        ChancesCreated: "CC",
        CompletedCrosses:"SCR",
        Crossing: "CR%",
        OpenPlayKeyPasses: "OPKP",
        OpenPlayKeyPassesInTeam: "OPKPiT%",
        OpenPlayPassesIntoOpponentBox: "OPPOPPB",
        OpenPlayPassesIntoOpponentBoxSuccessful: "OPPOPPBS",
        xAssists: "xA",
        xGChain: "xGC",
        xGBuildup: "xGBUP",
        xGBuildupInTeam: "xGBUPiT",
        BallProgression: "BP",
        SuccessfulDribbles: "SDR",
        Dispossessed: "TOV",
        TouchesInOpponentBox: "TOB",
        xGSavedPerShot: "xGSS",
        BallRetentionOppHalf: "BROPPH",
        DeepProgression: "DP",
        DeepProgressionFinalThird: "DPFT",
        FoulsTaken: "FOUR",
        PenaltiesTaken: "PT",
        BlockedCrosses: "BC",
        BlockedShots: "BS",
        Blocks: "BLO",
        NonPenaltyGoalsAgainst: "NPGC",
        Headers: "HEA",
        AveragePassDistance: "APD",
        ProgressiveRuns: "PRC",
        xT: "xT",
        xTOpenPlay: "xTOP",
        xTSetPiece: "xTSP",
        xGOT: "xGOT",
        BadActions: "BA",
        BadActionsOwnHalf: "BAOH",
        AerialsWonOwnBox: "AWOB",
        AerialsWonOppBox: "AWOPPB",
        AerialsTotalOppBox: "ATOPPB",
        AerialsTotalOwnBox: "ATOB",
        FoulsOwnHalfPct: "FOH%",
        RecoveriesOppHalf: "ROH",
        DuelsPct: "D%",
        TacklesUnsuccessful: "UTA",
        LongBallSuccessful: "SLB",
        TacklesWasDribbledFirstThird: "TWDFT",
        TacklesWasDribbledSecondThird: "TWDST",
        TacklesWasDribbledFinalThird: "TWDFT",
        BallProgressionFinalThird: "BPFT",
        DuelsTotal: "DT",
        QuickRecoveries: "QR",
        ShotsPerNPG: "SPNPG",
        ShotsOutBox: "SOB",
        GoalsOutBox: "GOB",
        ShootingOutBox: "SOB%",
        HandPassing: "HP",
        Catching: "CAT",
        ClaimAccuracy: "CA",
        HighTurnovers: "HTOV",
        ShotEndingHighTurnovers: "SEHT",
        GoalEndingHighTurnovers: "GEHT",
        AverageCarriesProgress: "ACP",
        ChanceEndingCarries: "CEC",
        AssistEndingCarries: "AEC",
        ShotEndingCarries: "SEC",
        GoalEndingCarries: "GEC",
        ShotEndingSequence: "SES",
        GoalEndingSequence: "GES",
        xGPerNPG: "xGPNPG",
        AerialWonOffensive: "AWO",
        AerialWonDefensive: "AWD",
        xGAgainst: "xGC",
        xGDiffAgainst: "xGDC",
        xGPerNPGAgainst: "xGPNPGA",
        xGOpenPlayAgainst: "xGOPC",
        xGSetPieceAgainst: "xGSPC",
        xGPerShotAgainst: "xGSC",
        ShotsAgainst: "STC",
        ShotsOnTargetAgainst: "SOTC",
        RivalPossession: "RP",
        AerialDefensivePct: "AD%",
        HighRecoveries: "HR",
        HighDefensiveActionPct: "HDA%",
        HighDefensiveDistance: "HDD",
        PassesPerPossession: "PPP",
        LengthPerPossession: "LPP",
        xTNet: "xTN",
        AvgCarriesDistance: "ACD",
        PassesForwardPct: "PF%",
        TacklesAttempted: "ATA",
        DuelsLost: "DL",
        Carries: "CARR",
        CarriesPct: "CARR%",
        Aerials: "AER",
        ProgressivePassesReceivedIntoBox: "PPRIB",
        PassesOppHalf: "POPH",
        ShotsOnTarget: "SOT",
        AggressiveActions: "AA",
        Crosses: "CRO",
        xGBuildup5pass: "xGBUP5",
        DefensiveDistance: "DD",
        SpeedSequence: "SS",
        Touches: "TOU",
        AerialsTotalOppHalf: "ATOPPH",
        AerialsOppHalf: "AOPPH",
        AerialsWonOppHalfPct: "AWOH%",
        AerialsPctOppBox: "AOPPB%",
        AerialsPctOwnBox: "AOB%",
        AerialDefensive: "AD",
        AerialOffensive: "AO",
        AerialOffensivePct: "AO%",
        IndividualPressureOppHalf: "IPOPPH",
        ChancesCreatedOP: "CCOP",
        TouchesPerShot: "TPS",
        PassesFinalThirdTotalPct: "PFT%",
        xACrosses: "xAC",
        Passes: "PAS",
        PassesSuccessful: "SPA",
        TacklesWasDribbledFouls: "TWDF",
        OffsidesCaught: "OC",
        ProgressivePassesReceivedFinalThird: "PPRFT",
        ProgressivePassesReceived: "PPR",
        Breadth: "BRD",
        DuelsDefTotal: "DDT",
        DefensiveActions: "DA",
        ProgressivePassesReceivedOppHalf: "PPROH",
        CompletedCrossesOP: "CCOP",
        CrossingOP: "COP",
        PassingContribution: "PC",
        BallProgressionOppHalfInTeam: "BPOPPHiT",
        PassesOPIntoBoxInTeam: "POBIT",
        TouchesOppBoxInTeam: "TOBIT",
        xGOPInTeam: "xGOPiT",
        DeepPasses: "DP",
        DefensiveDuelsPct: "DD%",
        DefensiveDistance: "DD",
        QuickRecoveriesPct: "QR%",
        DiffDefensiveDistanceTeam: "DDDT",
        xTPassing: "xTP",
        xTPassing100Passes: "xTP100",
        ProgressivePassesAccurate: "APP",
        xP: "xP",
        PassAbility: "PA",
        OPPassesIntoOppBoxPct: "OPPIOB%",
        EntriesOppBox: "EOPPB",
        Crosses6yardBox: "C6YB",
        Cutbacks: "CUT",
        xTDribbling: "xTD",
        AvgShotDistance: "ASD",
        xGOnTarget: "xGOT",
        FinishingxGOT: "FxGOT",
        DribblesWonOwnHalf: "DWOH",
        DribblesOwnHalf: "DOH",
        DribblesOwnHalfPct: "DOH%",
        DribblesWonOppHalf: "DWOPH",
        DribblesOppHalf: "DOPH",
        DribblesOppHalfPct: "DOPH%",
        DribblesWonFinalThird: "DWFT",
        DribblesFinalThird: "DFT",
        DribblesFinalThirdPct: "DFT%",
        Score: "SCO",
        PDScore: "SCO",
        xTOPInTeam: "xTOPiT",
        YellowCards: "YC",
        RedCards: "RC",
        xTOpenPlayAgainst: "xTOPC",
        xTSetPieceAgainst: "xTSPC",
        NPGOpenPlayAgainst: "NPG OPC",
        NPGSetPieceAgainst: "NPG SPC",
        PassesOppHalfPerPossession: "POHP",
        AverageTimeRecovery: "ATR",
        ExpectedPassing: "xP%",
        NumPossession10Passes: "P10P",
        PassesReceived: "PR",
        PassesReceivedFinalThird: "PRLFT",
        ProgressivePassesTotalPct: "PP%",
        ShortPassesPct: "SP%",
        TotalDistance: "DST",
        WalkingDistance: "WLKD",
        JoggingDistance: "JOGD",
        RunningDistance: "RUND",
        ExtremeAccelerations: "XACC",
        NumberOfRuns: "RUNQ",
        HsrDistance: "HSRD",
        HsrNumber: "HSRQ",
        HsrDistancePct: "HSRD%",
        SprintsNumber: "SPRQ",
        SprintsDistance: "SPRD",
        SprintNumberDeclinePct: "SQD%",
        SprintDistanceDeclinePct: "SDD%",
        SprintDistancePct: "SPRD%",
        Accelerations: "ACC",
        MaxSpeed: "MS",
        AvgMaxSpeed: "AvgMS",
        MaxAccelerations: "MACC",
        BypassedPlayers: "ByPP",
        BypassedDefenders: "ByPD",
        PassesBypassingPlayers: "PByPP",
        PassesBypassingDefenders: "PByPD",
        BypassedPlayersPerPass: "ByPPPP",
        BypassedDefendersPerPass: "ByPDPP",
        LineBreakingPasses: "LBP",
        LineBreakingPassesFM: "LBPFM",
        LineBreakingPassesMD: "LBPMD",
        LineBreakingThroughBalls: "LBTB",
        LineBreakingPassesPerPass: "LBPP",
        TotalPassesUnderStrongPressure: "TPUSP",
        TotalPassesUnderLightPressure: "TPUP",
        PassesUnderStrongPressure: "PUSP",
        PassesUnderLightPressure: "PULP",
        PassingUnderStrongPressure: "PUSP%",
        PassingUnderLightPressure: "PULP%",
        PassMadeReceiptsInSpace: "PRMS",
        PassReceiptsInSpace: "PRS",
        TotalStrongOnBallPressures: "TSBP",
        TotalLightOnBallPressures: "TBP",
        StrongOnBallPressures: "SBP",
        LightOnBallPressures: "BP",
        StrongOnBallPressuresPct: "SBP%",
        LightOnBallPressuresPct: "BP%",
      }
    },
    team: {
      title: "Team Sheet",
      subtitle: "Go deeper into the team's characteristics and statistics",
      averageAge: "Avg. age",
      transferBalance: "Transfer Balance",
      roster: "Roster",
      transfers: "Transfers",
      trends: "Trends",
      loans: "Loans",
      loanFrom: "Loan from",
      loanTo: "Loan to",
      latestGames: "Latest Games",
      latestXGames: "Latest {0} Games",
      playingFor: "Playing for",
      overview:"Overview",
      visualization:"Visualization",
      location:"Location",
      outcome:"Outcome",
      beeswarm:"Ranking",
      parentTeam: "Top Team",
      childTeam: "Youth Team",
      preferredFormation: "Preferred Formation",
      mostFrecuentFormations: "Most frecuent formations",
      viewType:"View Type",
      overviewTab: {
        axisXTotal: "Total",
        axisXper90: "Per 90'",
        dataPerGameText: "Data per game",
        season: "Season",
        last: "Last",
        current: "Current",
        TeamStyle: "Style",
        TeamDefensive: "Defensive",
        TeamOffensive: "Offensive",
        TeamCustom1: "Custom 1",
        TeamCustom2: "Custom 2",
        TeamCustom3: "Custom 3",
        TeamCustom4: "Custom 4",
        coach: "Coach",
        groups: {
          Goals: {
            name: "Goals",
            desc: "Shows Penalty Goals and Non-Penalty Goals (Open Play and Set Piece)."
          },
          Assists: {
            name: "Assists",
            desc: "Players with more Assists (Open Play and Set Piece) this season."
          },
          xG: {
            name: "Expected Goals",
            desc: "Expected Goals from Open Play and Set Piece"
          },
          xA: {
            name: "Expected Assists",
            desc: "Expected Assists from Open Play and Set Piece."
          },
          Finishing: {
            name: "Finishing",
            desc: "Percentage of shots ending in a goal."
          },
          ScoringContribution: {
            name: "Scoring Contribution",
            desc: "Number of Assists and Goals of the team."
          },
          xT: {
            name: "Expected Threat",
            desc: "Expected Threat generated from Open Play, Set Piece and negative xT."
          },

        },
        stats: {
          openPlay: "Open Play",
          setPiece: "Set Piece",
          negative: "Negative",
          npg: "Non-Penalty Goals",
          goalsPenalty: "Penalty Goals",
          npgOpenPlay: "NPG Open Play",
          npgSetPiece: "NPG Set Piece",
          assists: "Assists",
          assistsOpenPlay: "Assists Open Play",
          assistsSetPiece: "Assists Set Piece",
          xGOpenPlay: "xG Open Play",
          xGSetPiece: "xG Set Piece",
          xAOpenPlay: "xA Open Play",
          xASetPiece: "xA Set Piece",
          nonPenaltyShots: "Non-Penalty Shots",
          penaltyShots: "Penalty Shots",
          xT: "Expected Threat",
          xTOpenPlay: "xT Open Play",
          xTSetPiece: "xT Set Piece",
          xTNeg: "Negative xT",
          totalFinishing: "Finishing",
          nonPenaltyFinishing: "Non Penalty Finishing",
          goalsPenaltyFinishing: "Penalty Finishing",
          goal: "Goal",
          notGoal: "Not Goal",
          chance: "Chance",
          finished: "Finished",
          notFinished: "Not Finished",
          walkingDistance: "Walking",
          joggingDistance: "Jogging ",
          runningDistance: "Running ",
          hsrDistance: "HSR",
          sprintsDistance: "Sprinting",
          runningNumber: "Runs",
          hsrNumber: "HSR Sprints",
          sprintsNumber: "Sprints",
          maxSpeed: "Max. Speed",
          accelerations: "Accelerations",
          extremeAccelerations: "Extreme accelerations",
          maxAcceleration: "Maximum acceleration"
        },
      },
      teamAnalysis: "Team Analysis",
      agentView:{
        positions:{
          "gk": "GK",
          "leftFullback": "Left FB",
          "centralDefender": "Central Def.",
          "rightFullback": "Right FB",
          "midfielder": "Midfielder",
          "attackingMidfielder": "Attacking Mid.",
          "leftWinger": "Left Winger",
          "rightWinger": "Right Winger",
          "fw": "FW"
        },
        groups: {
          "contractEnd":"Months",
          "age":"Years Old",
          "availability":"Availabity",
        },
        placer: {
          legend:"Strength based on age, contract, availability and performance"
        }
      },
      transfersTab:{
        valueMovements:"Movements Value",
        valueTransfers:"Transfers Value",
        valueLoans:"Loans Value",
        avgAgeMovements:"Movements Avg. Age",
        avgAgeTransfers:"Transfers Avg. Age",
        avgAgeLoans:"Loans Avg. Age",
        operations:{
          buys:{
            "buy": "Buy",
            "loan": "Loan",
            "end of loan": "End of Loan",
            "free transfer":"Free",
            "free":"Free",
            "loan transfer":"Loan",
            "other":"Other",
          },
          sells:{
            "buy": "Sell",
            "loan": "Loan",
            "end of loan": "End of Loan",
            "free transfer":"Free",
            "free":"Free",
            "loan transfer":"Loan",
            "other":"Other",
            "retired": "Retired"
          }
        }
      },
      trendsTab: {
        streaks: "Streaks",
        wins: "Wins",
        cleanSheets: "Clean Sheets",
        goalPeriods: "Scored Goal Periods",
        concededGoalPeriods: "Conceded Goal Periods",
        comebacks: "Comebacks",
        avgTime: "Average Time",
        kindOfGoals: "Kind of Goals",
        percentWinning: "% Winning",
        percentDrawing: "% Drawing",
        percentLosing: "% Losing",
        totalOf: "Total of",
        minutes: "minutes",
        before: "Before",
        after: "After",
        playedOn: "Played on",
        scored: "Scored",
        conceded: "Conceded",
        ownGoals: "Own Goals"
      },
      onOff: "On/Off",
      dragUpTo5Players: "Drag up to 5 players",
      selectUpTo5Players: "Select up to 5 players",
      onOffTab:{
        G90:"Goals 90",
        GA90:"Goals Against 90",
        diffG90:"Goals Difference 90",
        XG90:"xG 90",
        XGA90:"xG Against 90",
        diffXG90:"xG Difference 90",
        playersOn:"Combo ON",
        playersOff:"Combo OFF",
        ground:"Ground",
        playersOnThePitch:"Players on the pitch",
        playersOffThePitch:"Players out of the pitch",
        attackTitle:"Attack",
        attackSubTitle:"Offensive Stats",
        defenseTitle:"Defense",
        defenseSubTitle:"Defensive Stats",
        associationTitle:"Association",
        associationSubTitle:"Associative Stats",
        comboOn: "Active Combo",
        comboOff: "Any other",
        "diffGoals90": "G Diff 90",
        "goals90": "Non-Penalty Goals 90",
        "goalsAgainst90": "Non-Penalty Goals Against 90",
        "xgAgainstPer90": "xG Against 90",
        "xgDiffPer90": "xG Diff 90",
        "xgPer90": "xG 90",
        "xt90": "xT 90",
        "shotsOnTarget90": "Shots On Target 90",
        "touchesOppBox90":"Touches Opp Box 90",
        "shotsOnTargetAgainst90":"Shots On Target Against 90",
        "ppda90":"PPDA 90",
        "xa90":"xA 90",
        "directness90":"Directness 90",
        "possession":"Possession %",
        "pctPasses":"Passes %",
        "pctPassesFinalThird":"Passes Final Third %",
        placeholder: "Start by selecting a team",
        subtitle: "Optimize the team's metrics by adding or removing players from the lineup"
      },
      terms:{
        short:'Short Term',
        mid:'Mid Term',
        long:'Long Term',
      },
      report: {
        title: 'Team Report',
        selectedPeriod: 'Selected Period',
        stackedCharts: 'Stacked Charts',
        generalData: 'General Data',
        scoringChances: 'Scoring Chances',
        areasReport: 'Areas Report',
        setPieceReport: 'Set Piece Report',
        corners: 'Corners',
        cornersAgainst: 'Corners Against',
        indirectFreeKicks: 'Indirect Free Kicks',
        indirectFreeKicksAgainst: 'Indirect Free Kicks Against',
        freeKicks: 'Free Kicks',
        freeKicksAgainst: 'Free Kicks Against',
        penaltys: 'Penaltys',
        freeKicksContribution: 'Free Kicks Contribution',
        shotsContribution: 'Shots Contribution',
        topXPlayersByStats: 'Top {x} Players by Stats',
        lastShotZone: 'Last Zone Shot',
        throwSide: 'Throw Side',
        kindOfThrow: 'Kind of Throw',
        scored: 'Scored',
        against: 'Against',
        perGame: 'per Game',
        total: 'Total',
        efficiency: 'Efficiency',
        organizedAttack: 'Organized Attack',
        offTransition: 'Offensive Transition',
        chances: 'Chances',
        chancesScored: 'Chances Scored',
        chancesAgainst: 'Chances Against',
        goalsScored: 'Goals Scored',
        goalsAgainst: 'Goals Against',
        goalsOrganizedAttack: 'Goals Organized Attack',
        goalsOffTransition: 'Goals Offensive Transition',
        goalsSetPiece: 'Goals Set Piece',
        goalsOrganizedAttackScored: 'Goals Org. Att. Scored',
        goalsOrganizedAttackAgainst: 'Goals Org. Att. Against',
        goalsOffTransitionScored: 'Goals Off. Tran. Scored',
        goalsOffTransitionAgainst: 'Goals Off. Tran. Against',
        goalsSetPieceScored: 'Goals Set Piece Scored',
        goalsSetPieceAgainst: 'Goals Set Piece Against',
        crossSide: 'Cross Side',
        externalShot: 'External Shot',
        innerPlay: 'Inner Play',
        throwIn: 'Throw In',
        box: 'Box',
        zone2: 'Zone 2',
        goalsPerPhases: 'Goals per Phases'
      },
      minutesAlert:"*Showing only players with 450 or more minutes played",
      minutesException:"There are not players with 450 or more minutes played. Showing all players",
      analysis: "Analysis",
      substitutions:"Substitutions",
      attackZones:"Attack Zones",
      formations:"Formations",
      shotZones:"Shot Zones",
      crossings:"Crossings",
      byTime:"By Time",
      byPosition:"By Position",
      byPlayer:"By Player",
      W:"Winning",
      D:"Drawing",
      L:"Losing",
      substitutionsByGame:"Substitutions by game",
      substitutionsShort:"Subs.",
      avgSeasonShort:"Avg. Season",
      startingAt:"Starting at",
      endingAt:"Ending at",
      startingAtInfo: "Shows share of possessions based on the location of the first event",
      endingAtInfo: "Shows share of possessions based on the location of the last event",
      endingWithShot:"Ending with shot",
      endingInBox:"Ending in box",
      pfX:"PF {x}",
      bySide: "By Side",
      cornerKicks:"Corner Kicks",
      included: "Included",
      excluded:"Excluded",
      onlyCorner:"Only Corner",
      sizeByMarketValue:"Size by Market Value",
      timeInTeam:"Seasons in Team",
      newSignings:"New Signings",
      sizeBy:"Size by",
      connections:"Connections",
      assistant:"Passer",
      finisher:"Finisher",
      playersMinutesAlert: "Showing only players with minutes played in the selected season",
    },
    leagueTable: {
      subtitle: "Check how the leagues go"
    },
    teamStats: {
      subtitle: "Compare how teams are performing",
      xGDiffPerGame: "xGD",
      xGDiffPerGameExplicit: "Difference between Expected Goals and Goals",
      expectedPointsDiff: "xPD",
      expectedPointsDiffExplicit: "Difference between Expected Points and Points",
      games: "GAM",
      gamesExplicit: "Games played",
      pointsPerGame: "PPG",
      pointsPerGameExplicit: "Points per Game",
    },
    roles: {
      "ROLE_USER": "User",
      "ROLE_ADMIN": "Admin",
      "ROLE_REPORTS": "Driblab Reports",
      "ROLE_API": "Driblab API",
      "ROLE_PHYSICAL_DATA": "Driblab Physical Data",
      "ROLE_VIDEO": "Capture",
      "ROLE_EVENTING_DATA": "Driblab XY",
      "ROLE_DRIBLAB_HUB": "Driblab Hub",
      "ROLE_TRACKING": "Tracking",
      "ROLE_ARRIGO": "Arrigo",
      "ROLE_API_description": "Extract player, team, game and league info effortlessly in JSON format.",
      "ROLE_EVENTING_DATA_description": "Dive deep into statistics with Radar Charts, Player Rankings, maps and more based on +100 performance metrics.",
      "ROLE_PHYSICAL_DATA_description": "Access fitness data and filter players by various performance metrics (distance, speed, sprints, acceleration…).",
      "ROLE_VIDEO_description": "Provide videos and lineups and get games tagged with events and statistics for in-depth analysis.",
      "ROLE_DRIBLAB_HUB_description": "Efficiently track and manage scouting tasks with calendars, notes, alerts and document sharing.",
      "ROLE_TRACKING_description": "Receive positional data of all players in a game through our API for comprehensive analysis.",
      "ROLE_ARRIGO_description": "Combine eventing and tracking data into innovative metrics that go beyond the traditional and add value to every action.",
      "ROLE_REPORTS_description": "Request detailed scouting reports from our team of analysts to find the perfect team or player."
    },
    administration: {
      pageSubtitle: "Manage the application's operation",
      newClient: "New Client",
      newUser: "New User",
      editClient: "Edit Client",
      editUser: "Edit User",
      clientName: "Name",
      permissions: "Permissions",
      releaseUser: "Release User",
      connectAsUser: "Connect as User",
      releaseModalTitle: "Release User Confirmation",
      releaseModalMessage: "The user will recieve an email about his new account. Are you sure you want to notify him?",
      clientType: {
        Driblab: "Driblab",
        Team: "Team",
        Brand: "Brand",
        Federation: "Federation",
        Media: "Media",
        Agency: "Agency",
        Individual: "Individual"
      },
      userType: {
        Ownership: "Ownership",
        SportingDirector: "Sporting Director",
        Brand: "Brand",
        Federation: "Federation",
        Media: "Media",
        Agency: "Agency",
        Individual: "Individual",
        Scout: "Scout",
        Coach: "Coach"
      },
      visibleYears: "Visible Years",
      areaModalTitle:"Activate/Deactivate Leagues Confirmation",
      areaModalMessage:"Are you sure to activate/deactivate all leagues from selected area?",
      countStats:"Count Stats",
      userClientModalTitle:"User already exists in another client",
      eventing: "Eventing",
      hub: "Hub"
    },
    dashboards: {
      lastGame: "Last game analysis",
      lastGameSimple: "Last game",
      seeAllGameInfo: "See all game info",
      nextGame: "Next Game Preview",
      myTeam: "My Team",
      lastMatchdayGames: "Last Matchday",
      lastAdded: "Last Added",
      myFavorites: "My Favorites",
      seeAllFavorites: "See all favorites",
      placeholderFavorites: "You can add favorites from player detail",
      placeholderTeamFavorites: "You can add favorites from team detail",
      myCollections: "My Collections",
      placeholderCollections: "You don´t have any collections yet",
      lastCreated: "Last Created",
      seeAllCollections: "See all collections",
      seeRival: "See Opponent",
      seeMyTeam: "See My Team",
      title: "Dashboard Overview",
      subtitle: "Welcome back",
      recentPlayers: "Recent players",
      lastScouted: "Last scouted",
      scout: "Scout",
      reportsRequested: "Reports",
      lastRequested: "Last requested",
      goInbox: "Go Inbox",
      placeholderLastScouted: "You can search for players in the left bar or in the scout tool",
      placeholderReports: "You can request reports from players detail",
      nationalPlayers: "Most valuable national players in others countries",
      lastGames: "Last Games",
      nationalPlayersShort: "National players in others countries",
      nextMatchdayGames: "Next Matchday",
      injuredPlayers: "Injured Players",
      atPresent:"Nowadays",
      seeAllPlayers:"See all players",
      suspendedPlayers: "Suspended Players",
      placeholderInjured:"There are no injured players",
      teamValueImpacted: "Team Value Impacted",
      placeholderSuspended:"There are no suspended players",
      placeholderNextGame:"There is no available game",
      placeholderNoGames:"There are no games available yet",
      placeholderLastMatchDayNotFound:"Last matchday not available",
      placeholderNextMatchDayNotFound:"Next matchday not available",
      usersMostSearch:"Users with most searches",
      lastTwoDays:"Last two days",
      searchesHistory:"Searches History",
      dayByDay:"Daily",
      activeUsersTitle:"Active Users",
      activeUsersSubtitle: "Logged at least one in last month",
      onlineUsersTitle:"Online Users",
      onlineUsersSubtitle: "Search something in last hour",
      searchesPerformed:"Searches Made",
      onlyClients:"Only clients",
      activeClientsTitle:"Active Clients",
      activeClientsSubtitle: "Have at least one active user",
      last24Hours:"Last 24 Hours",
      activityHistory:"Activity History",
      loginHistory:"Access History",
      failLogins:"Fail Access",
      successLogins:"Success Access",
      clientStats:"Client Stats",
      playersMostSearch: "Players with most searches",
      toolsMoreUsed: "More used tools",
      hotPlayers:"Hot Players",
      last_month:"Last Month",
      last_week:"Last Week",
      last_day:"Last Day",
      nClients:"Nº of Clients",
      userDashboard: "User Dashboard",
      userDashboardSubtitle: "Account activity summary",
      offlineDaysOfClient: "Offline days for each client",
      hideNoConnected: "Hide no connected",
      onlyTrial: "Only trial clients",
      daysWithoutLogin: "Days without logging in",
      trialDays: "Trial days"
    },
    faq: {
      subtitle: "Learn more about what Driblab PRO is",
      categories: {
        playerMetrics: "Player Metrics",
        teamMetrics: "Team Metrics",
        positions: "Team Positions",
        tools: "Tools",
        api: "API",
        videos:"Tutorials",
        playerPositions: "Player Positions"
      },
      positions:{
        "GK": "Goal Keeper",
        "DR":"Defender Right / Right Fullback (RB)",
        "DC":"Defender Center / Center Back (CB)",
        "DL":"Defender Left / Left Fullback (LB)",
        "DMR":"Right Wingback (RWB)",
        "DMC":"Centre Defensive Midfielder (CDM)",
        "DML":"Left Wingback (LWB)",
        "MR":"Right Midfielder (RM)",
        "MC":"Center Midfielder (CM)",
        "ML":"Left Midfielder (LM)",
        "AMR":"Attacking Midfielder Right / Right Winger (RW)",
        "AMC":"Attacking Midfielder Center / Advanced Midfielder",
        "AML":"Attacking Midfielder Left / Left Winger (LW)",
        "FWR":"Forward Right / Right Striker (RS)",
        "FW":"Forward / Striker (ST)",
        "FWL":"Forward Left / Left Striker (LS)"
      },
      metrics: {
        categories: {
          Association: "Association",
          Saving: "Saving",
          Shooting: "Shooting",
          Defending: "Defending",
          Passing: "Passing",
          BallHandling: "Ball Handling",
          Aerial: "Aerial",
          Physical: "Physical",
          Predictive: "Predictive",
          Score: "Score",
          Turnovers: "Turnovers",
          Carries: "Carries",
          SequenceInvolvement: "Sequence Involvement",
          Crosses: "Crosses",
          Distance: "Distance",
          Sprint: "Sprint",
          Acceleration: "Acceleration",
          Speed: "Speed",
          Packing: "Packing",
          LineBreakingPasses: "Line Breaking Passes",
          PassUnderPressure: "Pass Under Pressure",
          BallReceived: "Ball Receipts",
          OnBallPressure: "On-Ball Pressure",
          PitchControl: "PitchControl",
          OffBallPressure: "Off-Ball Pressure",
          NoCategory: "Others",
          desc: {
            Association: "Association",
            Saving: "Saving",
            Shooting: "Shooting",
            Defending: "Defending",
            Passing: "Passing",
            BallHandling: "Ball Handling",
            Aerial: "Aerial",
            Physical: "Physical",
            Predictive: "Predictive",
            Score: "Score",
            Turnovers: "Turnovers",
            Carries: "Carries",
            SequenceInvolvement: "Sequence Involvement",
            Crosses: "Crosses",
            Distance: "Distance covered at different speeds",
            Sprint: "Sprint at different speeds",
            Acceleration: "Acceleration",
            Speed: "Speed achieved by players at some point during the match",
            Packing: "Packing",
            LineBreakingPasses: "Line Breaking Passes",
            PassUnderPressure: "Pass Under Pressure",
            BallReceived: "Ball Receipts",
            OnBallPressure: "On-Ball Pressure",
            PitchControl: "PitchControl",
            OffBallPressure: "Off-Ball Pressure",
          },
          abbr: {
            Association: "Association",
            Saving: "Saving",
            Shooting: "Shooting",
            Defending: "Defending",
            Passing: "Passing",
            BallHandling: "Ball H.",
            Aerial: "Aerial",
            Physical: "Physical",
            Predictive: "Predictive",
            Score: "Score",
            Turnovers: "TOV",
            Carries: "Carries",
            SequenceInvolvement: "Seq. Involv.",
            Crosses: "Crosses",
            Distance: "Distance",
            Sprint: "Sprint",
            Acceleration: "Acceleration",
            Speed: "Speed",
            Packing: "Packing",
            LineBreakingPasses: "Line Breaking Passes",
            PassUnderPressure: "Pass Under Pressure",
            BallReceived: "Ball Receipts",
            OnBallPressure: "On-Ball Pressure",
            PitchControl: "PitchControl",
            OffBallPressure: "Off-Ball Pressure",
          },
        },
        types: {
          1: "Per 90",
          2: "Percentage",
          3: "Rate",
          4: "Efficiency",
          5: "Average",
          6: "Per Game",
          7: "Difference",
          8: "Max",
        }
      },
      api:{
        subtitle:"Get data from different requests",
        resourcesTitle: "Resources",
        authentication: "Authentication",
        authText: "In order to call the API you have to include in every request the header `Authorization` with value `Bearer {API_TOKEN}`",
        generate:"Generate",
        tokenPlaceholder:"If you do not have a token or it has expired, click on 'Generate'",
        pathParameters:"Path Parameters",
        queryParameters:"Query Parameters",
        responseModel:"Response Model",
        tokenWarning:"* Generate a token in order to use the API",
        pathParamsWarning:"* There are unfilled Path Parameters",
        genericDescription:"An API (Application Programming Interface) allows developers to access and integrate data or functionality into their own applications. Our football statistics API provides comprehensive access to a variety of data points about countries, competitions, teams, players, games, and more. By using this API, you can build applications that leverage our rich soccer data for analytics, visualizations, or other innovative solutions.",
        methods:{
          getAllCountries:"This method retrieves a complete list of all countries available in the API, providing key details such as each country's unique identifier and name. This endpoint is ideal for applications that require geographic soccer data, enabling features like country selection, filtering, and analytics. It also serves as a foundational resource for interacting with other endpoints that depend on a `countryId` parameter, ensuring smooth navigation and integration with the API's broader dataset.",
          getCountryDetail:"This method provides detailed information about a specific country available in the API. By using this endpoint, you can retrieve data such as the country's name, code, and any relevant metadata associated with it. This method is particularly useful for applications requiring country-specific details to enhance user experience, such as displaying contextual information or creating tailored insights based on geographic data. It complements other endpoints by allowing deeper exploration of a selected country.",
          getCountryCompetitions:"This method retrieves a list of all competitions available within a specific country. It is a valuable resource for building features that allow users to explore competitions by region, providing a seamless way to connect country data with its associated tournaments. This endpoint is essential for applications focusing on localized soccer content or regional analytics.",
          getAllCompetitionTypes:"This method returns a list of all competition types available in the API, such as leagues, cups, and international tournaments. This endpoint is ideal for categorizing competitions and providing users with an organized view of the different types of events covered. It is especially useful for building features like filters or dropdowns that allow users to explore soccer data based on the nature of the competition.",
          getAllCompetitions:"This method retrieves a comprehensive list of all competitions available in the API, regardless of type or location. This endpoint is useful for applications that need to display or analyze a wide range of soccer competitions, allowing users to explore and select events of interest.",
          getCompetitionAvailable:"This method retrieves a list of competitions currently marked as available in the API. This ensures that the returned data is up-to-date and ready for use in applications. It is particularly useful for developers building features that rely on active or accessible competitions, enabling users to explore relevant events without encountering outdated or incomplete data.",
          getCompetitionDetail:"This method provides detailed information about a specific competition available in the API. It is particularly useful for applications that require in-depth information about a competition, enabling features like detailed views, contextual insights, or filtering options based on competition characteristics.",
          getCompetitionSeasons:"This method retrieves a list of all seasons associated with a specific competition. This endpoint is essential for applications that aim to provide comprehensive coverage of a competition's history or current state, allowing users to explore data season by season.",
          getSeasonAvailable:"This method provides a list of seasons currently marked as available in the API. It is particularly useful for applications that focus on live or ongoing soccer events, allowing users to interact with relevant and current season data.",
          getSeasonDetail:"This method retrieves detailed information about a specific season, including its timeline, associated competition, and key metadata. This endpoint is essential for applications that require in-depth insights into a particular season, enabling features like season overviews, filtering by competition, or displaying detailed timelines for user interaction.",
          getSeasonTeams:"This method provides a list of all teams participating in a specific season. It is ideal for features like roster management, team performance analysis, or creating season-specific filters for users.",
          getSeasonPlayer:"This method retrieves a list of all players registered in a specific season. It is ideal for building features such as player rosters, performance tracking, or filtering players based on the selected season.",
          getSeasonPlayerStats:"This method provides detailed statistics for all players in a specific season. It is particularly useful for applications focused on analytics, player comparisons, or creating dynamic visualizations of season-long player achievements.",
          getGameTeamPhysicalStats:"This method retrieves physical performance statistics for teams in a specific game. It is ideal for applications analyzing team fitness levels, physical performance trends, or providing detailed breakdowns of a team's effort during a match.",
          getSeasonTeamStats:"This method provides comprehensive statistics for all teams participating in a specific season. It is particularly useful for applications focused on team analysis, season summaries, or comparisons of team performance throughout the season.",
          getSeasonCoaches:"This method retrieves a list of all coaches who managed teams during a specific season. It is particularly useful for applications that focus on season insights, coaching analysis, or tracking changes in team management over the course of a season.",
          getSeasonGames:"This method provides a list of all games played in a specific season. It is ideal for applications that need to display full season schedules, analyze game outcomes, or provide users with access to comprehensive season game data.",
          getSeasonGamesMatchday:"This method retrieves all games for a specific matchday within a given season. It is particularly useful for applications that aim to display matchday schedules, analyze specific rounds, or provide focused insights into a particular set of games during the season.",
          getSeasonLeagueTable:"This method provides the league table for a specific season, including rankings, points, wins, draws, losses, and other relevant statistics for each team. This endpoint is essential for applications focused on tracking team standings, analyzing league progression, or presenting users with up-to-date rankings throughout the season.",
          getTeamDetail:"This method provides detailed information about a specific team, including its name, foundation year, stadium, and other metadata. This endpoint is ideal for applications that require team-specific insights, enabling features like detailed team profiles, historical context, or enhanced user experiences with rich team-related data.",
          getTeamLoans:"This method retrieves information about loan transactions involving a specific team. This endpoint is particularly useful for applications focusing on transfer analysis, team roster management, or tracking player movements during a season.",
          getTeamRoster:"This method provides a complete list of players in a specific team's roster. It is ideal for applications that need to display team lineups, analyze player roles, or manage roster-related functionalities for a team.",
          getTeamGames:"This method retrieves a list of all games played by a specific team. It is particularly useful for applications that focus on team performance, schedule tracking, or providing users with access to a team's complete match history.",
          getTeamGameStats:"This method provides detailed statistics for a specific team in a given game. It is particularly useful for applications focusing on game analytics, performance evaluations, or in-depth breakdowns of a team's performance in individual matches.",
          getTeamTransfers:"This method retrieves information about transfer transactions involving a specific team. It is particularly useful for applications that focus on transfer market analysis, team roster changes, or tracking player movements over time.",
          getGameStatus:"This method provides a list of all possible game statuses available in the API, such as scheduled, in progress, completed, postponed, or canceled. This endpoint is particularly useful for applications that require real-time game tracking, filtering games by status, or providing users with clear updates on the progress or state of a match.",
          getPlayerPositions:"This method returns a list of all possible player positions, such as goalkeeper, defender, midfielder, and forward. This endpoint is particularly useful for applications that categorize players, analyze positional data, or allow users to filter players based on their roles on the field.",
          getGameDetail:"This method provides comprehensive information about a specific game, including details such as participating teams, date and time, venue, score, and other key metadata. This endpoint is ideal for applications that require in-depth game insights, enabling features like detailed match previews, reports, or analytics.",
          getGameStats:"This method provides detailed statistics for a specific game, including metrics such as goals, shots, possession percentages, passes, and defensive actions. This endpoint is particularly useful for applications focused on match analysis, post-game reports, or visualizations of team performance during a game.",
          getGamePlayerStats:"This method retrieves detailed performance statistics for all players who participated in a specific game. It is particularly useful for applications that analyze individual player performances, generate match reports, or compare players within a single game context.",
          getGamePlayerPhysicalStats:"This method provides detailed physical performance metrics for players in a specific game. It is particularly useful for applications focusing on player fitness analysis, physical performance tracking, or generating detailed game insights for individual players.",
          getGameTeamPhysicalStats:"This method provides detailed physical performance metrics for teams in a specific game. This includes data such as total distance covered, number of sprints, high-intensity runs, and other physical attributes. It is particularly useful for applications focused on team fitness analysis, comparing physical efforts between teams, or evaluating overall performance in a match.",
          getGameLineup: "This method retrieves the lineup for a specific game, including starting players, substitutes, and their respective positions. This endpoint is particularly useful for applications that display pre-match information, analyze team formations, or provide insights into tactical decisions made by teams for a given match.",
          getGameTimeline:"This method provides a chronological list of events that occurred during a specific game. It is particularly useful for applications that offer live match updates, post-match summaries, or detailed analyses of game events.",
          getGameTracking:"This method provides a link to download the tracking data file for a specific game. This file contains detailed movement and positional data for players and the ball throughout the match. It is particularly useful for applications focused on advanced analytics, tactical analysis, or creating visualizations of player and ball movements during the game.",
          getTrackingStatus: "This method returns a complete list of all states available in the tracking, providing key details such as the unique identifier and name of each state. This endpoint is ideal for applications that require match tracking, enabling features such as state selection, filtering and analysis. It also serves as a critical resource for interacting with other endpoints that depend on a `statusId` parameter, ensuring seamless navigation and integration with the API's broader data set.",
          getPlayerTransfersTypes: "This method retrieves a list of possible player transfer types, such as permanent transfer, loan, free transfer, or exchange. This endpoint is particularly useful for applications that analyze transfer market trends, categorize player movements, or provide users with detailed insights into the types of transactions involving players.",
          getPlayerDetail: "This method provides detailed information about a specific player, including personal details, career statistics, and current team affiliation. This endpoint is ideal for applications that offer player profiles, historical insights, or analytics on individual player performances and career trajectories.",
          getPlayerGames: "This method retrieves a list of all games a specific player has participated in. It is particularly useful for applications focused on player performance tracking, match history analysis, or providing users with comprehensive game logs for individual players.",
          getPlayerInjuries: "This method provides a detailed record of injuries sustained by a specific player. It is particularly useful for applications focused on player health analysis, career impact assessments, or tracking recovery timelines.",
          getPlayerNationalTeam: "This method retrieves detailed information about a player's participation in national team matches. It is particularly useful for applications focusing on player performance at the national level, tracking international careers, or providing insights into contributions during tournaments and friendlies.",
          getPlayerSeasons: "This method provides a list of all seasons in which a specific player has participated. It is particularly useful for applications that track a player's career progression, analyze performance across seasons, or provide historical context for their achievements.",
          getPlayerTransfers: "This method retrieves a detailed history of transfer transactions involving a specific player. It is particularly useful for applications focused on player career analysis, transfer market insights, or tracking the movement of players between teams over time.",
          getPlayerSeasonTeamStats: "This method provides detailed performance statistics for a specific player during a particular season with a team. It is particularly useful for applications focused on season-long player analysis, comparisons across teams or seasons, and tracking individual contributions to team success.",
          getPlayerSeasonPhysicalStats: "This method provides detailed physical performance metrics for a specific player throughout a season. It is particularly useful for applications focusing on player fitness tracking, physical performance analysis, or assessing a player's workload during a season.",
          getPlayerSeasonGamePhysicalStats: "This method provides detailed physical performance metrics for a specific player on a game-by-game basis within a season. It is particularly useful for applications focusing on game-specific fitness analysis, tracking player workload, or comparing physical performance across different matches.",
          getPlayerSeasonGameStats: "This method retrieves detailed performance statistics for a specific player on a game-by-game basis within a season. It is particularly useful for applications focusing on match-specific player analysis, performance trends, or detailed comparisons across games within a season.",
          getCoachDetail: "This method provides detailed information about a specific coach, including their name, career history, teams managed, and notable achievements. This endpoint is particularly useful for applications that highlight coaching profiles, track managerial careers, or analyze the impact of coaches on team performance.",
          getCoachHistory: "This method retrieves a comprehensive history of a specific coach's career, including the teams they have managed, competitions participated in, and their tenure durations. This endpoint is particularly useful for applications that focus on analyzing coaching careers, tracking managerial changes, or providing insights into a coach's professional journey and achievements."
        },
        responseCodes: "Response Codes",
        furtherInformation:"For further information, please read our API documentation",
        clipboard: "Copied to clipboard!",
      }
    },
    globalSearch: {
      subtitle: "Deep Filtering"
    },
    iso:{
      AF:"Afghanistan",
      DZ:"Algeria",
      AO:"Angola",
      AR:"Argentina",
      AU:"Australia",
      AZ:"Azerbaijan",
      BH:"Bahrain",
      BB:"Barbados",
      BE:"Belgium",
      BJ:"Benin",
      BO:"Bolivia",
      BW:"Botswana",
      BN:"Brunei",
      BF:"Burkina Faso",
      KH:"Cambodia",
      CA:"Canada",
      CF:"Central African Rep.",
      CL:"Chile",
      CO:"Colombia",
      CD:"Congo DR",
      CG:"Congo",
      CI:"Cote d'Ivoire",
      CU:"Cuba",
      CZ:"Czech Republic",
      DJ:"Djibouti",
      DO:"Dominican Republic",
      EC:"Ecuador",
      SV:"El Salvador",
      ER:"Eritrea",
      ET:"Ethiopia",
      FI:"Finland",
      PF:"French Polynesia",
      GM:"Gambia",
      DE:"Germany",
      GI:"Gibraltar",
      GL:"Greenland",
      GP:"Guadeloupe",
      GN:"Guinea",
      GY:"Guyana",
      HN:"Honduras",
      HU:"Hungary",
      IN:"India",
      IR:"Iran",
      IE:"Ireland",
      IT:"Italy",
      JP:"Japón",
      KZ:"Kazakhstan",
      KI:"Kiribati",
      KR:"Korea, South",
      KG:"Kyrgyzstan",
      LV:"Latvia",
      LS:"Lesotho",
      LY:"Libia",
      LT:"Lithuania",
      MO:"Macau SAR",
      MG:"Madagascar",
      MY:"Malaysia",
      ML:"Mali",
      MH:"Marshall Islands",
      MR:"Mauritania",
      MX:"Mexico",
      MD:"Moldova",
      MN:"Mongolia",
      MA:"Morocco",
      MM:"Myanmar",
      NR:"Nauru",
      NL:"Netherlands",
      NZ:"New Zealand",
      NE:"Niger",
      MP:"Northern Mariana Islands",
      OM:"Oman",
      PW:"Palau",
      PA:"Panama",
      PY:"Paraguay",
      PH:"Philippines",
      PT:"Portugal",
      QA:"Qatar",
      RO:"Romania",
      RW:"Rwanda",
      LC:"Saint Lucia",
      SM:"San Marino",
      SA:"Saudi Arabia",
      RS:"Serbia",
      SL:"Sierra Leone",
      SK:"Slovakia",
      SB:"Solomon Islands",
      ZA:"South Africa",
      LK:"Sri Lanka",
      SD:"Sudan",
      SZ:"Swaziland",
      CH:"Switzerland",
      TW:"Taiwan",
      TZ:"Tanzania",
      TG:"Togo",
      TT:"Trinidad and Tobago",
      TR:"Turkey",
      TV:"Tuvalu",
      UA:"Ukraine",
      GB:"United Kingdom",
      UY:"Uruguay",
      VU:"Vanuatu",
      VE:"Venezuela",
      VG:"Virgin Islands, British",
      EH:"Western Sahara",
      ZM:"Zambia",
      AL:"Albania",
      AD:"Andorra",
      AG:"Antigua and Barbuda",
      AM:"Armenia",
      AT:"Austria",
      BS:"Bahamas",
      BD:"Bangladesh",
      BY:"Belarus",
      BZ:"Belize",
      BT:"Bhutan",
      BA:"Bosnia and Herz.",
      BR:"Brazil",
      BG:"Bulgaria",
      BI:"Burundi",
      CM:"Cameroon",
      CV:"Cape Verde",
      TD:"Chad",
      CN:"China",
      KM:"Comoras",
      CR:"Costa Rica",
      HR:"Croatia",
      CY:"Cyprus",
      DK:"Denmark",
      DM:"Dominica",
      TL:"East Timor",
      EG:"Egypt",
      GQ:"Equatorial Guinea",
      EE:"Estonia",
      FJ:"Fiji",
      FR:"France",
      GA:"Gabon",
      GE:"Georgia",
      GH:"Ghana",
      GR:"Greece",
      GD:"Grenada",
      GT:"Guatemala",
      GW:"Guinea-Bissau",
      HT:"Haiti",
      HK:"Hong Kong SAR",
      IS:"Iceland",
      ID:"Indonesia",
      IQ:"Iraq",
      IL:"Israel",
      JM:"Jamaica",
      JO:"Jordan",
      KE:"Kenya",
      KP:"Korea, North",
      KW:"Kuwait",
      LA:"Laos",
      LB:"Lebanon",
      LR:"Liberia",
      LI:"Liechtenstein",
      LU:"Luxembourg",
      MK:"Macedonia",
      MW:"Malawi",
      MV:"Maldives",
      MT:"Malta",
      MQ:"Martinica",
      MU:"Mauritius",
      FM:"Micronesia",
      MC:"Monaco",
      ME:"Montenegro",
      MZ:"Mozambique",
      NA:"Namibia",
      NP:"Nepal",
      NC:"New Caledonia",
      NI:"Nicaragua",
      NG:"Nigeria",
      NO:"Norway",
      PK:"Pakistan",
      PS:"Palestinian Territories",
      PG:"Papua New Guinea",
      PE:"Peru",
      PL:"Poland",
      PR:"Puerto Rico",
      RE:"Reunion",
      RU:"Russian Federation",
      KN:"Saint Kitts and Nevis",
      WS:"Samoa",
      ST:"Sao Tome and Princ.",
      SN:"Senegal",
      SC:"Seychelles",
      SG:"Singapore",
      SI:"Slovenia",
      SO:"Somalia",
      ES:"Spain",
      VC:"St Vincent and Gren.",
      SR:"Suriname",
      SE:"Sweden",
      SY:"Syria",
      TJ:"Tajikistan",
      TH:"Thailandia",
      TO:"Tonga",
      TN:"Tunisia",
      TM:"Turkmenistan",
      UG:"Uganda",
      AE:"United Arab Emirates",
      US:"United States",
      UZ:"Uzbekistan",
      VA:"Vatican City",
      VN:"Vietnam",
      VI:"Virgin Islands, U.S.",
      YE:"Yemen",
      ZW:"Zimbabue",
      EU:"Europe",
      INT:"International",
      CW: "Curaçao",
      AFC:"AFC",
      CONCACAF:"CONCACAF",
      "GB-ENG":"England",
      "GB-WLS":"Wales",
      "GB-SCT":"Scotland",
      "LATAM":"South America",
      "CAF":"CAF",
      "XK":"Kosovo",
      AI: "Anguilla",
      AN: "Netherlands Antilles",
      AS: "American Samoa",
      AW: "Aruba",
      BM: "Bermuda",
      BQ: "Bonaire, SE and Saba",
      CK: "The Cook Islands",
      FO: "The Faroe Islands",
      GF: "Guyane",
      GG: "The Bailiwick of Guernsey",
      GU: "The Territory of Guam",
      IM: "The Isle of Man",
      JE: "The Bailiwick of Jersey",
      KY: "The Cayman Islands",
      MF: "The Collectivity of Saint-Martin",
      MS: "Montserrat",
      NU: "Niue",
      OC: "Oceania",
      RI: "Indonesia",
      SS: "The Republic of South Sudan",
      TC: "The Turks and Caicos Islands",
      YT: "The Department of Mayotte",
      SX: "Sint Maarten",
    },
    loadingMessages:{
      players:"Preparing Players",
      teams:"Ordering Teams",
      games:"Fetching Games",
      stats:"Calculating Metrics",
      graphs:"Drawing Graphs",
      gettingReady:"Warming Up",
      placeholder: "Get Ready"
    },
    requestReport:{
      subtitle:"Get a deep report with all you need",
      categories:{
        "scouting":{
          title:"Scouting",
          subtitle:"Who are the best players of a certain league? And from several leagues combined? Request a tailor-made report with any filter you want (age, height, contract end, etc..) and find out what players fit best"
        },
        "coaches":{
          title:"Coaches",
          subtitle:"How would a coach fit into the system of your team? Get detailed infomation or, given a certain profile, get to know which coaches fit best"
        },
        "team analysis":{
          title:"Team",
          subtitle:"Specify a team and obtain the season summary with valuable insights about style, defensive and offensive performance, weak points, best players, etc..."
        },
        "game analysis":{
          title:"Game Analysis",
          subtitle:"Given a match, get a deep pre-game and post-game analysis with detailed information"
        },
        "special projects":{
          title:"Special Projects",
          subtitle:"How does a player perform in away games? How do players change from league to league? Which players are available for loan? Ask anything you can think of"
        },
        "conversation":{
          title:"Conversation",
          subtitle:"Start a conversation with our team"
        }
      },
      notesPlaceholder: "Let us know the league, profile, stats, coach, team or game you want to know more about",
      chooseType: "Select a report type",
      requestSummary: "Request Summary",
      reportType:"Report Type",
      reportLanguage:"Report Language",
      detailTitle: "Follow-up of report",
      detailSubtitle: "All the info on the report you requested"
    },
    bugReport: {
      modalSubtitle:"Help us to improve",
      about:"About",
      sendSuccess:"Successfully notified. Check updates in the Inbox",
      bugs:"Bugs"
    },
    gbe:{
      autopass:"Auto Pass",
      bandX: "Band {0}",
      bandXCont:"Band {0} Continental Competition",
      points:"Points",
      titleWinner: "Title Winner",
      qualifiedGroupsBandX:"Qualified for group stage of a Band {0} Continental Competition",
      qualifiedQualifiersBandX:"Qualified for qualifiers of a Band {0} Continental Competition",
      midTable:"Mid-Table",
      relegation:"Relegation",
      promotion:"Promotion",
      final:"Final",
      semifinal:"Semi-Finals",
      quarterfinal:"Quarterfinals",
      round16:"Round of 16",
      round32: "Round of 32",
      groupstage:"Group Stage",
      firstRound: "1st Round",
      secondRound: "2nd Round",
      thirdRound: "3rd Round",
      fourthRound: "4th Round",
      preliminaryRound: "Preliminary Round",
      other:"Other",
      score:"Score",
      totalSummary:"Total Summary",
      currentlyPlayingInUK:"The player is a citizen of the United Kingdom or Ireland, or the player is a permanent resident in the United Kingdom",
      bandsAlert: "There are minutes played in more than one band, total is the max value",
      bandsAlertMax: "There are minutes played in more than one band, total is the max value",
      bandsAlertAvg: "There are minutes played in more than one band, total is the average value",
      generate: "GBEApplicationForm",
      debutYouthPlayer:"Debut for Youth Player",
      table1:{
        name:"Player's International Appearances",
        title1: "Aggregated FIFA World Ranking of the Player’s National Association",
        title2: "Player's International Appearances"
      },
      table2:{
        name:"Player’s Domestic Minutes",
        title1: "Player’s Domestic Minutes"
      },
      table3:{
        name:"Player’s Continental Minutes",
        title1: "Player’s Continental Minutes"
      },
      table4:{
        name:"Final League Position of Player´s Last Club",
        title1: "Last Club’s Final League Position"
      },
      table5:{
        name:"Continental Progression of Player´s Last Club",
        title1: "Continental Progression"
      },
      table6:{
        name:"League Quality of Player´s Current Club",
        title1: "Band of Player’s Current Club"
      },
      table7:{
        name:"Youth - Debut",
        title1: "Band"
      },
      table8:{
        name:"Youth - Final League Position",
        title1: "Last Club’s Final League Position"
      },
      table9:{
        name:"Youth - Continental Progression",
        title1: "Continental Progression"
      },
      table10:{
        name:"Youth - League Quality of Player´s Current",
        title1: "Band of Player’s Current Club"
      },
      table11:{
        name:"Youth - League Quality of Player´s Current",
        title1: "Band of Player’s Current Club"
      },
      table12:{
        name:"Youth - International Appearances",
        title1: "Player's International Appearances"
      }
    },
    mediaMode:{
      borderColor: "Border Color",
      fillColor:"Fill Color",
      bgColor:"Background Color",
      upperText:"Upper Text",
      lowerText:"Lower Text",
      socialMedia:"Social Media",
      textColor:"Text Color",
      axisColor:"Axis Color",
      logo:"Logo",
      comparisonBorderColor: "Comparison Border Color",
      comparisonFillColor:"Comparison Fill Color",
      comparisonUpperText:"Comparison Upper Text",
      comparisonLowerText:"Comparison Lower Text",
      homeFillColor:"Home Fill Color",
      homeBorderColor:"Home Border Color",
      awayFillColor:"Away Fill Color",
      awayBorderColor:"Away Border Color",
      face:"Face",
      nationalTeam:"National Team",
      comparisonFace:"Comparison Face",
      upperTextX:"Upper Text {0}",
      lowerTextX:"Lower Text {0}",
      borderColorX: "Border Color {0}",
      fillColorX: "Fill Color {0}",
      homeFillColorX:"Fill Color (Home) {0}",
      homeBorderColorX:"Border Color (Home) {0}",
      awayFillColorX:"Fill Color (Away) {0}",
      awayBorderColorX:"Border Color (Away) {0}",
      faceX:"Face {0}",
      selectField:"Select a property",
      orientationX:"Orientation {0}",
      searchBarPlaceholder:"Search Players and/or Games...",
      title:"Media Dashboard",
      pageSubtitle: "Explore and download maps and graphics",
      chooseChart:"Choose chart...",
      headerTextX:"Header Text {0}",
      avatarLineLength:"Avatar Line Length",
      avatarLineWeight:"Avatar Line Weight",
      avatarSize:"Avatar Size",
      chartX:"Chart {0}",
      chartHeaderFontSize:"Charts Header Font Size",
      chartHeaderFontWeight:"Charts Header Font Weight",
      upperTextFontSize: "Upper Text Font Size",
      upperTextFontWeight: "Upper Text Font Weight",
      lowerTextFontSize: "Lower Text Font Size",
      lowerTextFontWeight: "Lower Text Font Weight",
      socialMediaFontSize:"Social Media Font Size",
      socialMediaFontWeight:"Social Media Font Weight",
      subtitle:"Subtitle",
      subtitleFontSize:"Subtitle Font Size",
      subtitleFontWeight:"Subtitle Font Weight",
      subtitleX:"Subtitle {0}",
      subtitleFontSizeX:"Subtitle ${0} Font Size",
      subtitleFontWeightX:"Subtitle ${0} Font Weight",
      titleX:"Title {0}",
      titleFontSize:"Title Font Size",
      titleFontWeight:"Title Font Weight",
      sponsor:"Sponsor",
      fontFamily:"Font family"
    },
    documents:{
      types:{
        "SCOUTING_REPORT": "Scouting Reports",
        "GAME_REPORT": "Game Reports",
        "MEDICAL_REPORT": "Medical Reports",
        "PHYSICAL_REPORT": "Physical Reports",
        "PSYCHOLOGICAL_REPORT": "Psychological Reports",
        "OTHER": "Others",
        "QUICK_NOTES": "Quick Notes",
        "PLAYER_REPORT": "Player Reports",
        "GENERAL_COMMENTS": "General Comments",
        "PLAYER_ANALYSIS": "Player Analysis"
      },
      uploadDocument:"Upload Document",
      notesPlaceholder:"Type descriptive notes or comments related to the document",
      notesPlaceholderAlt:"Type descriptive notes or comments related to the player",
      uploadedBy:"Uploaded by",
      updatedBy:"Updated by",
      seeNotes:"See Notes",
      addNote:"Add Note",
      rating: "Rating",
      position: "Best position",
      physical: "Physical",
      onBall: "On Ball",
      offBall: "Off Ball",
      mental: "Mental",
      potential: "Potential",
      conclusion: "Conclusion",
      recommendation: {
        label: "Recommendation",
        1: "Sign",
        2: "Monitor",
        3: "Discard",
        4: "Interesting"
      },
      match: "Match",
      deleteQuickNote: "Delete Note",
      deleteQuickNoteMessage: "The note will be removed permanently. Are you sure?",
      noQuickNotes: "No data. Start by adding some quick notes!",
      deleteDocument: "Delete Document",
      deleteDocumentMessage: "The document will be removed permanently. Are you sure?",
      noDocuments: "No data. Start by adding some documents!",
    },
    notifications:{
      newReportMessage: "There is new message in a report"
    },
    blog:{
      subtitle:"Latest articles, updates and news",
      newEntry:"New Entry",
      title:"Title",
      text:"Text",
      link:"Link",
      image:"Image",
      author:"Author",
      date:"Release date",
      deleteEntry:"Delete Entry",
      deleteEntryMessage:"Are you sure you want to delete this entry?"
    },
    positionsOrlegi: {
      "GK":"Goalkeeper",
      "DC":"Defender",
      "DR":"Fullback",
      "MC":"Midfielder",
      "AMC":"Attacking Midfielder",
      "FW":"Forward",
      "FWR":"Winger"
    },
    library:{
      subtitle: "View and share updloaded documents",
      mediaSubtitle:"View and share exported charts",
      charts:"Charts",
      goToLibrary: "Go to library"
    },
    scatterPlot:{
      bubbleSize: "Bubble Size",
      byMinutes: "By Minutes",
      byAge:"By Age",
      byMarketValue:"By Market Value"
    },
    eventChart:{
      successfulEvent:"Successful Event",
      unsuccessfulEvent:"Unsuccessful Event",
      successfulPass:"Successful Pass",
      unsuccessfulPass:"Unsuccessful Pass",
      successfulCarry:"Successful Carry",
      unsuccessfulCarry:"Unsuccessful Carry",
      carryAndKeyPass:"Carry & Key Pass",
      carryAndAssist:"Carry & Assist",
      carryAndShot:"Carry & Shot",
      ballProgressionAndPass:"Ball Prog. & Pass",
      ballProgression:"Ball Progression",
      ballProgressionAndKeyPass:"Ball Prog. & Key Pass",
      ballProgressionAndAssist:"Ball Prog. & Assist",
      ballProgressionAndShot:"Ball Prog. & Shot",
      ballProgressionAndGoal:"Ball Prog. & Goal",
      pass:"Pass",
      carryAndPass:"Carry & Pass",
      carryAndAssist:"Carry & Assist",
      carryAndShot:"Carry & Shot",
      carryAndGoal:"Carry & Goal",
      totalTouches:"Total Touches",
      successful:"Successful",
      unsuccessful:"Unsuccessful"
    },
    event:{
      Pass: "Pass",
      TakeOn: "Dribble",
      Takeon: "Dribble",
      Foul: "Foul",
      Error: "Error",
      Tackle: "Tackle",
      Interception: "Interception",
      Clearance: "Clearance",
      MissedShot: "Missed Shot",
      ShotOnPost: "Shot on Post",
      SavedShot: "Saved Shot",
      Goal: "Goal",
      Aerial: "Aerial",
      BallRecovery: "Ball Recovery",
      Dispossessed: "Dispossessed",
      ChanceMissed: "Chance Missed",
      BallTouch: "Ball Touch",
      BlockedPass: "Blocked Pass",
      Challenge: "Challenge",
      lossPossession: "Loss of Possession",
      "Ball touch": "Ball Touch",
      "Smother": "Smother",
      "Keeper pickup": "Keeper Pickup",
      "Good skill": "Good Skill",
      "Punch": "Punch",
      "Saved shot":"Saved Shot",
      "Shot on post":"Shot on Post",
      "Missed shot":"Missed Shot",
      "Save":"Save",
      "Take on":"Take On",
      "Offside pass":"Offside Pass",
      "Claim": "Claim",
      "Blocked pass": "Blocked Pass",
    },
    leagueTab:{
      leagueTable:"League Table",
      matchdays:"Matchdays",
      playerInsights:"Player Insights",
      teamInsights:"Team Insights",
      head2head:"Head To Head",
      addNewChart:"Add new chart",
      rounds: {
        "W": "Winner",
        "F": "Final",
        "SF": "Semi-Finals",
        "QF": "Quarter-Finals",
        "16": "Round of 16",
        "32": "Round of 32",
        "GR": "Group Stage",
        "4R": "Fourth Round",
        "3R": "Third Round",
        "2R": "Second Round",
        "1R": "First Round",
        "PR": "Preliminary Round",
        "QPO1": "Make Round of 32 Tier Below",
        "QPO2": "Qualifier Round of 16",
      },
      prediction:"Predictions",
      predicted: "Prediction",
      groups:"Groups",
      ranking:"Ranking",
      positions:"Positions"
    },
    similarity:{
      subtitle:"Find similar players",
      searchBarPlaceholder:"Search and select a player to find similar",
      radarFilters:"Radar filters",
      similarityFilters:"Similarity filters",
      playersFilters:"Players filters",
      similarPlayers:"Similar Players",
      seasonWarning: "Only available seasons on Similarity tool in which he has played more than 450 minutes"
    },
    squadBuilder:{
      subtitle:"Sketch your unique elevens",
      playerSelector:"Player selector",
      loadSquad:"Load squad",
      yearsOld:"yo.",
      playersPerPosition:"Players per position",
      custom:"Custom",
      removeSquad: "Delete squad",
      removeSquadMessage: "Are you sure you want to delete the squad?",
      deleteSquadSuccess: "Squad has been deleted successfully",
      playerDetails: "Player details visibility",
      ageFormat: "Age format",
      mainPlayer: "Main player",
      showDetails: "Show details",
      all: "All",
      squadPosition: "Squad position",
      noData: "No data. Start by adding some players in the pitch!",
    },
    tours:{
      buttons: {
        dontShowAgain: "Don't Show Again",
        skipTour: "Skip Guided Tour",
        previous: "Previous",
        next: "Next",
        finish: "Finish"
      },
      playerRadar:{
        step1:{
          title: "PERSONAL FILE",
          message: "Check basic player data: age, height or contract date"
        },
        step2:{
          title: "GBE FILTER",
          message: "Functionality that allows to know if a player has enough GBE points to play in the UK"
        },
        step3:{
          title: "AVAILABILITY",
          message: "Percentage of minutes available and percentage of minutes played"
        },
        step4:{
          title: "POSITIONS",
          message: "Find out in which positions the player has played and how many minutes he has played in each position"
        },
        step5:{
          title: "DISPLAY FORMATS",
          message: "Measure the performance with 4 different visualizations, Radar, Polar, Lollipop and Text, to compare it with the players in his position"
        },
        step6:{
          title: "PERFORMANCE RADAR",
          message: "Here the performance is reflected visually. The panel is interactive, you can hover over each metric and get its definition"
        },
        step7:{
          title: "SEASON SELECTION",
          message: "Select or add seasons to measure your performance"
        },
        step8:{
          title: "CUSTOM TEMPLATE SELECTION",
          message: "Use the custom templates you have created to measure the player with different metrics than the standard radar"
        },
        step9:{
          title: "SELECTION OF POSITIONS PLAYED",
          message: "Check and uncheck the different positions to measure him in the position you want to measure him in"
        },
        step10:{
          title: "SELECTION OF MINIMA AND MAXIMA",
          message: "Measure the player with highs and lows of his season, of the top five leagues or of the own and default season of the user account"
        },
        step11:{
          title: "COMPARISONS",
          message: "Compares the player with his previous performance, with other players of his position, with the average of the position"
        },
        step12:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        }
      },
      playerRanking:{
        step1:{
          title: "SEASON, SQUAD AND POSITION",
          message: "Select the season, squad and position to compare the player with"
        },
        step2:{
          title: "BASIC FILTERS",
          message: "Filter players by age, minutes played or height"
        },
        step3:{
          title: "HIGHLIGHT AND EXCLUDE",
          message: "Highlight the players you want and exclude teams in the display"
        },
        step4:{
          title: "FILTER BY CATEGORY",
          message: "Filter statistics by category: Association, Defending, Passing, Ball Handling, etc"
        },
        step5:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        }
      },
      playerFinishing:{
        step1:{
          title: "SELECT DISPLAY",
          message: "You can see the finishing map in main view, goal view and in a distribution table"
        },
        step2:{
          title: "SELECT SEASONS",
          message: "Add seasons to measure your shooting efficiency"
        },
        step3:{
          title: "SHOOTING LOCATION",
          message: "Select the possibility to see the exact location of the shot (circles) or by areas of the box and the pitch (areas)"
        },
        step4:{
          title: "xG ON TARGET",
          message: "Check the boxes for xG to Goal and xG Completion to see what added value the player added after the shot"
        },
        step5:{
          title: "SHOT TYPE",
          message: "Filter by shot type, strategy, area or body part"
        },
        step6:{
          title: "FILTER MINUTES",
          message: "Minutes bar to select shots and goals scored by specific game periods"
        },
        step7:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        },
        step8:{
          title: "SHOOTING MAP",
          message: "The map is interactive. Check each circle with the mouse to find out xG for each shot"
        }
      },
      playerKeyPass:{
        step1:{
          title: "SEASON SELECTION",
          message: "Add seasons to measure your shooting efficiency"
        },
        step2:{
          title: "KEY PASS LOCATION",
          message: "Select the possibility to view the exact location of the key pass (circle) or by areas of the area and the field (areas)"
        },
        step3:{
          title: "TYPE OF FINISH AFTER KEY PASS",
          message: "Filter by type of shot, strategy, area or body part made after key pass"
        },
        step4:{
          title: "FILTER MINUTES",
          message: "Minutes bar to select shots and goals scored by specific game periods"
        },
        step5:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        },
        step6:{
          title: "KEY PASS MAP",
          message: "The map is interactive. Consult each circle with the mouse to know xA of each pass"
        }
      },
      playerThreat:{
        step1:{
          title: "SEASON SELECTION",
          message: "Add seasons to measure your shooting efficiency"
        },
        step2:{
          title: "THREAT LOCATION",
          message: "Select the possibility to view exact location of the key pass (circle) or by area and field zones (areas)"
        },
        step3:{
          title: "ACTION AND COMPLETION",
          message: "Check and uncheck according to the type of action and completion you want to display on the map"
        },
        step4:{
          title: "MINUTES AND THREAT",
          message: "Filter by period, by minutes and by threat value of the actions"
        },
        step5:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        },
        step6:{
          title: "THREAT MAP",
          message: "The map is interactive. Consult each circle with the mouse to find out the threat generated in each xT play of each pass"
        }
      },
      playerTouches:{
        step1:{
          title: "GAME AND EVENT SELECTION",
          message: "Select the game and events you want to display on the map"
        },
        step2:{
          title: "EVENT TYPE",
          message: "Check and uncheck according to the defensive or offensive nature of the player's event throughout the game"
        },
        step3:{
          title: "DISPLAY FILTER",
          message: "Filter map by basic actions, heat map, circles or boxes"
        },
        step4:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        },
        step5:{
          title: "TOUCHES MAP",
          message: "The map is interactive. You can view each event by clicking on each event"
        }
      },
      playerAllGames:{
        step1:{
          title: "AVAILABILITY",
          message: "Check availability and minutes played on a game by game basis"
        },
        step2:{
          title: "POSITIONS",
          message: "Consult the positions in which he has played in each game"
        }
      },
      playerInjuries:{
        step1:{
          title: "HISTORY AND DAYS LOST",
          message: "Consult injuries of the last year or the whole history and range of injuries according to their duration in days"
        },
        step2:{
          title: "INJURIES BY CLUB",
          message: "Consult the injuries separated by season and/or club of his trajectory"
        }
      },
      playerInfo:{
        step1:{
          title: "CAREER AND TRANSFERS",
          message: "You can consult minutes, position or availability history with his club, with his national team and the player's transfers throughout his career"
        }
      },
      teamOverview:{
        step1:{
          title: "TEAM SHEET",
          message: "Consult basic data of the team: average age, base formation, ELO or balance of transfers"
        },
        step2:{
          title: "BASIC STATISTICS",
          message: "Consult possession, xG, Shots, PPDA or Verticality"
        },
        step3:{
          title: "RADAR AND SEASON",
          message: "Select radar, season and home or away games to measure the team's performance"
        },
        step4:{
          title: "FILTER BY COACH AND MATCHES",
          message: "Select performance by stage for each coach"
        },
        step5:{
          title: "PERFOMANCE RADAR",
          message: "The panel is interactive, you can hover over each metric and get its definition"
        },
        step6:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Two download formats are available: png and svg"
        },
        step7:{
          title: "CALENDAR",
          message: "View the team's match schedule"
        },
        step8:{
          title: "BEST PLAYERS BY METRICS",
          message: "In this panel you can select different metrics and see which players are the most important ones"
        },
        step9:{
          title: "NEXT MATCH AND INJURIES",
          message: "Check the next opponent and the team's injured and suspended players"
        },
        step10:{
          title: "GRAPHS AND TRENDS",
          message: "View different graphs for the last 10 or 20 games"
        }
      },
      teamRoster:{
        step1:{
          title: "VIEW TYPE",
          message: "View the squad from 6 different categories: by position, end of contract, age, availability, age profile and pitch"
        }
      },
      teamLoans:{
        step1:{
          title: "LOAN PLAYERS",
          message: "Consult the players loaned to other teams and what position they play in"
        }
      },
      teamBeeswarm:{
        step1:{
          title: "SEASON AND SQUAD",
          message: "Filter by season, radar squad and compare with leagues of your choice"
        },
        step2:{
          title: "PERFORMANCE BY METRICS",
          message: "See where the team is in each metric compared to all the teams in the leagues previously selected"
        },
        step3:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        }
      },
      teamFinishingMap:{
        step1:{
          title: "SEASON SELECTION",
          message: "Add seasons to measure shooting efficiency"
        },
        step2:{
          title: "OWN OR OPPONENT'S FINISHING",
          message: "Choose whether you want to see the team's or all its opponents' completion map"
        },
        step3:{
          title: "SHOT PLACEMENT",
          message: "Select how you want to see the team's shots, by circles or by zones (boxes)"
        },
        step4:{
          title: "SHOT TYPE",
          message: "Filter by type of shot, strategy, area or body part"
        },
        step5:{
          title: "FILTER MINUTES",
          message: "Minutes bar to select shots and goals scored by specific match periods"
        },
        step6:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        },
        step7:{
          title: "SHOTS MAP",
          message: "The map is interactive. Check each circle with the mouse to find out xG of each shot"
        },
      },
      teamKeyPassMap:{
        step1:{
          title: "SEASON SELECTION",
          message: "Add seasons to measure shooting efficiency"
        },
        step2:{
          title: "OWN OR RIVAL KEY PASSES",
          message: "Choose if you want to see a map of key passes of the team or all its rivals"
        },
        step3:{
          title: "KEY PASS LOCATION",
          message: "Select whether you want to see the exact location of the key pass (circle) or by area and field (boxes)"
        },
        step4:{
          title: "TYPE OF FINISH AFTER PASS",
          message: "Filter by type of shot, strategy, area or body part made after key pass"
        },
        step5:{
          title: "FILTER MINUTES",
          message: "Minutes bar to select shots and goals scored by specific match periods"
        },
        step6:{
          title: "IMAGE DOWNLOAD FORMATS",
          message: "Three download formats are available: png, svg and embed"
        },
        step7:{
          title: "SHOTS MAP",
          message: "The map is interactive. Consult each circle with the mouse to know the xA of each pass"
        },
      },
      teamLatestGames:{
        step1:{
          title: "LATEST GAMES",
          message: "Consult results, possession, xG and win % of all the team's matches"
        }
      },
      teamTransfers:{
        step1:{
          title: "ARRIVALS",
          message: "Consult all arrivals (purchases + transfers) per calendar year"
        },
        step2:{
          title: "DEPARTURES",
          message: "Consult all departures (sales + transfers) by calendar year"
        }
      },
      teamAnalysis:{
        step1:{
          title: "TRENDS",
          message: "Query team form through streaks, wins, clean sheets, comebacks, periods with goals or types of goals"
        },
        step2:{
          title: "SET PIECE",
          message: "Compare Performance of the Team beetween Set Pieces Plays and Open Plays and get a detailed overview of Set Pieces"
        },
        step3:{
          title: "SUBSTITUTIONS",
          message: "See when the team makes substitutions and which players are substituted the most"
        },
        step4:{
          title: "CONNECTIONS",
          message: "Consult the most common connections between players. Filter by season and type of play"
        },
        step5:{
          title: "ATTACK ZONES",
          message: "Discover attacking zones of the team and filter by season or type of attack"
        },
        step6:{
          title: "FORMATIONS",
          message: "Check the most used formations and their % of wins, draws and defeats with each of them"
        },
        step7:{
          title: "SHOT ZONES",
          message: "Filter by season, team or opponent, way of visualizing the map, shot types or minutes"
        },
        step8:{
          title: "CROSSINGS",
          message: "Query and filter by season, type of display, successful or unsuccessful, from where they start and finish or including corner kicks"
        },
        step9:{
          title: "PLAYERS",
          message: "Filter by season, type of display, successful or unsuccessful, from where they start and finish or including corner kicks"
        }
      },
      teamOnOff:{
        step1:{
          title: "SEASONS AND MATCHES",
          message: "Filter by season, matches or by home or away games"
        },
        step2:{
          title: "PLAYERS",
          message: "View the performance of all players in the squad through countless metrics"
        }
      }
    },
    alerts:{
      numPlayers:"Number of players",
      newPlayersLastWeek:"New players last week",
      subtitle: "Get alerts when new players meet your search criteria",
      generalSubtitle: "Receive alerts on new players based on your criteria and news on your favourite players",
      subtitlePlayer: "Get alerts when we have news about your favorite players",
      subtitleSearch: "Get alerts when new players meet your search criteria",
      favorite: "Favorite",
      newEventCalendar: "New Event",
      updatedEventCalendar: "Updated Event",
      newShareFrom: "New share from",
      injuryAlert: "Injury Alert",
      contractAlert: "Contract Alert",
      teamAlert: "Signing Alert",
      marketValueAlert: "Market Value Alert",
      gameAlert: "Game Played Alert",
    },
    videoEvents:{
      highlights:"Highlights",
      fullGame:"Full game",
      autoplay:"Autoplay",
      searchBarPlaceholder:"Search player, game or team...",
      subtitle:"Analyze events through video",
      successful:"Success",
      unsuccessful:"Fail",
      playing:"Playing",
      games:"Games",
      moreFilters:"More filters...",
      startArea:"Start area",
      endArea:"End area",
      select:"Select",
      selectLastXGames: "Select last {0} games",
      advancedFilters: "Advanced Filters",
      freeKicks:"Free Kicks",
      cornerKicks:"Corner Kicks",
      allShots:"All Shots",
      generateZip:"Download Videos",
      zippedModalMessage:"We're now creating your video list and will send it to your email shortly",
      clickToSeeVideo:"Click to see video"
    },
    videoUpload:{
      subtitle: "Upload video and create new game",
      uploadVideo: "Upload video",
      selectPeriod: "Select period",
      gameData: "Game Data",
      venue:"Venue",
      matchType: "Match type",
      matchGroup: "Match group",
      roundType: "Round type",
      roundNumber: "Round number",
      offsetFh:"Offset First Half",
      offsetSh:"Offset Second Half",
      offsetFhOT:"Offset Overtime First Half",
      offsetShOT:"Offset Overtime Second Half",
      homeLineup: "Home Lineup",
      awayLineup: "Away Lineup",
      existingPlayer: "Existing player",
      newPlayer: "New player",
      startingTeam:"Starting",
      saveAndUpload:"Save and upload",
      existingGame: "Game exists already",
      sendToKora:"Send",
      invalidForm:"Invalid form",
      warningModalTitle:"Anomalies have been detected",
      noScoreSheetWarning:"No scoresheet attached",
      onlyOnePartUploadedWarning: "Only one half time attached",
      continueQuestion: "continue?",
      slaLimit: "You have uploaded {0} games with {1}. Your limit is {2}",
      requestedGames: "Requested games",
      limitClose: "Only {0} games left to request",
      limitReached: "You've reached your video upload limit. Uploading additional games may result in extra charges.",
      seasonFinishedWarning: "This will create a match in a season that has already ended. Please check that this is correct.",
      teamCountryWarning: "This team is from a different country to the one chosen league. Please check that this is correct.",
    },
    videoPlaylists:{
      subtitle: "Collections of video highlights filters",
      savePlaylist: "Save Playlist",
      seeAllPlaylists: "See all playlists",
    },
    videoHighlights: {
      recap:"Recap",
      homeCondensed:"Home Condensed Game",
      awayCondensed:"Away Condensed Game",
      selectedActions: "Selected actions",
      noActions: "No actions matching the specified filter criteria",
      noGames: "No games uploaded yet",
      attackingActions: "Attacking Actions",
      defensiveActions: "Defensive Actions",
      groundDuels: "Ground Duels",
      penaltiesProvoked: "Penalties Provoked",
      goalkeeperActions: "Goalkeeper Actions",
      addSomeGames: "Start by adding some games!",
      goToVideoUploadTool: "Go to Video Upload Tool",
      qualifiers: {
        "Pass": "Pass",
        "Save": "Save",
        "Saved Shot": "Saved Shot",
        "Shot": "Shot",
        "Goal": "Goal",
        "Missed Shot": "Missed Shot",
        "Shot on Post": "Shot on Post",
        "Error": "Error",
        "Clearance": "Clearance",
        "Aerial": "Aerial",
        "Challenge": "Ground Duel Lost",
        "Dispossessed": "Dispossessed",
        "Foul": "Foul",
        "Card": "Card",
        "Offside Pass": "Offside Pass",
        "Claim": "Cross Claimed",
        "Keeper Pickup": "Keeper Pickup",
        "Ball Touch": "Ball Touch",
        "Dribble": "Dribble",
        "Interception": "Interception",
        "Tackle": "Tackle",
        "Ball Recovery": "Ball Recovery"
      },
      qualifierIds: {
        "1": "Long ball",
        "2": "Cross",
        "5": "Free kick taken",
        "6": "Corner taken",
        "9": "Penalty",
        "15": "Head",
        "20": "Right footed",
        "21": "Other body part",
        "22": "Regular play",
        "23": "Fast break",
        "24": "Set piece",
        "25": "From corner",
        "26": "Free kick",
        "28": "Own goal",
        "29": "Assisted",
        "31": "Yellow card",
        "32": "Second yellow card",
        "33": "Red card",
        "72": "Left footed",
        "73": "Left",
        "82": "Saved shot (no GK)",
        "94": "Def block",
        "123": "Keeper throw",
        "124": "Goal kick",
        "160": "Throw-in set piece",
        "170": "Leading to goal",
        "173": "Parried safe",
        "174": "Parried danger",
        "177": "Collected",
        "178": "Standing",
        "179": "Diving",
        "182": "Hands",
        "183": "Feet",
        "185": "Blocked cross",
        "210": "Assist",
        "215": "Individual play",
        "279": "Kick off",
        "285": "Defensive",
        "286": "Offensive"
      },
      areas: {
        goalArea: "Goal Area",
        boxLeft: "Box Left",
        boxCenter: "Box Center",
        boxRight: "Box Right",
        outBoxDeepLeft: "Out of Box Deep Left",
        outBoxDeepRight: "Out of Box Deep Right",
        outBoxLeft: "Out of Box Left",
        outBoxCentreLeft: "Out of Box Centre Left",
        outBoxCentre: "Out of Box Centre",
        outBoxCentreRight: "Out of Box Centre Right",
        outBoxRight: "Out of Box Right",
        midfieldLeft35: "Midfield Left",
        midfieldCentreLeft35: "Midfield Centre Left",
        midfieldCentre35: "Midfield Centre",
        midfieldCentreRight35: "Midfield Centre Right",
        midfieldRight35: "Midfield Right",
        ownGoalArea: "Own Goal Area",
        ownBoxLeft: "Own Box Left",
        ownBoxCenter: "Own Box Center",
        ownBoxRight: "Own Box Right",
        ownFieldOutOfBoxDeepLeft: "Own Field Out of Box Deep Left",
        ownFieldOutOfBoxDeepRight: "Own Field Out of Box Deep Right",
        ownFieldOutOfBoxLeft: "Own Field Out of Box Left",
        ownFieldOutOfBoxCentreLeft: "Own Field Out of Box Centre Left",
        ownFieldOutOfBoxCentre: "Own Field Out of Box Centre",
        ownFieldOutOfBoxCentreRight: "Own Field Out of Box Centre Right",
        ownFieldOutOfBoxRight: "Own Field Out of Box Right"
      },
      outcomes: {
        success: "Success",
        fail: "Fail",
        possessionWon: "Possession Won",
        possessionNotWon: "Possession Not Won",
        received: "Received",
        provoked: "Provoked"
      }
    },
    share:{
      shareTo:"Send to",
      viaApp: "App (Driblab Message)",
      viaEmail: "Email",
      description: "Description",
      titleTab: "Shares",
      toMe:"Received",
      fromMe:"Sent",
      typeInternal:"Internal",
      typeExternal:"External",
      title: "Shared",
      subtitle: "Overview of the items in your share list and your shares",
      selectUser: "Select user",
      expired:"Expired",
      limitReached:"Link reached the uses limit"
    },
    homeStats: {
      data: "Available Data",
      players: "players",
      totalPlayers: "total players",
      teams: "teams",
      totalTeams: "total teams",
      leagues: "leagues",
      totalLeagues: "total leagues",
      seasons: "seasons",
      totalSeasons: "total seasons",
      games: "games",
      totalGames: "total games"
    },
    scoutingCalendar: {
      subtitle: "Create and organise your scouting tasks",
      myCalendars: "Private calendar",
      publicCalendars: "Public calendars",
      otherCalendars: "Other calendars",
      calendarSettings: "Calendar settings",
      moreInfo: "More info",
      individualScouting: "Individual Scouting",
      matchScouting: "Match Scouting",
      calendarView: {
        type: "Calendar type",
        month: "Month",
        week: "Week",
        day: "Day"
      },
      weekView: {
        type: "Week Type",
        monSun: "Monday - Sunday",
        sunSat: "Sunday - Saturday",
        monFri: "Monday - Friday"
      },
      tasks: {
        addNew: "Add new task",
        myTasks: "My tasks",
        filterTasks: "Filter tasks",
        sharedWithMe: "Shared with me",
        createTask: "Create task",
        newTask: "New task",
        taskName: "Task name",
        allDay: "All day",
        startDate: "Start date",
        endDate: "End date",
        startHour: "Start hour",
        endHour: "End hour",
        assignedTo: "Assignee",
        assignedToMe: "Assigned to me",
        color: "Color",
        scoutingType: "Scouting type",
        taskLocation: "Task location",
        selectLeague: "Select league",
        selectMatch: "Select match",
        useMatchdate: "Use matchdate as date",
        stadium: "Stadium",
        travel: "Travel",
        hotel: "Hotel",
        tickets: "Tickets",
        taskNotes: "Type descriptive notes or comments related to the task",
        states: {
          toDo: "To do",
          inProgress: "In progress",
          done: "Done"
        },
        type: {
          player: "Player Assessment",
          team: "Team Assessment",
          other: "Other"
        },
        location: {
          stadium: "In stadium",
          video: "Video"
        },
        accommodation: {
          accommodationDetails: "Accommodation Details",
          ownArrangement: "Own Arrangement",
          required: "Required",
          notRequired: "Not required",
          booked: "Booked"
        },
        assignToMe: "Assign to me",
        addOther: "Add other",
        deleteTask: "Delete task",
        deleteTaskMessage: "Task will be removed, are you sure?",
        cancelUpdate: "Cancel update",
        cancelUpdateMessage: "Changes will not be saved, are you sure?",
        selectGame: "Please, select a match to add files",
        noData: "No data. Start by adding some tasks!",
        widgetSubtitle: "Check out your next tasks",
        scoutingDetails: "Scouting details",
        taskDetails: "Task details",
        playerDocuments: "Player documents",
        teamDocuments: "Team documents",
        gameDocuments: "Game documents",
        taskDocuments: "Task documents",
        task: "Task",
      },
      nextGames: "Next games",
    },
    scoutingTasksBoard: {
      period: {
        week: "This week",
        month: "This month",
        year: "This year",
      },
      noTasks: "Create new tasks or drag one here!",
      goToBoard: "Go to board"
    },
    profile: {
      title: "Profile",
      subtitle: "Customize your account and subscription details"
    },
    hub: {
      onlyHub: "Only available in Driblab Hub"
    },
    uploadedGames: {
      subtitle: "All uploaded games",
      timeRequested:"Time it was requested",
      timeReceived:"When it was received",
      diffHours:"Difference in hours",
      collectionCompleted: "Collection completed",
      dateFrom:"Date from",
      dateTo:"Date to",
      goToUploadedGames: "Go To Uploaded Games",
      sla: "Server Level Agreement",
      matchDate: "Match Date",
      rejectedGame: "Rejected"
    },
    gameMap: {
      title: "Map of Games",
      subtitle: "Explore the matches for the next days",
      warning: "The time and place may not be correct. Please confirm this information.",
      taskAdded: "Task successfully created. Check the Scouting Calendar."
    },
    leagueRequestAccess: {
      sendSuccess: "Successfully notified",
      notPermissions: "You do not have permissions to see",
      notPermissionsLeague: "You do not have permissions to see this league",
      notPermissionsGame: "You do not have permissions to see this game",
      requestAccessTo: "Request access to",
      sendRequest: "Send Request",
    },
    videoTeams: {
      subtitle: "Find the latest matches tagged by team",
      noGamesUploaded: "No games uploaded yet"
    },
    scoutingAnalysis: {
      scoutingAnalysis: "Scouting Analysis",
      scoutingAnalyses: "Scouting Analyses",
      analyses: "Analyses",
      addReport: "Add analysis",
      technical: "Technical",
      tactical: "Tactical",
      physical: "Physical",
      mental: "Mental",
      technicalNotes: "Technical notes",
      tacticalNotes: "Tactical notes",
      physicalNotes: "Physical notes",
      mentalNotes: "Mental notes",
      conclusion: "Conclusion",
      charactersMax: "Max 1000 characters",
      globalRating: "Global rating",
      noData: "No data. Start by adding some scouting analyses!",
      deleteAnalysis: "Delete Scouting Analysis",
      deleteAnalysisMessage: "The analysis will be removed permanently. Are you sure?",
      avgTooltip: "Average based on final ratings of analyses visible to you",
      avgOverallScoreTooltip: "Average based on player's overall scores visible to you",
      scouter: "Scout",
      lastEdited: "Last edited",
      analysisFilters: "Analysis Filters",
      generalFilters: "General Filters",
      widgetSubtitle: "Latest analyses added",
      addPlayerReport: "Add Player Scouting Analysis",
      seeReports: "See reports"
    },
    addPlayerForm: {
      noLeague: "Creating a team without league can have a negative effect on its indexing and subsequent search within the application."
    },
    expenses: {
      expense: "Expense",
      expenses: "Expenses",
      addExpense: "Add expense",
      transportation: "Transportation",
      accommodation: "Accommodation",
      dietary: "Dietary",
      eventTicket: "Event ticket",
      expenseType: "Expense type",
      amount: "Amount",
      expenseDate: "Expense date",
      expenseFilters: "Expense filters",
      noData: "No data. Start by adding some expenses!",
      deleteExpense: "Delete Expense",
      deleteExpenseMessage: "The expense will be removed permanently. Are you sure?",
    },
    disabledTooltips: {
      general: "This feature is currently disabled",
      youth: "It must be youth to set an age",
      unit: "Stat must be Runs, HSR or SPR",
      seasonsWithout60MinsGames: "Player hasn't played more than 60 minutes in a single match in the selected season(s)",
      notEditable: "This cannot be edited",
      noMatchdate: "Matchdate unavailable",
      selectGame: "Select a game first",
      selectPlayer: "Select a player first",
      selectTeam: "Select a team first",
      selectBoxes: "Boxes visualization must be selected",
      selectYear: "Select a year first",
      pdScoreNotAvailable: "Score not available because player has not played 60 minutes in a match",
    },
    leagueTypes: {
      regular: "Regular",
      continental: "Continental",
      nationalTeam: "National Team",
      countryCup: "Country Cup",
      qualifier: "Qualifier",
      playOff: "Play-Off",
      regionalLeague: "Regional League",
      friendly: "Friendly",
      nationalFriendly: "National Friendly",
      nationaQualifier: "National Qualifier",
    }

  }



// WEBPACK FOOTER //
// ./src/utils/translations/en.js